
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1NG86", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14fb0c25a04918aa$var$_react = $14fb0c25a04918aa$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $14fb0c25a04918aa$var$_statusError = $14fb0c25a04918aa$var$_interopRequireDefault((parcelRequire("80DPg")));

var $14fb0c25a04918aa$var$_error = $14fb0c25a04918aa$var$_interopRequireDefault((parcelRequire("duLdC")));
function $14fb0c25a04918aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14fb0c25a04918aa$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $14fb0c25a04918aa$var$_react.default.createElement($14fb0c25a04918aa$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $14fb0c25a04918aa$var$_error.default
    }, props));
$14fb0c25a04918aa$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $14fb0c25a04918aa$var$_default = module.exports.default = $14fb0c25a04918aa$var$StatusErrorIcon;

});
parcelRegister("80DPg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d4d37611030f40f$var$_react = $5d4d37611030f40f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5d4d37611030f40f$var$_baseNew = $5d4d37611030f40f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5d4d37611030f40f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d4d37611030f40f$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $5d4d37611030f40f$var$_react.default.createElement($5d4d37611030f40f$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$5d4d37611030f40f$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $5d4d37611030f40f$var$_default = module.exports.default = $5d4d37611030f40f$var$StatusErrorIcon;

});
parcelRegister("fGWXz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("5EfQi")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("5EfQi")).Icon);

var $5EfQi = parcelRequire("5EfQi");

});
parcelRegister("5EfQi", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $fd4370b52e481e5d$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $fd4370b52e481e5d$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
const $fd4370b52e481e5d$var$svgStyles = null;
const $fd4370b52e481e5d$var$iconStyles = null;
const $fd4370b52e481e5d$var$utilityIconStyles = null;
const $fd4370b52e481e5d$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ const $fd4370b52e481e5d$var$baseHcmStyles = null;
const $fd4370b52e481e5d$var$scaleSize = null;
const $fd4370b52e481e5d$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $fd4370b52e481e5d$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $fd4370b52e481e5d$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $fd4370b52e481e5d$var$baseSizeMap = {
    core: 16,
    utility: 12
};
const $fd4370b52e481e5d$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
const $fd4370b52e481e5d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eJOHy.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, LEGACY_primaryColor: LEGACY_primaryColor, LEGACY_secondaryColor: LEGACY_secondaryColor, LEGACY_size: LEGACY_size, LEGACY_fallbackIcon: FallbackIcon, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, LEGACY_margin: LEGACY_margin, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $eGOwo.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ (0, $gt9Am.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor ?? color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        // @ts-ignore -next-line
        UNSAFE_margin: LEGACY_margin
    });
    const type = props.type ?? 'core';
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = $fd4370b52e481e5d$var$baseSizeMap[type];
    const viewBoxPadding = $fd4370b52e481e5d$var$paddingMap[type][size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $hcewu.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va18uv _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            fill: "none",
            // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
            // we want for Icon Tile
            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, $hcewu.default)([
                "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
                shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $fd4370b52e481e5d$var$utilSizes[spacing] : size === 'small' ? $fd4370b52e481e5d$var$coreSizeSmall[spacing] : $fd4370b52e481e5d$var$coreSizeMedium[spacing]
            ])
        })
    });
});
var $fd4370b52e481e5d$export$2e2bcd8739ae039 = $fd4370b52e481e5d$export$f04a61298a47a40f;

});



parcelRegister("duLdC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d32b456360462f2$var$_react = $9d32b456360462f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $9d32b456360462f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d32b456360462f2$var$ErrorIcon = (props)=>/*#__PURE__*/ $9d32b456360462f2$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$9d32b456360462f2$var$ErrorIcon.displayName = 'ErrorIcon';
var $9d32b456360462f2$var$_default = module.exports.default = $9d32b456360462f2$var$ErrorIcon;

});
parcelRegister("fL0In", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $9c8825587cdd277c$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $9c8825587cdd277c$export$2e2bcd8739ae039);
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9c8825587cdd277c$var$iconStyles = null;
const $9c8825587cdd277c$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ const $9c8825587cdd277c$var$baseHcmStyles = null;
const $9c8825587cdd277c$var$primaryEqualsSecondaryHcmStyles = null;
const $9c8825587cdd277c$var$secondaryTransparentHcmStyles = null;
const $9c8825587cdd277c$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eJOHy.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ (0, $gt9Am.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi3acm",
            size && $9c8825587cdd277c$var$sizeStyles[size]
        ])
    });
});
var $9c8825587cdd277c$export$2e2bcd8739ae039 = $9c8825587cdd277c$export$f04a61298a47a40f;

});



parcelRegister("jhvt8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e09803f0b63f79e8$var$_react = $e09803f0b63f79e8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e09803f0b63f79e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e09803f0b63f79e8$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $e09803f0b63f79e8$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$e09803f0b63f79e8$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $e09803f0b63f79e8$var$_default = module.exports.default = $e09803f0b63f79e8$var$CheckCircleIcon;

});

parcelRegister("laG04", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f69b1c85c221b021$var$_react = $f69b1c85c221b021$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $f69b1c85c221b021$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f69b1c85c221b021$var$CrossIcon = (props)=>/*#__PURE__*/ $f69b1c85c221b021$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$f69b1c85c221b021$var$CrossIcon.displayName = 'CrossIcon';
var $f69b1c85c221b021$var$_default = module.exports.default = $f69b1c85c221b021$var$CrossIcon;

});

parcelRegister("lD65a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbf1f553812fd223$var$_react = $fbf1f553812fd223$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $fbf1f553812fd223$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fbf1f553812fd223$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $fbf1f553812fd223$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props));
$fbf1f553812fd223$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $fbf1f553812fd223$var$_default = module.exports.default = $fbf1f553812fd223$var$HipchatChevronDownIcon;

});

parcelRegister("bIwqN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $887cf5eb32fca9c1$var$_react = $887cf5eb32fca9c1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $887cf5eb32fca9c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $887cf5eb32fca9c1$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $887cf5eb32fca9c1$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props));
$887cf5eb32fca9c1$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $887cf5eb32fca9c1$var$_default = module.exports.default = $887cf5eb32fca9c1$var$HipchatChevronUpIcon;

});

parcelRegister("cDDv2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9337c45fc79b4cef$var$_react = $9337c45fc79b4cef$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $9337c45fc79b4cef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9337c45fc79b4cef$var$InfoIcon = (props)=>/*#__PURE__*/ $9337c45fc79b4cef$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props));
$9337c45fc79b4cef$var$InfoIcon.displayName = 'InfoIcon';
var $9337c45fc79b4cef$var$_default = module.exports.default = $9337c45fc79b4cef$var$InfoIcon;

});

parcelRegister("60rxg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45f81a1eceec346f$var$_react = $45f81a1eceec346f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $45f81a1eceec346f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $45f81a1eceec346f$var$WarningIcon = (props)=>/*#__PURE__*/ $45f81a1eceec346f$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$45f81a1eceec346f$var$WarningIcon.displayName = 'WarningIcon';
var $45f81a1eceec346f$var$_default = module.exports.default = $45f81a1eceec346f$var$WarningIcon;

});

parcelRegister("3TFuO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f966e8890debb57eaf4e6f167681f98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d66b264855bf964$var$_react = $2d66b264855bf964$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2d66b264855bf964$var$_statusSuccess = $2d66b264855bf964$var$_interopRequireDefault((parcelRequire("3wl9L")));

var $2d66b264855bf964$var$_checkCircle = $2d66b264855bf964$var$_interopRequireDefault((parcelRequire("jhvt8")));
function $2d66b264855bf964$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2d66b264855bf964$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $2d66b264855bf964$var$_react.default.createElement($2d66b264855bf964$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $2d66b264855bf964$var$_checkCircle.default
    }, props));
$2d66b264855bf964$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $2d66b264855bf964$var$_default = module.exports.default = $2d66b264855bf964$var$StatusSuccessIcon;

});
parcelRegister("3wl9L", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2904c57bca5b7ee6$var$_react = $2904c57bca5b7ee6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2904c57bca5b7ee6$var$_baseNew = $2904c57bca5b7ee6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $2904c57bca5b7ee6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2904c57bca5b7ee6$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $2904c57bca5b7ee6$var$_react.default.createElement($2904c57bca5b7ee6$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$2904c57bca5b7ee6$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $2904c57bca5b7ee6$var$_default = module.exports.default = $2904c57bca5b7ee6$var$StatusSuccessIcon;

});


parcelRegister("6BxzS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::119fcb233ad7d2568bcc63888dfec4d2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4cf03e9d095bf914$var$_react = $4cf03e9d095bf914$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4cf03e9d095bf914$var$_chevronDown = $4cf03e9d095bf914$var$_interopRequireDefault((parcelRequire("1OQKp")));

var $4cf03e9d095bf914$var$_chevronDown2 = $4cf03e9d095bf914$var$_interopRequireDefault((parcelRequire("lD65a")));
function $4cf03e9d095bf914$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4cf03e9d095bf914$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $4cf03e9d095bf914$var$_react.default.createElement($4cf03e9d095bf914$var$_chevronDown.default, Object.assign({
        name: "ChevronDownIcon",
        LEGACY_fallbackIcon: $4cf03e9d095bf914$var$_chevronDown2.default
    }, props));
$4cf03e9d095bf914$var$ChevronDownIcon.displayName = 'ChevronDownIconMigration';
var $4cf03e9d095bf914$var$_default = module.exports.default = $4cf03e9d095bf914$var$ChevronDownIcon;

});
parcelRegister("1OQKp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $15336089c392d834$var$_react = $15336089c392d834$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $15336089c392d834$var$_baseNew = $15336089c392d834$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $15336089c392d834$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $15336089c392d834$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $15336089c392d834$var$_react.default.createElement($15336089c392d834$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$15336089c392d834$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $15336089c392d834$var$_default = module.exports.default = $15336089c392d834$var$ChevronDownIcon;

});


parcelRegister("jAF24", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9122dabf5a4e80a209ec2f5b7da6e804>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e43135504faba839$var$_react = $e43135504faba839$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e43135504faba839$var$_chevronUp = $e43135504faba839$var$_interopRequireDefault((parcelRequire("1vA1E")));

var $e43135504faba839$var$_chevronUp2 = $e43135504faba839$var$_interopRequireDefault((parcelRequire("bIwqN")));
function $e43135504faba839$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e43135504faba839$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $e43135504faba839$var$_react.default.createElement($e43135504faba839$var$_chevronUp.default, Object.assign({
        name: "ChevronUpIcon",
        LEGACY_fallbackIcon: $e43135504faba839$var$_chevronUp2.default
    }, props));
$e43135504faba839$var$ChevronUpIcon.displayName = 'ChevronUpIconMigration';
var $e43135504faba839$var$_default = module.exports.default = $e43135504faba839$var$ChevronUpIcon;

});
parcelRegister("1vA1E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6f832dcdc2d7a1f91afd5e9b90e10b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1194a1a6fd519924$var$_react = $1194a1a6fd519924$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1194a1a6fd519924$var$_baseNew = $1194a1a6fd519924$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $1194a1a6fd519924$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1194a1a6fd519924$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $1194a1a6fd519924$var$_react.default.createElement($1194a1a6fd519924$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$1194a1a6fd519924$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $1194a1a6fd519924$var$_default = module.exports.default = $1194a1a6fd519924$var$ChevronUpIcon;

});


parcelRegister("i4Iw4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::750ecc162e36259ef90344888c589176>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d28b21b3ccdf3130$var$_react = $d28b21b3ccdf3130$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d28b21b3ccdf3130$var$_statusInformation = $d28b21b3ccdf3130$var$_interopRequireDefault((parcelRequire("2R0ne")));

var $d28b21b3ccdf3130$var$_info = $d28b21b3ccdf3130$var$_interopRequireDefault((parcelRequire("cDDv2")));
function $d28b21b3ccdf3130$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d28b21b3ccdf3130$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $d28b21b3ccdf3130$var$_react.default.createElement($d28b21b3ccdf3130$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $d28b21b3ccdf3130$var$_info.default
    }, props));
$d28b21b3ccdf3130$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $d28b21b3ccdf3130$var$_default = module.exports.default = $d28b21b3ccdf3130$var$StatusInformationIcon;

});
parcelRegister("2R0ne", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2140d232e8b0a187$var$_react = $2140d232e8b0a187$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2140d232e8b0a187$var$_baseNew = $2140d232e8b0a187$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $2140d232e8b0a187$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2140d232e8b0a187$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $2140d232e8b0a187$var$_react.default.createElement($2140d232e8b0a187$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$2140d232e8b0a187$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $2140d232e8b0a187$var$_default = module.exports.default = $2140d232e8b0a187$var$StatusInformationIcon;

});


parcelRegister("jkYbX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e13e9370299759dc$var$_react = $e13e9370299759dc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e13e9370299759dc$var$_statusWarning = $e13e9370299759dc$var$_interopRequireDefault((parcelRequire("d8UFE")));

var $e13e9370299759dc$var$_warning = $e13e9370299759dc$var$_interopRequireDefault((parcelRequire("60rxg")));
function $e13e9370299759dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e13e9370299759dc$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $e13e9370299759dc$var$_react.default.createElement($e13e9370299759dc$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $e13e9370299759dc$var$_warning.default
    }, props));
$e13e9370299759dc$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $e13e9370299759dc$var$_default = module.exports.default = $e13e9370299759dc$var$StatusWarningIcon;

});
parcelRegister("d8UFE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9917fb5de79cb2d0$var$_react = $9917fb5de79cb2d0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9917fb5de79cb2d0$var$_baseNew = $9917fb5de79cb2d0$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9917fb5de79cb2d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9917fb5de79cb2d0$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $9917fb5de79cb2d0$var$_react.default.createElement($9917fb5de79cb2d0$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$9917fb5de79cb2d0$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $9917fb5de79cb2d0$var$_default = module.exports.default = $9917fb5de79cb2d0$var$StatusWarningIcon;

});


parcelRegister("6J9k6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c17176afeb2169f76dc501092efdf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e5e2d758ad941bc$var$_react = $4e5e2d758ad941bc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4e5e2d758ad941bc$var$_cross = $4e5e2d758ad941bc$var$_interopRequireDefault((parcelRequire("6zhpo")));

var $4e5e2d758ad941bc$var$_cross2 = $4e5e2d758ad941bc$var$_interopRequireDefault((parcelRequire("laG04")));
function $4e5e2d758ad941bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e5e2d758ad941bc$var$CrossIcon = (props)=>/*#__PURE__*/ $4e5e2d758ad941bc$var$_react.default.createElement($4e5e2d758ad941bc$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $4e5e2d758ad941bc$var$_cross2.default
    }, props));
$4e5e2d758ad941bc$var$CrossIcon.displayName = 'CrossIconMigration';
var $4e5e2d758ad941bc$var$_default = module.exports.default = $4e5e2d758ad941bc$var$CrossIcon;

});
parcelRegister("6zhpo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c8383eacf797672$var$_react = $4c8383eacf797672$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4c8383eacf797672$var$_baseNew = $4c8383eacf797672$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $4c8383eacf797672$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c8383eacf797672$var$CrossIcon = (props)=>/*#__PURE__*/ $4c8383eacf797672$var$_react.default.createElement($4c8383eacf797672$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$4c8383eacf797672$var$CrossIcon.displayName = 'CrossIcon';
var $4c8383eacf797672$var$_default = module.exports.default = $4c8383eacf797672$var$CrossIcon;

});


parcelRegister("eUaD0", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => (parcelRequire("7hRz2")).ELEMENTS_CONTEXT);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => (parcelRequire("7hRz2")).FabricElementsAnalyticsContext);
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => (parcelRequire("btPrf")).NAVIGATION_CONTEXT);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("btPrf")).NavigationAnalyticsContext);
$parcel$export(module.exports, "EDITOR_CONTEXT", () => (parcelRequire("457Jo")).EDITOR_CONTEXT);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => (parcelRequire("457Jo")).FabricEditorAnalyticsContext);
$parcel$export(module.exports, "MEDIA_CONTEXT", () => $5bf02ef989474068$export$70df29c238ba7306);
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => (parcelRequire("5MVYz")).PEOPLE_TEAMS_CONTEXT);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => (parcelRequire("5MVYz")).PeopleTeamsAnalyticsContext);
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => (parcelRequire("2j1be")).NOTIFICATIONS_CONTEXT);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => (parcelRequire("2j1be")).NotificationsAnalyticsContext);
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => (parcelRequire("3Vyd5")).RECENT_WORK_CONTEXT);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => (parcelRequire("3Vyd5")).RecentWorkAnalyticsContext);
$parcel$export(module.exports, "ATLAS_CONTEXT", () => (parcelRequire("hc6VA")).ATLAS_CONTEXT);
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => (parcelRequire("77Y0z")).TOWNSQUARE_HOME_CONTEXT);
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => (parcelRequire("afpzL")).LINKING_PLATFORM_CONTEXT);
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => (parcelRequire("jxC8l")).POST_OFFICE_CONTEXT);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => (parcelRequire("jxC8l")).PostOfficeAnalyticsContext);
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => (parcelRequire("jj0ut")).AI_MATE_CONTEXT);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => (parcelRequire("jj0ut")).AIMateAnalyticsContext);
$parcel$export(module.exports, "AVP_CONTEXT", () => (parcelRequire("bPP8D")).AVP_CONTEXT);
$parcel$export(module.exports, "GROWTH_CONTEXT", () => (parcelRequire("7J1FZ")).GROWTH_CONTEXT);
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => (parcelRequire("5gOQP")).OMNI_CHANNEL_CONTEXT);
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => (parcelRequire("dBFv4")).ROVO_EXTENSION_CONTEXT);

var $7hRz2 = parcelRequire("7hRz2");

var $btPrf = parcelRequire("btPrf");

var $457Jo = parcelRequire("457Jo");


var $5MVYz = parcelRequire("5MVYz");

var $2j1be = parcelRequire("2j1be");

var $3Vyd5 = parcelRequire("3Vyd5");

var $hc6VA = parcelRequire("hc6VA");

var $77Y0z = parcelRequire("77Y0z");

var $afpzL = parcelRequire("afpzL");

var $jxC8l = parcelRequire("jxC8l");

var $jj0ut = parcelRequire("jj0ut");

var $bPP8D = parcelRequire("bPP8D");

var $7J1FZ = parcelRequire("7J1FZ");

var $5gOQP = parcelRequire("5gOQP");

var $dBFv4 = parcelRequire("dBFv4");

});
parcelRegister("7hRz2", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $1014084fd5947e59$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $1014084fd5947e59$export$3fe25500478a635c);

var $hzaKR = parcelRequire("hzaKR");
const $1014084fd5947e59$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $1014084fd5947e59$export$3fe25500478a635c = (0, $hzaKR.default)($1014084fd5947e59$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});
parcelRegister("hzaKR", function(module, exports) {
$parcel$export(module.exports, "default", () => $6708324a2f3c0fa6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");
const $6708324a2f3c0fa6$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: newData,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.only(props.children)
        });
    };
    Component.displayName = displayName;
    return Component;
};
var $6708324a2f3c0fa6$export$2e2bcd8739ae039 = $6708324a2f3c0fa6$var$createNamespaceContext;

});
parcelRegister("e2B2h", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e3d4b5a0edd21bf$export$2e2bcd8739ae039);

var $csmow = parcelRequire("csmow");
var $8e3d4b5a0edd21bf$export$2e2bcd8739ae039 = (0, $csmow.default);

});
parcelRegister("csmow", function(module, exports) {
$parcel$export(module.exports, "default", () => $02130629cbd8410c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2UVxZ = parcelRequire("2UVxZ");

var $49e07 = parcelRequire("49e07");

var $gAkni = parcelRequire("gAkni");
const $02130629cbd8410c$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $gAkni.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $49e07.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $eJOHy.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $eJOHy.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2UVxZ.default).Provider, {
        value: value,
        children: children
    });
};
var $02130629cbd8410c$export$2e2bcd8739ae039 = $02130629cbd8410c$var$AnalyticsContext;

});
parcelRegister("2UVxZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $21fd7369ccaf3539$export$2e2bcd8739ae039);

var $gWekL = parcelRequire("gWekL");
var $21fd7369ccaf3539$export$2e2bcd8739ae039 = (0, $gWekL.default);

});
parcelRegister("gWekL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c54d2e8815121eda$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
var $c54d2e8815121eda$var$AnalyticsNextContext = (0, $eJOHy.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $c54d2e8815121eda$export$2e2bcd8739ae039 = $c54d2e8815121eda$var$AnalyticsNextContext;

});


parcelRegister("49e07", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $194aca0b1baa8b4a$export$d1f587f82ad51c4);

var $eJOHy = parcelRequire("eJOHy");

var $2UVxZ = parcelRequire("2UVxZ");
const $194aca0b1baa8b4a$export$d1f587f82ad51c4 = ()=>{
    return (0, $eJOHy.useContext)((0, $2UVxZ.default));
};

});

parcelRegister("gAkni", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $067bd834c5686dc7$export$1d27a74659855e44);

var $eJOHy = parcelRequire("eJOHy");
const $067bd834c5686dc7$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
};

});





parcelRegister("btPrf", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $284ed9171c88f80a$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $284ed9171c88f80a$export$d0a82da1a0b94929);

var $hzaKR = parcelRequire("hzaKR");
const $284ed9171c88f80a$export$1fd3aad76a7c6788 = 'navigationCtx';
const $284ed9171c88f80a$export$d0a82da1a0b94929 = (0, $hzaKR.default)($284ed9171c88f80a$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("457Jo", function(module, exports) {
$parcel$export(module.exports, "EDITOR_CONTEXT", () => $af19ced53fb0932c$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $af19ced53fb0932c$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $af19ced53fb0932c$export$629cada6c5e621e1);

var $hzaKR = parcelRequire("hzaKR");
const $af19ced53fb0932c$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $af19ced53fb0932c$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $af19ced53fb0932c$export$629cada6c5e621e1 = (0, $hzaKR.default)($af19ced53fb0932c$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $5bf02ef989474068$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

parcelRegister("5MVYz", function(module, exports) {
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $a0fbbed399652067$export$b326383bee6cb993);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => $a0fbbed399652067$export$4119ddb38ccbfb87);

var $hzaKR = parcelRequire("hzaKR");
const $a0fbbed399652067$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $a0fbbed399652067$export$4119ddb38ccbfb87 = (0, $hzaKR.default)($a0fbbed399652067$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("2j1be", function(module, exports) {
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $fad3bb14b236479f$export$da1befb791e93c7e);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => $fad3bb14b236479f$export$6f8e7ff1e3feafd7);

var $hzaKR = parcelRequire("hzaKR");
const $fad3bb14b236479f$export$da1befb791e93c7e = 'NotificationsCtx';
const $fad3bb14b236479f$export$6f8e7ff1e3feafd7 = (0, $hzaKR.default)($fad3bb14b236479f$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("3Vyd5", function(module, exports) {
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $87fb40adaa1a9ca0$export$fc7a65795610cb71);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => $87fb40adaa1a9ca0$export$745926731087ebe2);

var $hzaKR = parcelRequire("hzaKR");
const $87fb40adaa1a9ca0$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $87fb40adaa1a9ca0$export$745926731087ebe2 = (0, $hzaKR.default)($87fb40adaa1a9ca0$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("hc6VA", function(module, exports) {
$parcel$export(module.exports, "ATLAS_CONTEXT", () => $89d422d8a905a099$export$4906017439f33fc0);

var $hzaKR = parcelRequire("hzaKR");
const $89d422d8a905a099$export$4906017439f33fc0 = 'atlasCtx';
const $89d422d8a905a099$export$43ebbe41370d4543 = (0, $hzaKR.default)($89d422d8a905a099$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("77Y0z", function(module, exports) {
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => $ce1e1cbd930bc988$export$aa18ab4fff926c9e);

var $hzaKR = parcelRequire("hzaKR");
const $ce1e1cbd930bc988$export$aa18ab4fff926c9e = 'townsquareHomeCtx';
const $ce1e1cbd930bc988$export$d283110f5d85c8f2 = (0, $hzaKR.default)($ce1e1cbd930bc988$export$aa18ab4fff926c9e, 'TownsquareHomeAnalyticsContext');

});

parcelRegister("afpzL", function(module, exports) {
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $e42f81e94dc1253d$export$3240443bf2b83834);

var $hzaKR = parcelRequire("hzaKR");
const $e42f81e94dc1253d$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $e42f81e94dc1253d$export$6d568da622ce0a08 = (0, $hzaKR.default)($e42f81e94dc1253d$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("jxC8l", function(module, exports) {
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $4f4effdab98c544c$export$ef0c05448f0f8f9);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => $4f4effdab98c544c$export$dcd232f3be312f94);

var $hzaKR = parcelRequire("hzaKR");
const $4f4effdab98c544c$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $4f4effdab98c544c$export$dcd232f3be312f94 = (0, $hzaKR.default)($4f4effdab98c544c$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("jj0ut", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $5f48110889b86192$export$5c3a6fd8b96e8b66);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => $5f48110889b86192$export$de3826c30468da26);

var $hzaKR = parcelRequire("hzaKR");
const $5f48110889b86192$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $5f48110889b86192$export$de3826c30468da26 = (0, $hzaKR.default)($5f48110889b86192$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});

parcelRegister("bPP8D", function(module, exports) {
$parcel$export(module.exports, "AVP_CONTEXT", () => $43eb417a79a498bc$export$c2a811a4e42f4af5);

var $hzaKR = parcelRequire("hzaKR");
const $43eb417a79a498bc$export$c2a811a4e42f4af5 = 'avpCtx';
const $43eb417a79a498bc$export$da383e8879a25b03 = (0, $hzaKR.default)($43eb417a79a498bc$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});

parcelRegister("7J1FZ", function(module, exports) {
$parcel$export(module.exports, "GROWTH_CONTEXT", () => $9c8da9aeac794093$export$82023f2f4bfb06c1);

var $hzaKR = parcelRequire("hzaKR");
const $9c8da9aeac794093$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $9c8da9aeac794093$export$84980182680018f = (0, $hzaKR.default)($9c8da9aeac794093$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});

parcelRegister("5gOQP", function(module, exports) {
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => $ed89232b896350b9$export$6d3c48fd1b3e4f3b);

var $hzaKR = parcelRequire("hzaKR");
const $ed89232b896350b9$export$6d3c48fd1b3e4f3b = 'omniChannelCtx';
const $ed89232b896350b9$export$e4e6df99270bbbb1 = (0, $hzaKR.default)($ed89232b896350b9$export$6d3c48fd1b3e4f3b, 'OmniChannelAnalyticsContext');

});

parcelRegister("dBFv4", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => $d2c0fab62b9d6ab7$export$fae437eb1dd9520c);

var $hzaKR = parcelRequire("hzaKR");
const $d2c0fab62b9d6ab7$export$fae437eb1dd9520c = 'rovoExtensionCtx';
const $d2c0fab62b9d6ab7$export$7fcecc25ee38fbef = (0, $hzaKR.default)($d2c0fab62b9d6ab7$export$fae437eb1dd9520c, 'RovoExtensionAnalyticsContext');

});


parcelRegister("3VCQy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("fIowa")).default);
$parcel$export(module.exports, "LOG_LEVEL", () => (parcelRequire("65d8G")).LOG_LEVEL);
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("bgewf")).FabricChannel);

var $fIowa = parcelRequire("fIowa");

var $65d8G = parcelRequire("65d8G");

var $bgewf = parcelRequire("bgewf");

});
parcelRegister("fIowa", function(module, exports) {
$parcel$export(module.exports, "default", () => $462f7a840ce4b6d1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $dvLOo = parcelRequire("dvLOo");

var $jy5dr = parcelRequire("jy5dr");

var $65d8G = parcelRequire("65d8G");

var $bKP0b = parcelRequire("bKP0b");

var $8XsBl = parcelRequire("8XsBl");

var $aB7gd = parcelRequire("aB7gd");

var $29OhD = parcelRequire("29OhD");

var $3R41p = parcelRequire("3R41p");

var $i5hVX = parcelRequire("i5hVX");

var $9UiMr = parcelRequire("9UiMr");

var $iTkry = parcelRequire("iTkry");

var $4IkeC = parcelRequire("4IkeC");

var $29r8A = parcelRequire("29r8A");

var $4uQD9 = parcelRequire("4uQD9");

var $lQZFV = parcelRequire("lQZFV");

var $hkzcN = parcelRequire("hkzcN");

var $3HZO0 = parcelRequire("3HZO0");

var $eroM1 = parcelRequire("eroM1");

var $kusYb = parcelRequire("kusYb");
const $462f7a840ce4b6d1$var$listenerMap = {
    [(0, $bgewf.FabricChannel).elements]: (0, $dvLOo.default),
    [(0, $bgewf.FabricChannel).editor]: (0, $8XsBl.default),
    [(0, $bgewf.FabricChannel).atlaskit]: (0, $jy5dr.default),
    [(0, $bgewf.FabricChannel).navigation]: (0, $bKP0b.default),
    [(0, $bgewf.FabricChannel).media]: (0, $aB7gd.default),
    [(0, $bgewf.FabricChannel).peopleTeams]: (0, $29OhD.default),
    [(0, $bgewf.FabricChannel).notifications]: (0, $3R41p.default),
    [(0, $bgewf.FabricChannel).recentWork]: (0, $i5hVX.default),
    [(0, $bgewf.FabricChannel).atlas]: (0, $9UiMr.default),
    [(0, $bgewf.FabricChannel).crossFlow]: (0, $iTkry.default),
    [(0, $bgewf.FabricChannel).linkingPlatform]: (0, $4IkeC.default),
    [(0, $bgewf.FabricChannel).postOffice]: (0, $29r8A.default),
    [(0, $bgewf.FabricChannel).aiMate]: (0, $4uQD9.default),
    [(0, $bgewf.FabricChannel).avp]: (0, $lQZFV.default),
    [(0, $bgewf.FabricChannel).growth]: (0, $hkzcN.default),
    [(0, $bgewf.FabricChannel).omniChannel]: (0, $3HZO0.default),
    [(0, $bgewf.FabricChannel).townsquareHome]: (0, $eroM1.default),
    [(0, $bgewf.FabricChannel).rovoExtension]: (0, $kusYb.default)
};
class $462f7a840ce4b6d1$var$FabricAnalyticsListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.logger = new (0, $65d8G.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        const { client: client, children: children, logLevel: logLevel, excludedChannels: excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys($462f7a840ce4b6d1$var$listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>$462f7a840ce4b6d1$var$listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Listener, {
                client: client,
                logger: this.logger,
                children: prev
            }), children);
        return listeners;
    }
}
var $462f7a840ce4b6d1$export$2e2bcd8739ae039 = $462f7a840ce4b6d1$var$FabricAnalyticsListeners;

});
parcelRegister("bgewf", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => $1eaf8f81bbefc654$export$8faa0b115ef0268b);
var $1eaf8f81bbefc654$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    FabricChannel["rovoExtension"] = "rovoExtension";
    return FabricChannel;
}({});

});

parcelRegister("dvLOo", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_TAG", () => $22870fe540e17a23$export$ed71ae78997933a);
$parcel$export(module.exports, "default", () => $22870fe540e17a23$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8QoO2 = parcelRequire("8QoO2");

var $bgewf = parcelRequire("bgewf");

var $24wjQ = parcelRequire("24wjQ");
const $22870fe540e17a23$export$ed71ae78997933a = 'fabricElements';
class $22870fe540e17a23$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8QoO2.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $bgewf.FabricChannel).elements,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $24wjQ.handleEvent)(event, $22870fe540e17a23$export$ed71ae78997933a, this.props.logger, this.props.client);
        };
    }
}

});
parcelRegister("8QoO2", function(module, exports) {
$parcel$export(module.exports, "default", () => $801a65a6e03320e1$export$2e2bcd8739ae039);

var $5oh1g = parcelRequire("5oh1g");
var $801a65a6e03320e1$export$2e2bcd8739ae039 = (0, $5oh1g.default);

});
parcelRegister("5oh1g", function(module, exports) {
$parcel$export(module.exports, "default", () => $550d8031e5926a81$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2UVxZ = parcelRequire("2UVxZ");

var $49e07 = parcelRequire("49e07");

var $gAkni = parcelRequire("gAkni");
const $550d8031e5926a81$var$AnalyticsListener = ({ children: children, channel: channel, onEvent: onEvent })=>{
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = ()=>[], getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext } = (0, $49e07.useAnalyticsContext)();
    const onEventRef = (0, $gAkni.useTrackedRef)(onEvent);
    const channelRef = (0, $gAkni.useTrackedRef)(channel);
    const getAnalyticsEventHandlers = (0, $eJOHy.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler,
            ...getAtlaskitAnalyticsEventHandlers()
        ];
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    const value = (0, $eJOHy.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2UVxZ.default).Provider, {
        value: value,
        children: children
    });
};
var $550d8031e5926a81$export$2e2bcd8739ae039 = $550d8031e5926a81$var$AnalyticsListener;

});


parcelRegister("24wjQ", function(module, exports) {
$parcel$export(module.exports, "handleEvent", () => $c9abbb13be1d9746$export$d6e5ca10785815df);

var $6IHxX = parcelRequire("6IHxX");

var $4tRzn = parcelRequire("4tRzn");
const $c9abbb13be1d9746$export$d6e5ca10785815df = (event, // If passing through multiple tags, the primary tag should be first in the array.
// The primary tag is used for matching context.
tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $4tRzn.processEventPayload)(event, tags);
    (0, $6IHxX.sendEvent)(logger, client)(payload);
};

});
parcelRegister("6IHxX", function(module, exports) {
$parcel$export(module.exports, "sendEvent", () => $56cdf3044715fac8$export$7329bcdc3edcd90e);
const $56cdf3044715fac8$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $56cdf3044715fac8$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const { eventType: eventType, ...gasEvent } = event;
            const withClient = (cb)=>{
                if ($56cdf3044715fac8$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});

parcelRegister("4tRzn", function(module, exports) {
$parcel$export(module.exports, "processEventPayload", () => $a854ade6c7986ac9$export$c37d638b7f2ca192);

parcelRequire("eUaD0");
var $457Jo = parcelRequire("457Jo");
var $7hRz2 = parcelRequire("7hRz2");

var $1O6Yz = parcelRequire("1O6Yz");

var $dvLOo = parcelRequire("dvLOo");

var $8XsBl = parcelRequire("8XsBl");
const $a854ade6c7986ac9$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, item), {});
const $a854ade6c7986ac9$var$fieldExtractor = (contextKey)=>$a854ade6c7986ac9$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const $a854ade6c7986ac9$var$getContextKey = (tag)=>{
    switch(tag){
        case 0, $dvLOo.ELEMENTS_TAG:
            return 0, $7hRz2.ELEMENTS_CONTEXT;
        case 0, $8XsBl.EDITOR_TAG:
            return 0, $457Jo.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const $a854ade6c7986ac9$var$updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return {
        source: (0, $d6f34b7bd34f6138$export$b055de0e665cb20c),
        ...event.payload
    };
    const contextKey = $a854ade6c7986ac9$var$getContextKey(primaryTag) || 'attributes';
    const { [contextKey]: attributes, ...fields } = $a854ade6c7986ac9$var$fieldExtractor(contextKey)(event.context);
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(attributes, event.payload.attributes || {});
    return {
        source: (0, $d6f34b7bd34f6138$export$b055de0e665cb20c),
        ...fields,
        ...event.payload
    };
};
const $a854ade6c7986ac9$var$addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $a854ade6c7986ac9$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const $a854ade6c7986ac9$export$c37d638b7f2ca192 = (event, tags)=>{
    const primaryTag = $a854ade6c7986ac9$var$getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return {
        ...$a854ade6c7986ac9$var$updatePayloadWithContext(primaryTag, event),
        tags: $a854ade6c7986ac9$var$addTags(tagsArray, event.payload.tags)
    };
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $d6f34b7bd34f6138$export$a1562d08625f5d7e = 'ui';
const $d6f34b7bd34f6138$export$947dac6c72b26f81 = 'track';
const $d6f34b7bd34f6138$export$f1d537d508d2945a = 'screen';
const $d6f34b7bd34f6138$export$12346a674644c156 = 'operational';
const $d6f34b7bd34f6138$export$b055de0e665cb20c = 'unknown';

parcelRegister("8XsBl", function(module, exports) {
$parcel$export(module.exports, "EDITOR_TAG", () => $80ae93c5cbe88ac1$export$a1d9dc589a29b3aa);
$parcel$export(module.exports, "default", () => $80ae93c5cbe88ac1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8QoO2 = parcelRequire("8QoO2");

var $bgewf = parcelRequire("bgewf");

var $24wjQ = parcelRequire("24wjQ");
const $80ae93c5cbe88ac1$export$a1d9dc589a29b3aa = 'editor';
const $80ae93c5cbe88ac1$export$8aa0d788f94a809 = 'fabricEditor';
class $80ae93c5cbe88ac1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8QoO2.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $bgewf.FabricChannel).editor,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $24wjQ.handleEvent)(event, [
                $80ae93c5cbe88ac1$export$a1d9dc589a29b3aa,
                $80ae93c5cbe88ac1$export$8aa0d788f94a809
            ], this.props.logger, this.props.client);
        };
    }
}

});




parcelRegister("jy5dr", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1d1a9736fcf8396$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $2T8hQ = parcelRequire("2T8hQ");

var $3NQSG = parcelRequire("3NQSG");
function $c1d1a9736fcf8396$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).atlaskit,
        processEvent: (0, $2T8hQ.default)
    });
}

});
parcelRegister("2T8hQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f71942fd8da86940$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");


var $hCvNd = parcelRequire("hCvNd");
const $f71942fd8da86940$var$ATLASKIT_TAG = 'atlaskit';
const $f71942fd8da86940$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $f71942fd8da86940$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $hCvNd.getSources)(event);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = (0, $hCvNd.getExtraAttributes)(event);
    const components = (0, $hCvNd.getComponents)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $hCvNd.getPackageInfo)(event)) || {};
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $f71942fd8da86940$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $hCvNd.getPackageHierarchy)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($f71942fd8da86940$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $hCvNd.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $d6f34b7bd34f6138$export$947dac6c72b26f81) || eventType === (0, $d6f34b7bd34f6138$export$12346a674644c156) || eventType === (0, $d6f34b7bd34f6138$export$f1d537d508d2945a)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

});
parcelRegister("hCvNd", function(module, exports) {
$parcel$export(module.exports, "extractFromEventContext", () => $3754ce04b58ae17c$export$9b947b4502cd2705);
$parcel$export(module.exports, "getActionSubject", () => $3754ce04b58ae17c$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getSources", () => $3754ce04b58ae17c$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $3754ce04b58ae17c$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $3754ce04b58ae17c$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $3754ce04b58ae17c$export$cd17d76da7967240);
$parcel$export(module.exports, "getPackageHierarchy", () => $3754ce04b58ae17c$export$4e0b83da1896ebc7);
/**
 * Largely taken from analytics-web-react
 */ 
var $1O6Yz = parcelRequire("1O6Yz");
const $3754ce04b58ae17c$export$9b947b4502cd2705 = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);
const $3754ce04b58ae17c$export$6f40cdf6d42c018d = (event)=>{
    const overrides = $3754ce04b58ae17c$export$9b947b4502cd2705('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};
const $3754ce04b58ae17c$export$5f9bc633b116660f = (event)=>$3754ce04b58ae17c$export$9b947b4502cd2705('source', event);
const $3754ce04b58ae17c$export$4e811121b221213b = (event)=>$3754ce04b58ae17c$export$9b947b4502cd2705('component', event);
const $3754ce04b58ae17c$export$67c3590839ebecdd = (event)=>$3754ce04b58ae17c$export$9b947b4502cd2705('attributes', event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, extraAttributes), {});
const $3754ce04b58ae17c$export$cd17d76da7967240 = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $3754ce04b58ae17c$export$18cd124b5098d330 = (event)=>$3754ce04b58ae17c$export$9b947b4502cd2705('packageVersion', event);
function $3754ce04b58ae17c$export$4e0b83da1896ebc7(event) {
    const packages = $3754ce04b58ae17c$export$cd17d76da7967240(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}

});


parcelRegister("3NQSG", function(module, exports) {
$parcel$export(module.exports, "default", () => $550788bd3f06d6b9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8QoO2 = parcelRequire("8QoO2");

var $6IHxX = parcelRequire("6IHxX");
class $550788bd3f06d6b9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8QoO2.default), {
            onEvent: this.listenerHandler,
            channel: this.props.channel,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.listenerHandler = (event)=>{
            const { client: client, logger: logger, channel: channel, processEvent: processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, $6IHxX.sendEvent)(logger, client)(payload);
        };
    }
}

});


parcelRegister("65d8G", function(module, exports) {
$parcel$export(module.exports, "LOG_LEVEL", () => $8370c8880a8a40e9$export$ffe0c436e29512cf);
$parcel$export(module.exports, "default", () => $8370c8880a8a40e9$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $8370c8880a8a40e9$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $8370c8880a8a40e9$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $8370c8880a8a40e9$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $8370c8880a8a40e9$export$ffe0c436e29512cf.DEBUG && logLevel <= $8370c8880a8a40e9$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $8370c8880a8a40e9$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage($8370c8880a8a40e9$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($8370c8880a8a40e9$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($8370c8880a8a40e9$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($8370c8880a8a40e9$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});

parcelRegister("bKP0b", function(module, exports) {
$parcel$export(module.exports, "default", () => $3297ad0a4f77ecd5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $lfPQ0 = parcelRequire("lfPQ0");

var $3NQSG = parcelRequire("3NQSG");
function $3297ad0a4f77ecd5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).navigation,
        processEvent: (0, $lfPQ0.default)
    });
}

});
parcelRegister("lfPQ0", function(module, exports) {
$parcel$export(module.exports, "default", () => $f06c02d33efb610e$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("eUaD0");
var $btPrf = parcelRequire("btPrf");

var $lSCHZ = parcelRequire("lSCHZ");
const $f06c02d33efb610e$var$NAVIGATION_TAG = 'navigation';
const $f06c02d33efb610e$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $f06c02d33efb610e$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lSCHZ.getSources)(event, (0, $btPrf.NAVIGATION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = (0, $lSCHZ.getExtraAttributes)(event, (0, $btPrf.NAVIGATION_CONTEXT));
    const components = (0, $lSCHZ.getComponents)(event, (0, $btPrf.NAVIGATION_CONTEXT));
    const packages = (0, $lSCHZ.getPackageInfo)(event, (0, $btPrf.NAVIGATION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $lSCHZ.getPackageInfo)(event, (0, $btPrf.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $f06c02d33efb610e$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($f06c02d33efb610e$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("lSCHZ", function(module, exports) {
$parcel$export(module.exports, "getSources", () => $eedce3040caa2563$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $eedce3040caa2563$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $eedce3040caa2563$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $eedce3040caa2563$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ 
var $1O6Yz = parcelRequire("1O6Yz");
const $eedce3040caa2563$var$extractFromEventContext = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);
const $eedce3040caa2563$export$5f9bc633b116660f = (event, contextName)=>$eedce3040caa2563$var$extractFromEventContext([
        'source'
    ], event, false, contextName);
const $eedce3040caa2563$export$4e811121b221213b = (event, contextName)=>$eedce3040caa2563$var$extractFromEventContext([
        'component',
        'componentName'
    ], event, false, contextName);
const $eedce3040caa2563$export$67c3590839ebecdd = (event, contextName)=>$eedce3040caa2563$var$extractFromEventContext([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, extraAttributes), {});
const $eedce3040caa2563$export$cd17d76da7967240 = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);
const $eedce3040caa2563$export$18cd124b5098d330 = (event, contextName)=>$eedce3040caa2563$var$extractFromEventContext([
        'packageVersion'
    ], event, true, contextName);

});



parcelRegister("aB7gd", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b0559f6d57c13de$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $fYckt = parcelRequire("fYckt");

var $3NQSG = parcelRequire("3NQSG");
function $3b0559f6d57c13de$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).media,
        processEvent: (0, $fYckt.processEvent)
    });
}

});
parcelRegister("fYckt", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $4dada978f41e2e77$export$22af68e3614bf024);

parcelRequire("eUaD0");

var $1O6Yz = parcelRequire("1O6Yz");

var $1ilzu = parcelRequire("1ilzu");

var $hCvNd = parcelRequire("hCvNd");
const $4dada978f41e2e77$var$listenerVersion = "0.0.0-use.local";
function $4dada978f41e2e77$var$getMediaContexts(event) {
    return (0, $hCvNd.extractFromEventContext)((0, $5bf02ef989474068$export$70df29c238ba7306), event);
}
function $4dada978f41e2e77$var$getMediaRegion() {
    try {
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $4dada978f41e2e77$export$22af68e3614bf024(event) {
    const sources = (0, $hCvNd.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $hCvNd.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $hCvNd.getExtraAttributes)(event);
    const mediaContexts = $4dada978f41e2e77$var$getMediaContexts(event) || [];
    const mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, $hCvNd.getComponents)(event);
    const mediaRegion = $4dada978f41e2e77$var$getMediaRegion();
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, extraAttributes, mediaAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $hCvNd.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $4dada978f41e2e77$var$listenerVersion,
            ...mediaRegion ? {
                mediaRegion: mediaRegion
            } : undefined
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});


parcelRegister("29OhD", function(module, exports) {
$parcel$export(module.exports, "default", () => $62830ed7e62d98a2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $7JVz6 = parcelRequire("7JVz6");

var $3NQSG = parcelRequire("3NQSG");
function $62830ed7e62d98a2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).peopleTeams,
        processEvent: (0, $7JVz6.default)
    });
}

});
parcelRegister("7JVz6", function(module, exports) {
$parcel$export(module.exports, "default", () => $12a754f4f0e51532$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("eUaD0");
var $5MVYz = parcelRequire("5MVYz");

var $lSCHZ = parcelRequire("lSCHZ");
const $12a754f4f0e51532$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
const $12a754f4f0e51532$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $12a754f4f0e51532$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lSCHZ.getSources)(event, (0, $5MVYz.PEOPLE_TEAMS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = (0, $lSCHZ.getExtraAttributes)(event, (0, $5MVYz.PEOPLE_TEAMS_CONTEXT));
    const components = (0, $lSCHZ.getComponents)(event, (0, $5MVYz.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, $lSCHZ.getPackageInfo)(event, (0, $5MVYz.PEOPLE_TEAMS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $lSCHZ.getPackageInfo)(event, (0, $5MVYz.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $12a754f4f0e51532$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($12a754f4f0e51532$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("3R41p", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2f823ce5d122e89$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $g59eT = parcelRequire("g59eT");

var $3NQSG = parcelRequire("3NQSG");
function $d2f823ce5d122e89$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).notifications,
        processEvent: (0, $g59eT.default)
    });
}

});
parcelRegister("g59eT", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ce94ecfa2e5e8fa$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");


var $lSCHZ = parcelRequire("lSCHZ");
parcelRequire("eUaD0");
var $2j1be = parcelRequire("2j1be");

var $bgewf = parcelRequire("bgewf");
const $8ce94ecfa2e5e8fa$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $8ce94ecfa2e5e8fa$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lSCHZ.getSources)(event, (0, $2j1be.NOTIFICATIONS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = (0, $lSCHZ.getExtraAttributes)(event, (0, $2j1be.NOTIFICATIONS_CONTEXT));
    const components = (0, $lSCHZ.getComponents)(event, (0, $2j1be.NOTIFICATIONS_CONTEXT));
    const packages = (0, $lSCHZ.getPackageInfo)(event, (0, $2j1be.NOTIFICATIONS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $lSCHZ.getPackageInfo)(event, (0, $2j1be.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $8ce94ecfa2e5e8fa$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $bgewf.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("i5hVX", function(module, exports) {
$parcel$export(module.exports, "default", () => $d468b41026013a75$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $dZwNZ = parcelRequire("dZwNZ");

var $3NQSG = parcelRequire("3NQSG");
function $d468b41026013a75$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).recentWork,
        processEvent: (0, $dZwNZ.default)
    });
}

});
parcelRegister("dZwNZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b29837fc8703719$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");


var $lSCHZ = parcelRequire("lSCHZ");
parcelRequire("eUaD0");
var $3Vyd5 = parcelRequire("3Vyd5");

var $bgewf = parcelRequire("bgewf");
const $1b29837fc8703719$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $1b29837fc8703719$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lSCHZ.getSources)(event, (0, $3Vyd5.RECENT_WORK_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = (0, $lSCHZ.getExtraAttributes)(event, (0, $3Vyd5.RECENT_WORK_CONTEXT));
    const components = (0, $lSCHZ.getComponents)(event, (0, $3Vyd5.RECENT_WORK_CONTEXT));
    const packages = (0, $lSCHZ.getPackageInfo)(event, (0, $3Vyd5.RECENT_WORK_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $lSCHZ.getPackageInfo)(event, (0, $3Vyd5.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $1b29837fc8703719$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $bgewf.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("9UiMr", function(module, exports) {
$parcel$export(module.exports, "default", () => $ded604a3510a00fd$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $7hhcl = parcelRequire("7hhcl");

var $3NQSG = parcelRequire("3NQSG");
function $ded604a3510a00fd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).atlas,
        processEvent: (0, $7hhcl.default)
    });
}

});
parcelRegister("7hhcl", function(module, exports) {
$parcel$export(module.exports, "default", () => $093bf35b01ab66d1$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");


var $lSCHZ = parcelRequire("lSCHZ");
parcelRequire("eUaD0");
var $hc6VA = parcelRequire("hc6VA");
const $093bf35b01ab66d1$var$ATLAS_TAG = 'atlas';
const $093bf35b01ab66d1$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $093bf35b01ab66d1$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lSCHZ.getSources)(event, (0, $hc6VA.ATLAS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = (0, $lSCHZ.getExtraAttributes)(event, (0, $hc6VA.ATLAS_CONTEXT));
    const components = (0, $lSCHZ.getComponents)(event, (0, $hc6VA.ATLAS_CONTEXT));
    const packages = (0, $lSCHZ.getPackageInfo)(event, (0, $hc6VA.ATLAS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $lSCHZ.getPackageInfo)(event, (0, $hc6VA.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $093bf35b01ab66d1$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($093bf35b01ab66d1$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("iTkry", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0e684145f5206d7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $kqT0D = parcelRequire("kqT0D");

var $3NQSG = parcelRequire("3NQSG");
function $c0e684145f5206d7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).crossFlow,
        processEvent: (0, $kqT0D.default)
    });
}

});
parcelRegister("kqT0D", function(module, exports) {
$parcel$export(module.exports, "default", () => $53c6d3fd0670c127$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 

var $1ilzu = parcelRequire("1ilzu");
parcelRequire("eUaD0");
var $btPrf = parcelRequire("btPrf");

var $hCvNd = parcelRequire("hCvNd");

var $lSCHZ = parcelRequire("lSCHZ");
const $53c6d3fd0670c127$var$CROSS_FLOW_TAG = 'crossFlow';
var $53c6d3fd0670c127$export$2e2bcd8739ae039 = (event, logger)=>{
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, name: name } = event.payload;
    let sources = (0, $hCvNd.getSources)(event);
    const lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources);
    const source = event.payload.source ?? lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = {
        // To get extra attributes from AnalyticsContext from other products/platforms, e.g. Jira-frontend
        ...(0, $hCvNd.getExtraAttributes)(event),
        // To inherit the extra attributes from the navigation (Atlassian Switcher) context into the crossFlow events,
        // because the events current crossFlow touchpionts already inherit these attributes in the payload.
        ...(0, $lSCHZ.getExtraAttributes)(event, (0, $btPrf.NAVIGATION_CONTEXT)),
        ...event.payload.attributes,
        namespaces: sources.join('.')
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($53c6d3fd0670c127$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("4IkeC", function(module, exports) {
$parcel$export(module.exports, "default", () => $1efe59083d552cfa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4iKlO = parcelRequire("4iKlO");

var $bgewf = parcelRequire("bgewf");

var $3NQSG = parcelRequire("3NQSG");
function $1efe59083d552cfa$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).linkingPlatform,
        processEvent: (0, $4iKlO.default)
    });
}

});
parcelRegister("4iKlO", function(module, exports) {
$parcel$export(module.exports, "default", () => $0902eedf527d7213$export$2e2bcd8739ae039);

var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("eUaD0");
var $afpzL = parcelRequire("afpzL");

var $lSCHZ = parcelRequire("lSCHZ");

var $bgewf = parcelRequire("bgewf");
const $0902eedf527d7213$var$listenerVersion = "0.0.0-use.local";
var $0902eedf527d7213$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $lSCHZ.getSources)(event, (0, $afpzL.LINKING_PLATFORM_CONTEXT));
    const packages = (0, $lSCHZ.getPackageInfo)(event, (0, $afpzL.LINKING_PLATFORM_CONTEXT));
    const components = (0, $lSCHZ.getComponents)(event, (0, $afpzL.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, $lSCHZ.getExtraAttributes)(event, (0, $afpzL.LINKING_PLATFORM_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $bgewf.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $0902eedf527d7213$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, event.payload.attributes)
        },
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});


parcelRegister("29r8A", function(module, exports) {
$parcel$export(module.exports, "default", () => $904679effbf12b62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $jS839 = parcelRequire("jS839");

var $3NQSG = parcelRequire("3NQSG");
function $904679effbf12b62$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).postOffice,
        processEvent: (0, $jS839.default)
    });
}

});
parcelRegister("jS839", function(module, exports) {
$parcel$export(module.exports, "default", () => $91369ce6e4562dea$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("eUaD0");
var $jxC8l = parcelRequire("jxC8l");

var $lSCHZ = parcelRequire("lSCHZ");

var $bgewf = parcelRequire("bgewf");
const $91369ce6e4562dea$var$POST_OFFICE_TAG = (0, $bgewf.FabricChannel).postOffice;
const $91369ce6e4562dea$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $91369ce6e4562dea$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lSCHZ.getSources)(event, (0, $jxC8l.POST_OFFICE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = (0, $lSCHZ.getExtraAttributes)(event, (0, $jxC8l.POST_OFFICE_CONTEXT));
    const components = (0, $lSCHZ.getComponents)(event, (0, $jxC8l.POST_OFFICE_CONTEXT));
    const packages = (0, $lSCHZ.getPackageInfo)(event, (0, $jxC8l.POST_OFFICE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $lSCHZ.getPackageInfo)(event, (0, $jxC8l.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $91369ce6e4562dea$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($91369ce6e4562dea$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("4uQD9", function(module, exports) {
$parcel$export(module.exports, "default", () => $61504c0f07873aa2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $bkyUv = parcelRequire("bkyUv");

var $3NQSG = parcelRequire("3NQSG");
function $61504c0f07873aa2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).aiMate,
        processEvent: (0, $bkyUv.default)
    });
}

});
parcelRegister("bkyUv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fc570644709f9bf$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("eUaD0");
var $jj0ut = parcelRequire("jj0ut");

var $lSCHZ = parcelRequire("lSCHZ");
const $9fc570644709f9bf$var$AI_MATE_TAG = 'aiMate';
const $9fc570644709f9bf$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $9fc570644709f9bf$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lSCHZ.getSources)(event, (0, $jj0ut.AI_MATE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = (0, $lSCHZ.getExtraAttributes)(event, (0, $jj0ut.AI_MATE_CONTEXT));
    const components = (0, $lSCHZ.getComponents)(event, (0, $jj0ut.AI_MATE_CONTEXT));
    const packages = (0, $lSCHZ.getPackageInfo)(event, (0, $jj0ut.AI_MATE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $lSCHZ.getPackageInfo)(event, (0, $jj0ut.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $9fc570644709f9bf$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($9fc570644709f9bf$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("lQZFV", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fd2e67186d017b4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $izFzF = parcelRequire("izFzF");

var $3NQSG = parcelRequire("3NQSG");
function $3fd2e67186d017b4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).avp,
        processEvent: (0, $izFzF.default)
    });
}

});
parcelRegister("izFzF", function(module, exports) {
$parcel$export(module.exports, "default", () => $b95244a1144a76bb$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("eUaD0");
var $bPP8D = parcelRequire("bPP8D");

var $lSCHZ = parcelRequire("lSCHZ");
const $b95244a1144a76bb$var$AVP_TAG = 'avp';
const $b95244a1144a76bb$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $b95244a1144a76bb$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lSCHZ.getSources)(event, (0, $bPP8D.AVP_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = (0, $lSCHZ.getExtraAttributes)(event, (0, $bPP8D.AVP_CONTEXT));
    const components = (0, $lSCHZ.getComponents)(event, (0, $bPP8D.AVP_CONTEXT));
    const packages = (0, $lSCHZ.getPackageInfo)(event, (0, $bPP8D.AVP_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $lSCHZ.getPackageInfo)(event, (0, $bPP8D.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $b95244a1144a76bb$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, ...event.context)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($b95244a1144a76bb$var$AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("hkzcN", function(module, exports) {
$parcel$export(module.exports, "default", () => $0118739644050658$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $gykTj = parcelRequire("gykTj");

var $3NQSG = parcelRequire("3NQSG");
function $0118739644050658$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).growth,
        processEvent: (0, $gykTj.default)
    });
}

});
parcelRegister("gykTj", function(module, exports) {
$parcel$export(module.exports, "default", () => $36a80a8e1f6afc63$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("eUaD0");
var $7J1FZ = parcelRequire("7J1FZ");

var $lSCHZ = parcelRequire("lSCHZ");
const $36a80a8e1f6afc63$var$GROWTH_TAG = 'growth';
const $36a80a8e1f6afc63$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $36a80a8e1f6afc63$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lSCHZ.getSources)(event, (0, $7J1FZ.GROWTH_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = (0, $lSCHZ.getExtraAttributes)(event, (0, $7J1FZ.GROWTH_CONTEXT));
    const components = (0, $lSCHZ.getComponents)(event, (0, $7J1FZ.GROWTH_CONTEXT));
    const packages = (0, $lSCHZ.getPackageInfo)(event, (0, $7J1FZ.GROWTH_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $lSCHZ.getPackageInfo)(event, (0, $7J1FZ.GROWTH_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $36a80a8e1f6afc63$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($36a80a8e1f6afc63$var$GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("3HZO0", function(module, exports) {
$parcel$export(module.exports, "default", () => $26eda93c6a105e3f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $6Swq5 = parcelRequire("6Swq5");

var $3NQSG = parcelRequire("3NQSG");
const $26eda93c6a105e3f$var$OmniChannelAnalyticsListener = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).omniChannel,
        processEvent: (0, $6Swq5.default)
    });
};
var $26eda93c6a105e3f$export$2e2bcd8739ae039 = $26eda93c6a105e3f$var$OmniChannelAnalyticsListener;

});
parcelRegister("6Swq5", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0dadc59782250ff$export$2e2bcd8739ae039);

parcelRequire("eUaD0");
var $5gOQP = parcelRequire("5gOQP");

var $lSCHZ = parcelRequire("lSCHZ");

var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

var $bgewf = parcelRequire("bgewf");
const $b0dadc59782250ff$var$listenerVersion = "0.0.0-use.local";
var $b0dadc59782250ff$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lSCHZ.getSources)(event, (0, $5gOQP.OMNI_CHANNEL_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = (0, $lSCHZ.getExtraAttributes)(event, (0, $5gOQP.OMNI_CHANNEL_CONTEXT));
    const components = (0, $lSCHZ.getComponents)(event, (0, $5gOQP.OMNI_CHANNEL_CONTEXT));
    const packages = (0, $lSCHZ.getPackageInfo)(event, (0, $5gOQP.OMNI_CHANNEL_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $lSCHZ.getPackageInfo)(event, (0, $5gOQP.OMNI_CHANNEL_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $b0dadc59782250ff$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $bgewf.FabricChannel).omniChannel);
    if (event.payload) switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("eroM1", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab3b6c16de510d5a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $bcLEO = parcelRequire("bcLEO");

var $3NQSG = parcelRequire("3NQSG");
function $ab3b6c16de510d5a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).townsquareHome,
        processEvent: (0, $bcLEO.default)
    });
}

});
parcelRegister("bcLEO", function(module, exports) {
$parcel$export(module.exports, "default", () => $845719366aff950c$export$2e2bcd8739ae039);

var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");


var $lSCHZ = parcelRequire("lSCHZ");
parcelRequire("eUaD0");
var $77Y0z = parcelRequire("77Y0z");
const $845719366aff950c$var$TOWNSQUARE_TAG = 'townsquare';
const $845719366aff950c$var$TOWNSQUARE_HOME_TAG = 'townsquareHome';
const $845719366aff950c$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $845719366aff950c$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lSCHZ.getSources)(event, (0, $77Y0z.TOWNSQUARE_HOME_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = (0, $lSCHZ.getExtraAttributes)(event, (0, $77Y0z.TOWNSQUARE_HOME_CONTEXT));
    const components = (0, $lSCHZ.getComponents)(event, (0, $77Y0z.TOWNSQUARE_HOME_CONTEXT));
    const packages = (0, $lSCHZ.getPackageInfo)(event, (0, $77Y0z.TOWNSQUARE_HOME_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $lSCHZ.getPackageInfo)(event, (0, $77Y0z.TOWNSQUARE_HOME_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $845719366aff950c$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "townsquare" is our platform analytic for data portal
    tags.add($845719366aff950c$var$TOWNSQUARE_TAG);
    // "townsquareHome" allows us to differentiate our events from townsquare events.
    tags.add($845719366aff950c$var$TOWNSQUARE_HOME_TAG);
    if (event.payload) switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("kusYb", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8608e132900515d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $3T4WD = parcelRequire("3T4WD");

var $3NQSG = parcelRequire("3NQSG");
function $c8608e132900515d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3NQSG.default), {
        ...props,
        channel: (0, $bgewf.FabricChannel).rovoExtension,
        processEvent: (0, $3T4WD.default)
    });
}

});
parcelRegister("3T4WD", function(module, exports) {
$parcel$export(module.exports, "default", () => $aae8fe2796879a03$export$2e2bcd8739ae039);

var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");


var $lSCHZ = parcelRequire("lSCHZ");
parcelRequire("eUaD0");
var $dBFv4 = parcelRequire("dBFv4");
const $aae8fe2796879a03$var$ROVO_EXTENSION_TAG = 'rovoExtension';
const $aae8fe2796879a03$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $aae8fe2796879a03$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lSCHZ.getSources)(event, (0, $dBFv4.ROVO_EXTENSION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = (0, $lSCHZ.getExtraAttributes)(event, (0, $dBFv4.ROVO_EXTENSION_CONTEXT));
    const components = (0, $lSCHZ.getComponents)(event, (0, $dBFv4.ROVO_EXTENSION_CONTEXT));
    const packages = (0, $lSCHZ.getPackageInfo)(event, (0, $dBFv4.ROVO_EXTENSION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $lSCHZ.getPackageInfo)(event, (0, $dBFv4.ROVO_EXTENSION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $aae8fe2796879a03$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "rovoExtension" allows us to differentiate our events from rovo events.
    tags.add($aae8fe2796879a03$var$ROVO_EXTENSION_TAG);
    if (event.payload) switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});




parcelRegister("4FnHr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("h0TP6")).default);
$parcel$export(module.exports, "AutoDismissFlag", () => (parcelRequire("1jLQ3")).default);
$parcel$export(module.exports, "FlagGroup", () => (parcelRequire("gPCVG")).default);
$parcel$export(module.exports, "useFlags", () => (parcelRequire("101p7")).useFlags);
$parcel$export(module.exports, "withFlagsProvider", () => (parcelRequire("101p7")).withFlagsProvider);
$parcel$export(module.exports, "FlagsProvider", () => (parcelRequire("101p7")).FlagsProvider);

var $h0TP6 = parcelRequire("h0TP6");

var $1jLQ3 = parcelRequire("1jLQ3");

var $gPCVG = parcelRequire("gPCVG");

var $101p7 = parcelRequire("101p7");

});
parcelRegister("h0TP6", function(module, exports) {
$parcel$export(module.exports, "default", () => $29f89ece31eb6777$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $806LH = parcelRequire("806LH");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $6fs4r = parcelRequire("6fs4r");


var $luSmY = parcelRequire("luSmY");

var $gPCVG = parcelRequire("gPCVG");

var $kB33F = parcelRequire("kB33F");
var $hq2lE = parcelRequire("hq2lE");

var $3Qkuo = parcelRequire("3Qkuo");
const $29f89ece31eb6777$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs8sq4 _1pbyni7l _1bsb1osq"
};
const $29f89ece31eb6777$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $29f89ece31eb6777$var$descriptionStyles = null;
const $29f89ece31eb6777$var$iconWrapperStyles = null;
const $29f89ece31eb6777$var$flagWrapperStyles = null;
const $29f89ece31eb6777$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $29f89ece31eb6777$var$transitionStyles = null; /**
                                * __Flag__
                                *
                                * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
                                * often displayed using a flag group.
                                *
                                * - [Examples](https://atlassian.design/components/flag/examples)
                                * - [Code](https://atlassian.design/components/flag/code)
                                * - [Usage](https://atlassian.design/components/flag/usage)
                                */ 
const $29f89ece31eb6777$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $a09d0fc1237ba534$export$d6830277b06edd6), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $3Vuhz.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $3Vuhz.default), onDismissed: onDismissedProp = (0, $3Vuhz.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $eJOHy.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $gPCVG.useFlagGroup)();
    const onDismissed = (0, $eJOHy.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $eJOHy.useState)(false);
    const onDismissedAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$29f89ece31eb6777$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $a09d0fc1237ba534$export$d6830277b06edd6);
    const toggleExpand = (0, $eJOHy.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $eJOHy.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$29f89ece31eb6777$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$29f89ece31eb6777$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $3Qkuo.flagTextColor)[appearance];
    const iconColor = (0, $3Qkuo.flagIconColor)[appearance];
    const iconGlyph = (0, $3Qkuo.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded; // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
        children: [
            title,
            description
        ]
    }) : undefined;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $hcewu.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            padding: "space.200",
            backgroundColor: (0, $3Qkuo.flagBackgroundColor)[appearance],
            xcss: $29f89ece31eb6777$var$styles.flag,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                alignBlock: "start",
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    , {
                        style: {
                            [$29f89ece31eb6777$var$CSS_VAR_ICON_COLOR]: iconColor
                        },
                        "data-testid": testId && `${testId}-icon-container`,
                        className: (0, $hcewu.default)([
                            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"
                        ]),
                        children: icon || iconGlyph
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        className: (0, $hcewu.default)([
                            "_v5641hdc _16jlkb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: $29f89ece31eb6777$var$styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                                                as: `h${headingLevel}`,
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                                                    /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                                    children: title
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kB33F.default), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hq2lE.default), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        , {
                                            style: {
                                                color: (0, $3Qkuo.flagTextColorToken)[appearance]
                                            },
                                            "data-testid": testId && `${testId}-description`,
                                            "aria-hidden": isDelayToAnnounce,
                                            className: (0, $hcewu.default)([
                                                "_11c82smr _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $luSmY.default), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $29f89ece31eb6777$export$2e2bcd8739ae039 = $29f89ece31eb6777$var$Flag;

});
parcelRegister("jrFnt", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $06b541c64041df71$export$a4687b0234b40e28);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $gAkni = parcelRequire("gAkni");
function $06b541c64041df71$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $gAkni.useTrackedRef)(analyticsData);
    const fnRef = (0, $gAkni.useTrackedRef)(fn);
    const handler = (0, $eJOHy.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("ftN6c", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $6107e3d74e8a4cd1$export$5bf35293e545f20c);

var $7pA0u = parcelRequire("7pA0u");

var $5EMLi = parcelRequire("5EMLi");

var $49e07 = parcelRequire("49e07");
function $6107e3d74e8a4cd1$export$5bf35293e545f20c() {
    const analyticsContext = (0, $49e07.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $7pA0u.useCallbackOne)((payload)=>{
        return new (0, $5EMLi.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("5EMLi", function(module, exports) {
$parcel$export(module.exports, "isUIAnalyticsEvent", () => $f6dcb2cf45464cd9$export$35f8383928ba8d7);
$parcel$export(module.exports, "default", () => $f6dcb2cf45464cd9$export$2e2bcd8739ae039);
/// <reference types="node" />

var $lIzdo = parcelRequire("lIzdo");
const $f6dcb2cf45464cd9$export$35f8383928ba8d7 = (obj)=>obj instanceof $f6dcb2cf45464cd9$export$2e2bcd8739ae039 || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
class $f6dcb2cf45464cd9$export$2e2bcd8739ae039 extends (0, $lIzdo.default) {
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
		 * A hacky "deep clone" of the object. This is limited in that it wont
		 * support functions, regexs, Maps, Sets, etc, but none of those need to
		 * be represented in our payload.
		 */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $f6dcb2cf45464cd9$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>handler(this, channel));
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}

});
parcelRegister("lIzdo", function(module, exports) {
$parcel$export(module.exports, "default", () => $f87d8ae21f953411$export$2e2bcd8739ae039);
const $f87d8ae21f953411$export$ad4be5c2ec28cecf = (obj)=>obj instanceof $f87d8ae21f953411$export$2e2bcd8739ae039 || !!obj?._isAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'AnalyticsEvent';
class $f87d8ae21f953411$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $f87d8ae21f953411$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});




parcelRegister("3Vuhz", function(module, exports) {
$parcel$export(module.exports, "default", () => $97b53fd6d232ac02$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $97b53fd6d232ac02$export$2e2bcd8739ae039() {}

});

parcelRegister("806LH", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb2968a076b4bf0e$export$2e2bcd8739ae039);
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gF73L = parcelRequire("gF73L");

var $1yiB6 = parcelRequire("1yiB6");

var $a1hYp = parcelRequire("a1hYp");

var $igDjg = parcelRequire("igDjg");
const $bb2968a076b4bf0e$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
const $bb2968a076b4bf0e$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
const $bb2968a076b4bf0e$var$headingColorStylesMap = {
    'color.text': "_syazi7uo",
    'color.text.inverse': "_syaz15cr",
    'color.text.warning.inverse': "_syaz1yd3"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::406afb01e5634a0b459f50de660d8c2e>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ const $bb2968a076b4bf0e$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ const $bb2968a076b4bf0e$var$useColor = (colorProp)=>{
    const surface = (0, $1yiB6.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $gF73L.inverseColorMap).hasOwnProperty(surface)) return (0, $gF73L.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $bb2968a076b4bf0e$var$Heading = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $igDjg;
    const [hLevel, inferredElement] = (0, $a1hYp.useHeading)($bb2968a076b4bf0e$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $bb2968a076b4bf0e$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $hcewu.default)([
            $bb2968a076b4bf0e$var$styles.reset,
            size && $bb2968a076b4bf0e$var$headingSizeStylesMap[size],
            $bb2968a076b4bf0e$var$headingColorStylesMap[color]
        ]),
        children: children
    });
});
var $bb2968a076b4bf0e$export$2e2bcd8739ae039 = $bb2968a076b4bf0e$var$Heading;

});
parcelRegister("gF73L", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $563a24dea78fe8fb$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $563a24dea78fe8fb$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $563a24dea78fe8fb$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $563a24dea78fe8fb$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $563a24dea78fe8fb$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $563a24dea78fe8fb$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $563a24dea78fe8fb$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $563a24dea78fe8fb$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $563a24dea78fe8fb$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $563a24dea78fe8fb$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $563a24dea78fe8fb$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $563a24dea78fe8fb$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $563a24dea78fe8fb$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $563a24dea78fe8fb$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $563a24dea78fe8fb$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $563a24dea78fe8fb$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $563a24dea78fe8fb$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $563a24dea78fe8fb$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $563a24dea78fe8fb$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "textSizeStylesMap", () => $563a24dea78fe8fb$export$219d364c0da35ae4);
$parcel$export(module.exports, "textWeightStylesMap", () => $563a24dea78fe8fb$export$38845ca010b93505);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $563a24dea78fe8fb$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $563a24dea78fe8fb$export$5e65a44e5b6ecadb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $cZeFf = parcelRequire("cZeFf");
const $563a24dea78fe8fb$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $563a24dea78fe8fb$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $563a24dea78fe8fb$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $563a24dea78fe8fb$export$632685d741f3dbbf = {
    ...$563a24dea78fe8fb$export$958d0ae7f2977ae4,
    ...$563a24dea78fe8fb$export$d2dc61f58390201c
};
const $563a24dea78fe8fb$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $563a24dea78fe8fb$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $563a24dea78fe8fb$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $563a24dea78fe8fb$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $563a24dea78fe8fb$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $563a24dea78fe8fb$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $563a24dea78fe8fb$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
const $563a24dea78fe8fb$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
const $563a24dea78fe8fb$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $563a24dea78fe8fb$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
const $563a24dea78fe8fb$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
const $563a24dea78fe8fb$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $563a24dea78fe8fb$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
const $563a24dea78fe8fb$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $563a24dea78fe8fb$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $563a24dea78fe8fb$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $563a24dea78fe8fb$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
// Generate maps for Box props. backgroundColor, padding, etc
const $563a24dea78fe8fb$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $563a24dea78fe8fb$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = /*#__PURE__*/ (0, $1NIU8.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $563a24dea78fe8fb$export$e615f061ca585a6c = $563a24dea78fe8fb$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $563a24dea78fe8fb$export$ca0f9c2de39ffed7(spacingProperty, $563a24dea78fe8fb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $563a24dea78fe8fb$export$bf46c3f9eeafc71f = $563a24dea78fe8fb$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $563a24dea78fe8fb$export$ca0f9c2de39ffed7(spacingProperty, $563a24dea78fe8fb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $563a24dea78fe8fb$export$e7af83bafe7f9e63 = $563a24dea78fe8fb$export$ca0f9c2de39ffed7('backgroundColor', $563a24dea78fe8fb$export$d1d79bf68ac056bd);
const $563a24dea78fe8fb$export$3a1bcba60b23d7f0 = $563a24dea78fe8fb$export$ca0f9c2de39ffed7('color', $563a24dea78fe8fb$export$8473307aa00d6ea1);
const $563a24dea78fe8fb$export$45f3f4fe16f9f7d5 = $563a24dea78fe8fb$export$ca0f9c2de39ffed7('fontWeight', $563a24dea78fe8fb$export$303e322c6b1ed114);
const $563a24dea78fe8fb$export$68cc305da27dbaa4 = $563a24dea78fe8fb$export$ca0f9c2de39ffed7('fontFamily', $563a24dea78fe8fb$export$3c7e9587132614b4);
const $563a24dea78fe8fb$export$128f10c238242f83 = $563a24dea78fe8fb$export$ca0f9c2de39ffed7('font', $563a24dea78fe8fb$export$6ffa317d5e70375);
const $563a24dea78fe8fb$export$219d364c0da35ae4 = $563a24dea78fe8fb$export$ca0f9c2de39ffed7('font', $563a24dea78fe8fb$export$236bfe3a33ef1292);
const $563a24dea78fe8fb$export$38845ca010b93505 = $563a24dea78fe8fb$export$ca0f9c2de39ffed7('fontWeight', $563a24dea78fe8fb$export$855cfd311192d666);
const $563a24dea78fe8fb$export$ff257d957d48c421 = $563a24dea78fe8fb$export$ca0f9c2de39ffed7((0, $cZeFf.CURRENT_SURFACE_CSS_VAR), $563a24dea78fe8fb$export$41a358c9c2356760);
const $563a24dea78fe8fb$export$5e65a44e5b6ecadb = (color)=>$563a24dea78fe8fb$export$41a358c9c2356760[color] !== undefined;
const $563a24dea78fe8fb$export$7001ce64d9ff7c7f = $563a24dea78fe8fb$export$ca0f9c2de39ffed7('font', $563a24dea78fe8fb$export$b805719bc8cb376);

});
parcelRegister("cZeFf", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $86d497704ad78271$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $86d497704ad78271$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $86d497704ad78271$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $86d497704ad78271$export$352e418ed5b6193a);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $86d497704ad78271$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $86d497704ad78271$export$9d7b58831ae93caa);
const $86d497704ad78271$export$4ef52930e33717cd = 'data-theme';
const $86d497704ad78271$export$a00eac3f8684bcd0 = 'data-color-mode';
const $86d497704ad78271$export$2112803007239c61 = 'data-contrast-mode';
const $86d497704ad78271$export$352e418ed5b6193a = 'data-custom-theme';
const $86d497704ad78271$export$6f0c6fb8c80fcc92 = 'ds';
const $86d497704ad78271$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const $86d497704ad78271$export$dddac1532e822863 = `--${$86d497704ad78271$export$6f0c6fb8c80fcc92}-token-not-found`;
const $86d497704ad78271$export$9d7b58831ae93caa = `--${$86d497704ad78271$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});


parcelRegister("1yiB6", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $fb36a93c5821d3eb$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $fb36a93c5821d3eb$export$1aeb4f6b93c4540d);

var $eJOHy = parcelRequire("eJOHy");
const $fb36a93c5821d3eb$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $eJOHy.createContext)('elevation.surface');
const $fb36a93c5821d3eb$export$1aeb4f6b93c4540d = ()=>{
    return (0, $eJOHy.useContext)($fb36a93c5821d3eb$export$1ca2a26fecb070ae);
};
$fb36a93c5821d3eb$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("a1hYp", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $3d675bbac708b7ea$export$97a37b1befbbf9b1);
$parcel$export(module.exports, "default", () => $3d675bbac708b7ea$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $3d675bbac708b7ea$var$HeadingLevelContext = /*#__PURE__*/ (0, $eJOHy.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ const $3d675bbac708b7ea$var$useHeadingLevel = ()=>{
    return (0, $eJOHy.useContext)($3d675bbac708b7ea$var$HeadingLevelContext);
};
const $3d675bbac708b7ea$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = $3d675bbac708b7ea$var$useHeadingLevel();
    /**
	 * Order here is important, we for now apply
	 * 1. inferred a11y level (this only applies if context is present)
	 * 2. default final fallback
	 */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ const $3d675bbac708b7ea$var$HeadingLevelContextProvider = ({ children: children, value: value })=>{
    const parentHeadingLevel = $3d675bbac708b7ea$var$useHeadingLevel();
    const headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($3d675bbac708b7ea$var$HeadingLevelContext.Provider, {
        value: value || headingLevel,
        children: children
    });
};
var $3d675bbac708b7ea$export$2e2bcd8739ae039 = $3d675bbac708b7ea$var$HeadingLevelContextProvider;

});


parcelRegister("8IeH1", function(module, exports) {
$parcel$export(module.exports, "default", () => $00c69133d3e19b79$export$2e2bcd8739ae039);
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1yiB6 = parcelRequire("1yiB6");
const $00c69133d3e19b79$var$baseStyles = null;
const $00c69133d3e19b79$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhk1w7a",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $00c69133d3e19b79$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $00c69133d3e19b79$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const $00c69133d3e19b79$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $00c69133d3e19b79$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $00c69133d3e19b79$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $00c69133d3e19b79$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ const $00c69133d3e19b79$var$Box = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $hcewu.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $00c69133d3e19b79$var$backgroundColorMap[backgroundColor],
            backgroundColor && $00c69133d3e19b79$var$isSurfaceToken(backgroundColor) && $00c69133d3e19b79$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $00c69133d3e19b79$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $00c69133d3e19b79$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $00c69133d3e19b79$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $00c69133d3e19b79$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1yiB6.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
var $00c69133d3e19b79$export$2e2bcd8739ae039 = $00c69133d3e19b79$var$Box;
function $00c69133d3e19b79$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $00c69133d3e19b79$var$setSurfaceTokenMap;
}

});

parcelRegister("6djmC", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd9eb1e25dd0c445$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6qaBj = parcelRequire("6qaBj");

var $2sLVw = parcelRequire("2sLVw");
const $dd9eb1e25dd0c445$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $dd9eb1e25dd0c445$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            $dd9eb1e25dd0c445$var$styles.separator
        ]),
        children: children
    });
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $dd9eb1e25dd0c445$var$Inline = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $gt9Am.jsx)($dd9eb1e25dd0c445$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $eJOHy.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
        ...ariaAttributes,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $6qaBj.cx)(grow === 'hug' && $dd9eb1e25dd0c445$var$styles.hug, grow === 'fill' && $dd9eb1e25dd0c445$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$dd9eb1e25dd0c445$var$Inline.displayName = 'Inline';
var $dd9eb1e25dd0c445$export$2e2bcd8739ae039 = $dd9eb1e25dd0c445$var$Inline;

});
parcelRegister("6qaBj", function(module, exports) {
$parcel$export(module.exports, "cx", () => $4f9db1057caf3d0e$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("eJOHy");

var $3C1kS = parcelRequire("3C1kS");
const $4f9db1057caf3d0e$var$strictApi = (0, $3C1kS.createStrictAPI)();
const $4f9db1057caf3d0e$export$dbf350e5966cf602 = $4f9db1057caf3d0e$var$strictApi.css;
const $4f9db1057caf3d0e$export$eb1ecd84a24ee424 = $4f9db1057caf3d0e$var$strictApi.cssMap;
$4f9db1057caf3d0e$var$strictApi.cssMap;
const $4f9db1057caf3d0e$export$a274e22fb40f762e = $4f9db1057caf3d0e$var$strictApi.cx;
const $4f9db1057caf3d0e$var$XCSSProp = $4f9db1057caf3d0e$var$strictApi.XCSSProp;

});

parcelRegister("2sLVw", function(module, exports) {
$parcel$export(module.exports, "default", () => $78e37b65b3f9f109$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $78e37b65b3f9f109$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $78e37b65b3f9f109$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $78e37b65b3f9f109$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $78e37b65b3f9f109$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $78e37b65b3f9f109$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $78e37b65b3f9f109$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $78e37b65b3f9f109$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $78e37b65b3f9f109$var$Flex = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        ...ariaAttributes,
        role: role,
        className: (0, $hcewu.default)([
            $78e37b65b3f9f109$var$styles.root,
            gap && $78e37b65b3f9f109$var$columnGapMap[gap],
            columnGap && $78e37b65b3f9f109$var$columnGapMap[columnGap],
            gap && $78e37b65b3f9f109$var$rowGapMap[gap],
            rowGap && $78e37b65b3f9f109$var$rowGapMap[rowGap],
            alignItems && $78e37b65b3f9f109$var$alignItemsMap[alignItems],
            direction && $78e37b65b3f9f109$var$flexDirectionMap[direction],
            justifyContent && $78e37b65b3f9f109$var$justifyContentMap[justifyContent],
            wrap && $78e37b65b3f9f109$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$78e37b65b3f9f109$var$Flex.displayName = 'Flex';
var $78e37b65b3f9f109$export$2e2bcd8739ae039 = $78e37b65b3f9f109$var$Flex;

});


parcelRegister("78OnL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c51b64a571e2aa22$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $2sLVw = parcelRequire("2sLVw");
const $c51b64a571e2aa22$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $c51b64a571e2aa22$var$Stack = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
        ...ariaAttributes,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $6qaBj.cx)(grow === 'hug' && $c51b64a571e2aa22$var$styles.hug, grow === 'fill' && $c51b64a571e2aa22$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$c51b64a571e2aa22$var$Stack.displayName = 'Stack';
var $c51b64a571e2aa22$export$2e2bcd8739ae039 = $c51b64a571e2aa22$var$Stack;

});

parcelRegister("6fs4r", function(module, exports) {
$parcel$export(module.exports, "default", () => $86c5c9b0ad6d4ee8$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $86c5c9b0ad6d4ee8$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $86c5c9b0ad6d4ee8$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
var $86c5c9b0ad6d4ee8$export$2e2bcd8739ae039 = $86c5c9b0ad6d4ee8$var$VisuallyHidden;

});

const $a09d0fc1237ba534$export$d6830277b06edd6 = 'normal';

parcelRegister("luSmY", function(module, exports) {
$parcel$export(module.exports, "default", () => $0edcec5ad4782ce9$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $abjs4 = parcelRequire("abjs4");

var $6djmC = parcelRequire("6djmC");


var $3Qkuo = parcelRequire("3Qkuo");
const $0edcec5ad4782ce9$var$buttonStyles = null;
const $0edcec5ad4782ce9$var$fontStyles = null;
const $0edcec5ad4782ce9$var$appearanceNormalButtonStyles = null;
const $0edcec5ad4782ce9$var$appearanceNormalActionsContainerStyles = null;
const $0edcec5ad4782ce9$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $a09d0fc1237ba534$export$d6830277b06edd6), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $a09d0fc1237ba534$export$d6830277b06edd6);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c82smr"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && `${testId}-actions`,
            children: actions.map((action, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $abjs4.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $3Qkuo.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $3Qkuo.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $3Qkuo.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $3Qkuo.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $hcewu.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow0718uv _1p6b18uv _8dbm18uv _77mc18uv _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        appearance === (0, $a09d0fc1237ba534$export$d6830277b06edd6) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index))
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0edcec5ad4782ce9$export$2e2bcd8739ae039 = $0edcec5ad4782ce9$var$FlagActions;

});
parcelRegister("abjs4", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe7e713370b43932$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kUDZ7 = parcelRequire("kUDZ7");

var $guzrQ = parcelRequire("guzrQ");

var $5xD8j = parcelRequire("5xD8j");

var $2re7G = parcelRequire("2re7G");

var $lBX28 = parcelRequire("lBX28");
function $fe7e713370b43932$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $fe7e713370b43932$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $fe7e713370b43932$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $lBX28.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $eJOHy.useState)($fe7e713370b43932$var$initial);
    const onMouseEnter = (0, $eJOHy.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $eJOHy.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $eJOHy.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $eJOHy.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $eJOHy.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $eJOHy.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lBX28.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kUDZ7.default).Consumer, {
            children: ({ mode: mode })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lBX28.default).Consumer, {
                    mode: mode,
                    state: $fe7e713370b43932$var$getInteractionState({
                        ...state,
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    }),
                    iconIsOnlyChild: (0, $5xD8j.default)(restProps),
                    isLoading: isLoading,
                    ...restProps,
                    children: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $guzrQ.default), {
                            ...restProps,
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2re7G.default), {
                                ...restProps
                            }) : null,
                            // No need to render aria-disabled when it is false
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, $lBX28.getSpecifiers)(buttonStyles)
                        })
                })
        })
    });
}));
// Tools including enzyme rely on components having a display name
$fe7e713370b43932$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $fe7e713370b43932$export$2e2bcd8739ae039 = $fe7e713370b43932$var$CustomThemeButton;

});
parcelRegister("kUDZ7", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", () => $8ef56131ebb02d50$export$7692396083754928);
$parcel$export(module.exports, "default", () => $8ef56131ebb02d50$export$2e2bcd8739ae039);

var $iMaCz = parcelRequire("iMaCz");
// Create default global light theme
const { Provider: $8ef56131ebb02d50$var$Provider, Consumer: $8ef56131ebb02d50$var$Consumer, useTheme: $8ef56131ebb02d50$export$7692396083754928 } = (0, $iMaCz.createTheme)(()=>({
        mode: 'light'
    }));
const $8ef56131ebb02d50$var$Theme = {
    Provider: $8ef56131ebb02d50$var$Provider,
    Consumer: $8ef56131ebb02d50$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8ef56131ebb02d50$export$2e2bcd8739ae039 = $8ef56131ebb02d50$var$Theme;

});
parcelRegister("iMaCz", function(module, exports) {
$parcel$export(module.exports, "createTheme", () => $8587b6f02ce1cafc$export$25d302a5b900a763);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $8587b6f02ce1cafc$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
	 * Internally, Theme uses React Context, with internal providers and consumers.
	 * The React Context passes only a function that gets props, and turns them into tokens. This
	 * function gets mixed as more Providers with their own themes are added. This mixed function
	 * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
	 * the theme.
	 */ const ThemeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $eJOHy.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: children(tokens)
        });
    }
    /**
	 * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
	 * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
	 * - The getTokens function isn't called immediately - instead the props are passed
	 *    through a mix of parent theming functions
	 * Children of this provider will receive this mixed theme
	 */ function Provider(props) {
        const themeFn = (0, $eJOHy.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $eJOHy.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("guzrQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ff0cef7b434577e$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
                                                                        * @jsxRuntime classic
                                                                        * @jsx jsx
                                                                        */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $jTslB = parcelRequire("jTslB");

var $3U4Mr = parcelRequire("3U4Mr");

var $d0Gew = parcelRequire("d0Gew");


var $79ekO = parcelRequire("79ekO");

var $dtCDi = parcelRequire("dtCDi");

var $dy5Kp = parcelRequire("dy5Kp");
function $4ff0cef7b434577e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $4ff0cef7b434577e$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $4ff0cef7b434577e$var$iconBeforeSpacingFixStyle = {
    name: "s584p2",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-025, 2px);--ds--button--new-icon-padding-start:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-negative-025, -2px)"
};
const $4ff0cef7b434577e$var$iconAfterSpacingFixStyle = {
    name: "150qmyr",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-050, 4px);--ds--button--new-icon-padding-start:var(--ds-space-025, 2px);margin-inline-end:var(--ds-space-negative-025, -2px)"
};
const $4ff0cef7b434577e$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $dy5Kp.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $4ff0cef7b434577e$var$getChildren = (children, childrenStyles)=>{
    if ((0, $dy5Kp.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $4ff0cef7b434577e$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $3Vuhz.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $3Vuhz.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $eJOHy.useRef)();
    const setRef = (0, $eJOHy.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $jTslB.default)(ourRef, autoFocus);
    const interactionContext = (0, $eJOHy.useContext)((0, $d0Gew.default));
    const handleClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $eJOHy.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = /*#__PURE__*/ (0, $1NIU8.css)((0, $dtCDi.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? `var(--ds-icon-subtle, ${0, $7bb4c1736002a04a$export$c39c0fe0f26207ae})` : `var(--ds-icon-warning-inverse, ${0, $7bb4c1736002a04a$export$c39c0fe0f26207ae})`} !important`
        }
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3U4Mr.default), null, /*#__PURE__*/ (0, $1NIU8.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $4ff0cef7b434577e$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $79ekO.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dtCDi.getIconStyle)({
                spacing: spacing
            }),
            $4ff0cef7b434577e$var$getSpacingFix(children, $4ff0cef7b434577e$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $4ff0cef7b434577e$var$getChildren(children, [
        fadeStyles,
        (0, $dtCDi.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dtCDi.getIconStyle)({
                spacing: spacing
            }),
            $4ff0cef7b434577e$var$getSpacingFix(children, $4ff0cef7b434577e$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: [
            (0, $dtCDi.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4ff0cef7b434577e$export$2e2bcd8739ae039 = $4ff0cef7b434577e$var$ButtonBase;

});
parcelRegister("jTslB", function(module, exports) {
$parcel$export(module.exports, "default", () => $db051fbe28ebf364$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $db051fbe28ebf364$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("3U4Mr", function(module, exports) {
$parcel$export(module.exports, "default", () => $d84634403c1c7d4c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");
const $d84634403c1c7d4c$var$BORDER_WIDTH = 2;
const $d84634403c1c7d4c$var$baseFocusOutsideStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #2684FF)"}`,
    outlineOffset: $d84634403c1c7d4c$var$BORDER_WIDTH
});
const $d84634403c1c7d4c$var$baseInsetStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$d84634403c1c7d4c$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const $d84634403c1c7d4c$var$focusRingStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $d84634403c1c7d4c$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $d84634403c1c7d4c$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const $d84634403c1c7d4c$var$insetFocusRingStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $d84634403c1c7d4c$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $d84634403c1c7d4c$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ const $d84634403c1c7d4c$var$FocusRing = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $d84634403c1c7d4c$var$baseInsetStyles : $d84634403c1c7d4c$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $d84634403c1c7d4c$var$insetFocusRingStyles : $d84634403c1c7d4c$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1NIU8.ClassNames), null, ({ css: css, cx: cx })=>(0, $eJOHy.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $eJOHy.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$d84634403c1c7d4c$var$FocusRing.displayName = 'FocusRing';
var $d84634403c1c7d4c$export$2e2bcd8739ae039 = $d84634403c1c7d4c$var$FocusRing;

});

var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

parcelRegister("79ekO", function(module, exports) {
$parcel$export(module.exports, "default", () => $173f629a1d555b2c$export$2e2bcd8739ae039);
function $173f629a1d555b2c$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $173f629a1d555b2c$var$tabKeyCode = 9;
function $173f629a1d555b2c$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $173f629a1d555b2c$var$tabKeyCode) return;
    $173f629a1d555b2c$var$abort(event);
}
const $173f629a1d555b2c$var$block = {
    onMouseDownCapture: $173f629a1d555b2c$var$abort,
    onMouseUpCapture: $173f629a1d555b2c$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $173f629a1d555b2c$var$onKey,
    onKeyUpCapture: $173f629a1d555b2c$var$onKey,
    onTouchStartCapture: $173f629a1d555b2c$var$abort,
    onTouchEndCapture: $173f629a1d555b2c$var$abort,
    onPointerDownCapture: $173f629a1d555b2c$var$abort,
    onPointerUpCapture: $173f629a1d555b2c$var$abort,
    onClickCapture: $173f629a1d555b2c$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $173f629a1d555b2c$var$abort
};
const $173f629a1d555b2c$var$doNotBlock = {};
function $173f629a1d555b2c$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $173f629a1d555b2c$var$doNotBlock : $173f629a1d555b2c$var$block;
}

});

parcelRegister("dtCDi", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $3a3f04ffda0438f0$export$955358618f994a11);
$parcel$export(module.exports, "getIconStyle", () => $3a3f04ffda0438f0$export$864eea3f4ec3368f);
$parcel$export(module.exports, "getContentStyle", () => $3a3f04ffda0438f0$export$7ad0316cc0dd65a);
$parcel$export(module.exports, "getFadingCss", () => $3a3f04ffda0438f0$export$1b5827d324e945b1);
$parcel$export(module.exports, "overlayCss", () => $3a3f04ffda0438f0$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $3a3f04ffda0438f0$var$gridSize = 8;
const $3a3f04ffda0438f0$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
const $3a3f04ffda0438f0$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $3a3f04ffda0438f0$var$lineHeights = {
    default: $3a3f04ffda0438f0$var$heights.default,
    compact: $3a3f04ffda0438f0$var$heights.compact,
    none: 'inherit'
};
const $3a3f04ffda0438f0$var$padding = {
    // 10px gutter
    default: `0 ${$3a3f04ffda0438f0$var$gridSize + $3a3f04ffda0438f0$var$gridSize / 4}px`,
    compact: `0 ${$3a3f04ffda0438f0$var$gridSize + $3a3f04ffda0438f0$var$gridSize / 4}px`,
    none: '0'
};
const $3a3f04ffda0438f0$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$3a3f04ffda0438f0$var$gridSize / 4}px`,
    default: `0 ${$3a3f04ffda0438f0$var$gridSize / 4}px`,
    none: '0'
};
const $3a3f04ffda0438f0$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $3a3f04ffda0438f0$var$innerMargin = {
    content: `0 ${$3a3f04ffda0438f0$var$gridSize / 4}px`,
    icon: `0 ${$3a3f04ffda0438f0$var$gridSize / 4}px`
};
const $3a3f04ffda0438f0$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $3a3f04ffda0438f0$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$3a3f04ffda0438f0$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
const $3a3f04ffda0438f0$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
const $3a3f04ffda0438f0$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
const $3a3f04ffda0438f0$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
const $3a3f04ffda0438f0$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
const $3a3f04ffda0438f0$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
const $3a3f04ffda0438f0$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
const $3a3f04ffda0438f0$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$3a3f04ffda0438f0$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
const $3a3f04ffda0438f0$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $3a3f04ffda0438f0$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $3a3f04ffda0438f0$var$heights[spacing],
        lineHeight: $3a3f04ffda0438f0$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $3a3f04ffda0438f0$var$singleIconPadding[spacing] : $3a3f04ffda0438f0$var$padding[spacing],
        verticalAlign: $3a3f04ffda0438f0$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $3a3f04ffda0438f0$var$selectedStyles : {
            ...appearance === 'default' && $3a3f04ffda0438f0$var$defaultStyles,
            ...appearance === 'primary' && $3a3f04ffda0438f0$var$primaryStyles,
            ...appearance === 'link' && $3a3f04ffda0438f0$var$linkStyles,
            ...appearance === 'subtle' && $3a3f04ffda0438f0$var$subtleStyles,
            ...appearance === 'subtle-link' && $3a3f04ffda0438f0$var$subtleLinkStyles,
            ...appearance === 'warning' && $3a3f04ffda0438f0$var$warningStyles,
            ...appearance === 'danger' && $3a3f04ffda0438f0$var$dangerStyles,
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $3a3f04ffda0438f0$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $3a3f04ffda0438f0$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $3a3f04ffda0438f0$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
                }
            },
            ...$3a3f04ffda0438f0$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}
function $3a3f04ffda0438f0$export$864eea3f4ec3368f({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $1NIU8.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $3a3f04ffda0438f0$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $3a3f04ffda0438f0$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $3a3f04ffda0438f0$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $3a3f04ffda0438f0$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
const $3a3f04ffda0438f0$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});

parcelRegister("dy5Kp", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $b29219c524f6603d$export$20bbd2efb0d734c4);

var $eJOHy = parcelRequire("eJOHy");

var $6fs4r = parcelRequire("6fs4r");
const $b29219c524f6603d$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $eJOHy.isValidElement)(children) && children.type === (0, $6fs4r.default);
};

});


parcelRegister("5xD8j", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb4749b151756606$export$2e2bcd8739ae039);

var $dy5Kp = parcelRequire("dy5Kp");
function $eb4749b151756606$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $dy5Kp.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("2re7G", function(module, exports) {
$parcel$export(module.exports, "default", () => $e72b7918776688ea$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");
function $e72b7918776688ea$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $e72b7918776688ea$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
        size: size,
        label: ", Loading",
        appearance: $e72b7918776688ea$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("7ep4S", function(module, exports) {
$parcel$export(module.exports, "default", () => $240a8f26aa5fc268$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $d0Gew = parcelRequire("d0Gew");


var $ciXjS = parcelRequire("ciXjS");
/**
 * Returns the appropriate circle stroke color.
 */ function $240a8f26aa5fc268$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? `var(--ds-icon-subtle, ${0, $7bb4c1736002a04a$export$c39c0fe0f26207ae})` : `var(--ds-icon-inverse, ${0, $7bb4c1736002a04a$export$29a4f05edc054374})`;
}
const $240a8f26aa5fc268$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ const $240a8f26aa5fc268$var$loadIn = null;
const $240a8f26aa5fc268$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $240a8f26aa5fc268$var$useLayoutEffect = typeof window === 'undefined' ? (0, $eJOHy.useEffect) : (0, $eJOHy.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ const $240a8f26aa5fc268$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $ciXjS.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $240a8f26aa5fc268$var$getStrokeColor(appearance);
    const context = (0, $eJOHy.useContext)((0, $d0Gew.default));
    $240a8f26aa5fc268$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $hcewu.default)([
            $240a8f26aa5fc268$var$styles.wrapperStyles,
            $240a8f26aa5fc268$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $hcewu.default)([
                $240a8f26aa5fc268$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $hcewu.default)([
                    $240a8f26aa5fc268$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $240a8f26aa5fc268$export$2e2bcd8739ae039 = $240a8f26aa5fc268$var$Spinner;

});
parcelRegister("ciXjS", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $da84f353adb3c759$export$4e9f1640bbe7a1a8);
const $da84f353adb3c759$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("lBX28", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", () => $b6040c9f87f32659$export$643db0b8d8778e);
$parcel$export(module.exports, "defaultThemeFn", () => $b6040c9f87f32659$export$437a7f77d13d7916);
$parcel$export(module.exports, "default", () => $b6040c9f87f32659$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $iMaCz = parcelRequire("iMaCz");

var $dtCDi = parcelRequire("dtCDi");
const $b6040c9f87f32659$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $b6040c9f87f32659$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', mode: mode = 'light', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $dtCDi.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $b6040c9f87f32659$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $b6040c9f87f32659$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $b6040c9f87f32659$export$437a7f77d13d7916(current, values) {
    return current(values);
}
const $b6040c9f87f32659$var$Theme = (0, $iMaCz.createTheme)((themeProps)=>({
        buttonStyles: $b6040c9f87f32659$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b6040c9f87f32659$export$2e2bcd8739ae039 = $b6040c9f87f32659$var$Theme;

});


parcelRegister("3Qkuo", function(module, exports) {
$parcel$export(module.exports, "flagBackgroundColor", () => $757b9ecc0cfe18dc$export$59e42969c95d314);
$parcel$export(module.exports, "flagIconColor", () => $757b9ecc0cfe18dc$export$7f70afe2167f8235);
$parcel$export(module.exports, "flagIconGlyph", () => $757b9ecc0cfe18dc$export$73f08aee70487cd4);
$parcel$export(module.exports, "flagTextColor", () => $757b9ecc0cfe18dc$export$f50075b2584087f);
$parcel$export(module.exports, "flagTextColorToken", () => $757b9ecc0cfe18dc$export$13b42cd9d596bfe0);
$parcel$export(module.exports, "actionBackgroundColor", () => $757b9ecc0cfe18dc$export$81ba6b63eedb299f);
$parcel$export(module.exports, "actionTextColor", () => $757b9ecc0cfe18dc$export$7bcfe3cca4dd78b6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1NG86 = parcelRequire("1NG86");

var $i4Iw4 = parcelRequire("i4Iw4");

var $3TFuO = parcelRequire("3TFuO");

var $jkYbX = parcelRequire("jkYbX");

const $757b9ecc0cfe18dc$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};
const $757b9ecc0cfe18dc$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};
const $757b9ecc0cfe18dc$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
        LEGACY_secondaryColor: "var(--ds-background-danger-bold, #C9372C)"
    }),
    info: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
        LEGACY_secondaryColor: "var(--ds-background-neutral-bold, #292A2E)"
    }),
    normal: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
        LEGACY_secondaryColor: "var(--ds-surface-overlay, #FFFFFF)"
    }),
    success: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
        LEGACY_secondaryColor: "var(--ds-background-success-bold, #5B7F24)"
    }),
    warning: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-warning-inverse, ${(0, $7bb4c1736002a04a$export$ad0bacf983b7ddaa)})`,
        LEGACY_secondaryColor: "var(--ds-background-warning-bold, #FBC828)"
    })
};
const $757b9ecc0cfe18dc$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};
const $757b9ecc0cfe18dc$export$13b42cd9d596bfe0 = {
    error: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    info: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    normal: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`,
    success: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $7bb4c1736002a04a$export$ad0bacf983b7ddaa)})`
};
const $757b9ecc0cfe18dc$export$81ba6b63eedb299f = {
    success: {
        default: `var(--ds-background-inverse-subtle, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`
    },
    info: {
        default: `var(--ds-background-inverse-subtle, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`
    },
    error: {
        default: `var(--ds-background-inverse-subtle, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`
    },
    warning: {
        default: `var(--ds-background-inverse-subtle, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};
const $757b9ecc0cfe18dc$export$7bcfe3cca4dd78b6 = {
    success: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    info: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    error: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $7bb4c1736002a04a$export$ad0bacf983b7ddaa)})`,
    normal: `var(--ds-link, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`
};

});


parcelRegister("gPCVG", function(module, exports) {
$parcel$export(module.exports, "useFlagGroup", () => $26a219186beb23d3$export$e91ea202abb66350);
$parcel$export(module.exports, "default", () => $26a219186beb23d3$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Vuhz = parcelRequire("3Vuhz");

var $Ys7jv = parcelRequire("Ys7jv");
var $8UpxG = parcelRequire("8UpxG");

var $67YQP = parcelRequire("67YQP");

var $IW7jS = parcelRequire("IW7jS");

var $6fs4r = parcelRequire("6fs4r");
const $26a219186beb23d3$export$1eee5ddc4f6d41c5 = 400;
const $26a219186beb23d3$var$defaultFlagGroupContext = {
    onDismissed: (0, $3Vuhz.default),
    isDismissAllowed: false
};
const $26a219186beb23d3$export$c57ba665aaa722be = /*#__PURE__*/ (0, $eJOHy.createContext)($26a219186beb23d3$var$defaultFlagGroupContext);
function $26a219186beb23d3$export$e91ea202abb66350() {
    return (0, $eJOHy.useContext)($26a219186beb23d3$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $26a219186beb23d3$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $26a219186beb23d3$var$dismissAllowedStyles = null;
const $26a219186beb23d3$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ const $26a219186beb23d3$var$FlagGroup = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $3Vuhz.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $eJOHy.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $eJOHy.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8UpxG.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $hcewu.default)([
                            $26a219186beb23d3$var$groupStyles.root,
                            index === 0 && $26a219186beb23d3$var$groupStyles.first,
                            index === 1 && $26a219186beb23d3$var$groupStyles.second,
                            index >= 1 && $26a219186beb23d3$var$groupStyles.nth,
                            index >= 2 && $26a219186beb23d3$var$groupStyles.hidden,
                            isDismissAllowed && "_12a7luct",
                            className
                        ]),
                        ref: ref,
                        "data-vc-oob": true,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)($26a219186beb23d3$export$c57ba665aaa722be.Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : $26a219186beb23d3$var$defaultFlagGroupContext,
                            children: flag
                        })
                    })
            });
        }) : false;
    };
    const flags = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $hcewu.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(LabelTag, {
                    children: label
                })
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ys7jv.default), {
                appear: false,
                children: renderChildren()
            })
        ]
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
        zIndex: (0, $IW7jS.layers).flag(),
        children: flags
    });
};
var $26a219186beb23d3$export$2e2bcd8739ae039 = $26a219186beb23d3$var$FlagGroup;

});
parcelRegister("Ys7jv", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $0b7bd366f4926019$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $0b7bd366f4926019$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
// We define empty context here so the object doesn't change.
const $0b7bd366f4926019$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ const $0b7bd366f4926019$var$ExitingContext = /*#__PURE__*/ (0, $eJOHy.createContext)($0b7bd366f4926019$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $0b7bd366f4926019$var$wrapChildWithContextProvider = (child, value = $0b7bd366f4926019$var$emptyContext)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($0b7bd366f4926019$var$ExitingContext.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $0b7bd366f4926019$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $eJOHy.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $0b7bd366f4926019$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $0b7bd366f4926019$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $0b7bd366f4926019$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $0b7bd366f4926019$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $0b7bd366f4926019$var$ExitingPersistence = /*#__PURE__*/ (0, $eJOHy.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $eJOHy.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $eJOHy.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $eJOHy.useState)(()=>({
            appear: appear,
            isExiting: false
        }));
    (0, $eJOHy.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
		 * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
		 * useState is mocked to return a boolean value.
		 */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $0b7bd366f4926019$var$childrenToArray(previousChildren);
    const current = $0b7bd366f4926019$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    const missingKeys = $0b7bd366f4926019$var$getMissingKeys(current, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $0b7bd366f4926019$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        return $0b7bd366f4926019$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$0b7bd366f4926019$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
const $0b7bd366f4926019$export$3b6f38abbdcbd000 = ()=>{
    return (0, $eJOHy.useContext)($0b7bd366f4926019$var$ExitingContext);
};
$0b7bd366f4926019$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $0b7bd366f4926019$export$2e2bcd8739ae039 = $0b7bd366f4926019$var$ExitingPersistence;

});

parcelRegister("8UpxG", function(module, exports) {
$parcel$export(module.exports, "default", () => $415d7ea45b7ad021$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KOMj = parcelRequire("3KOMj");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ const $415d7ea45b7ad021$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KOMj.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
var $415d7ea45b7ad021$export$2e2bcd8739ae039 = $415d7ea45b7ad021$var$SlideIn;

});
parcelRegister("3KOMj", function(module, exports) {
$parcel$export(module.exports, "default", () => $546a4eee86d1fc03$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kk5YU = parcelRequire("kk5YU");

var $34ZNB = parcelRequire("34ZNB");

var $gcrIE = parcelRequire("gcrIE");

var $Ys7jv = parcelRequire("Ys7jv");

var $523vM = parcelRequire("523vM");
const $546a4eee86d1fc03$var$zoomIn = null;
const $546a4eee86d1fc03$var$zoomOut = null;
const $546a4eee86d1fc03$var$fadeIn = null;
const $546a4eee86d1fc03$var$fadeOut = null;
const $546a4eee86d1fc03$var$fadeInFromTop = null;
const $546a4eee86d1fc03$var$fadeOutFromTop = null;
const $546a4eee86d1fc03$var$fadeInFromLeft = null;
const $546a4eee86d1fc03$var$fadeOutFromLeft = null;
const $546a4eee86d1fc03$var$fadeInFromBottom = null;
const $546a4eee86d1fc03$var$fadeOutFromBottom = null;
const $546a4eee86d1fc03$var$fadeInFromRight = null;
const $546a4eee86d1fc03$var$fadeOutFromRight = null;
const $546a4eee86d1fc03$var$fadeInFromTopConstant = null;
const $546a4eee86d1fc03$var$fadeOutFromTopConstant = null;
const $546a4eee86d1fc03$var$fadeInFromLeftConstant = null;
const $546a4eee86d1fc03$var$fadeOutFromLeftConstant = null;
const $546a4eee86d1fc03$var$fadeInFromBottomConstant = null;
const $546a4eee86d1fc03$var$fadeOutFromBottomConstant = null;
const $546a4eee86d1fc03$var$fadeInFromRightConstant = null;
const $546a4eee86d1fc03$var$fadeOutFromRightConstant = null;
const $546a4eee86d1fc03$var$slideInFromTop = null;
const $546a4eee86d1fc03$var$slideOutFromTop = null;
const $546a4eee86d1fc03$var$slideInFromRight = null;
const $546a4eee86d1fc03$var$slideOutFromRight = null;
const $546a4eee86d1fc03$var$slideInFromBottom = null;
const $546a4eee86d1fc03$var$slideOutFromBottom = null;
const $546a4eee86d1fc03$var$slideInFromLeft = null;
const $546a4eee86d1fc03$var$slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const $546a4eee86d1fc03$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $523vM.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $Ys7jv.useExitingPersistence)();
    const setTimeout = (0, $gcrIE.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $eJOHy.useState)(appear);
    (0, $eJOHy.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion?.(state);
        };
        if ((0, $kk5YU.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $34ZNB.exitingDurations)[duration] : (0, $34ZNB.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $hcewu.default)([
            (0, $hcewu.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $hcewu.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $hcewu.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $hcewu.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $hcewu.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $hcewu.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $hcewu.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $hcewu.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $hcewu.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $hcewu.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $hcewu.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $hcewu.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $hcewu.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $hcewu.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $hcewu.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $hcewu.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $hcewu.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $hcewu.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $hcewu.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $hcewu.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $hcewu.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $hcewu.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $hcewu.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $hcewu.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $hcewu.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $hcewu.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $hcewu.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $hcewu.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $hcewu.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $hcewu.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $hcewu.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $hcewu.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $hcewu.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $hcewu.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $hcewu.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $hcewu.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $hcewu.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $hcewu.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $hcewu.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $hcewu.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $hcewu.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $hcewu.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $hcewu.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $hcewu.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $hcewu.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $hcewu.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $hcewu.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $hcewu.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $hcewu.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $hcewu.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $hcewu.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
var $546a4eee86d1fc03$export$2e2bcd8739ae039 = $546a4eee86d1fc03$var$EnteringMotion;

});
parcelRegister("kk5YU", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $328be7c5458fe05d$export$b7baf7667a68d87c);
$parcel$export(module.exports, "useIsReducedMotion", () => $328be7c5458fe05d$export$c537e63161742ce3);
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $328be7c5458fe05d$export$f0f789643ba5a83c);
$parcel$export(module.exports, "prefersReducedMotion", () => $328be7c5458fe05d$export$ff7706047246b98b);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");
const $328be7c5458fe05d$var$isMatchMediaAvailable = ()=>typeof window !== 'undefined' && 'matchMedia' in window;
const $328be7c5458fe05d$export$b7baf7667a68d87c = ()=>{
    if (!$328be7c5458fe05d$var$isMatchMediaAvailable()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};
const $328be7c5458fe05d$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $eJOHy.useState)($328be7c5458fe05d$export$b7baf7667a68d87c);
    (0, $eJOHy.useEffect)(()=>{
        if (!$328be7c5458fe05d$var$isMatchMediaAvailable()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $4eDgu.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
const $328be7c5458fe05d$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
const $328be7c5458fe05d$export$ff7706047246b98b = ()=>$328be7c5458fe05d$export$f0f789643ba5a83c;

});

parcelRegister("34ZNB", function(module, exports) {
$parcel$export(module.exports, "durations", () => $9046c6c4d7de0884$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $9046c6c4d7de0884$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $9046c6c4d7de0884$export$368bacef0dacbe05 = 25;
const $9046c6c4d7de0884$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $9046c6c4d7de0884$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $9046c6c4d7de0884$export$30fa1a2e62ae150c = {
    none: $9046c6c4d7de0884$export$38b928a7167ce124.none,
    small: $9046c6c4d7de0884$export$38b928a7167ce124.small * $9046c6c4d7de0884$var$EXITING_MOTION_MULTIPLIER,
    medium: $9046c6c4d7de0884$export$38b928a7167ce124.medium * $9046c6c4d7de0884$var$EXITING_MOTION_MULTIPLIER,
    large: $9046c6c4d7de0884$export$38b928a7167ce124.large * $9046c6c4d7de0884$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("gcrIE", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $b79721ea1937d104$export$1775f27e7c8051ca);
$parcel$export(module.exports, "useSetTimeout", () => $b79721ea1937d104$export$4f34107a2b00f39c);

var $eJOHy = parcelRequire("eJOHy");
const $b79721ea1937d104$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $b79721ea1937d104$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $eJOHy.useRef)([]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $b79721ea1937d104$var$getHookDeps(opts));
    return (0, $eJOHy.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
const $b79721ea1937d104$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $eJOHy.useRef)([]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $b79721ea1937d104$var$getHookDeps(opts));
    return (0, $eJOHy.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("523vM", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $24e86cb6fe644454$export$25c7213fc07ec080);
$parcel$export(module.exports, "default", () => $24e86cb6fe644454$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $5mfrv = parcelRequire("5mfrv");

var $7Nqnu = parcelRequire("7Nqnu");
const $24e86cb6fe644454$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $eJOHy.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $3Vuhz.default)
    }));
const $24e86cb6fe644454$export$25c7213fc07ec080 = ()=>{
    const indentifier = (0, $7Nqnu.useUniqueId)();
    const context = (0, $eJOHy.useContext)($24e86cb6fe644454$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $24e86cb6fe644454$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $eJOHy.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $eJOHy.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $5mfrv.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($24e86cb6fe644454$var$StaggeredEntranceContext.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
var $24e86cb6fe644454$export$2e2bcd8739ae039 = $24e86cb6fe644454$var$StaggeredEntrance;

});
parcelRegister("5mfrv", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $c48bafcb7d89af99$export$e5c5a5f917a5871c);

var $eJOHy = parcelRequire("eJOHy");
const $c48bafcb7d89af99$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $eJOHy.useEffect) : (0, $eJOHy.useLayoutEffect);

});

parcelRegister("7Nqnu", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $c7c26f4d6e24b2a8$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $eJOHy = parcelRequire("eJOHy");
function $c7c26f4d6e24b2a8$export$c485849f2e393253() {
    const identifier = (0, $eJOHy.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("67YQP", function(module, exports) {
$parcel$export(module.exports, "default", () => $51a617c913c1b19d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $jzlTq = parcelRequire("jzlTq");

var $ddj4K = parcelRequire("ddj4K");

var $fQhhF = parcelRequire("fQhhF");

var $9yvpy = parcelRequire("9yvpy");
function $51a617c913c1b19d$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect' }) {
    const isSubsequentRender = (0, $fQhhF.default)(mountStrategy);
    (0, $9yvpy.default)(zIndex);
    return !(0, $eGOwo.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jzlTq.default), {
        zIndex: zIndex,
        children: children
    }) : null : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ddj4K.default), {
        zIndex: zIndex,
        children: children
    });
}

});
parcelRegister("jzlTq", function(module, exports) {
$parcel$export(module.exports, "default", () => $72acedcbd3c5df72$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $l80Nr = parcelRequire("l80Nr");
function $72acedcbd3c5df72$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const container = (0, $eJOHy.useMemo)(()=>(0, $l80Nr.createContainer)(zIndex), [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $l80Nr.appendPortalContainerIfNotAppended)(container);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            (0, $l80Nr.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aQK2r.createPortal)(children, container);
}

});
parcelRegister("l80Nr", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $ec5b3599cc31102e$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $ec5b3599cc31102e$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $ec5b3599cc31102e$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $ec5b3599cc31102e$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $ec5b3599cc31102e$export$95029ca7aca2989e);

const $ec5b3599cc31102e$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $3d9529cd8ff26a50$export$13f57c02915787b3);
    container.style.zIndex = `${zIndex}`;
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $ec5b3599cc31102e$var$getBody = ()=>{
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ const $ec5b3599cc31102e$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $3d9529cd8ff26a50$export$72f415121273627e));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $3d9529cd8ff26a50$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        $ec5b3599cc31102e$var$getBody()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $ec5b3599cc31102e$export$da99f98bf3fe55b3 = (container)=>{
    $ec5b3599cc31102e$var$getPortalParent().removeChild(container);
};
const $ec5b3599cc31102e$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $ec5b3599cc31102e$var$getPortalParent().appendChild(container);
};
const $ec5b3599cc31102e$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $ec5b3599cc31102e$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($ec5b3599cc31102e$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $3d9529cd8ff26a50$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};
const $ec5b3599cc31102e$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($ec5b3599cc31102e$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $3d9529cd8ff26a50$export$72f415121273627e));
        if (!parentElement) {
            const parent = document.createElement('div');
            parent.className = (0, $3d9529cd8ff26a50$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            $ec5b3599cc31102e$var$getBody()?.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});
const $3d9529cd8ff26a50$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $3d9529cd8ff26a50$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $3d9529cd8ff26a50$export$13f57c02915787b3 = 'atlaskit-portal';



parcelRegister("ddj4K", function(module, exports) {
$parcel$export(module.exports, "default", () => $541118367f0532b4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $lWEHz = parcelRequire("lWEHz");

var $l80Nr = parcelRequire("l80Nr");
function $541118367f0532b4$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $eJOHy.useState)(null);
    (0, $lWEHz.useIsomorphicLayoutEffect)(()=>{
        const tempPortalContainer = (0, $l80Nr.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        const portalParent = (0, $l80Nr.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return ()=>{
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
	 * We wrap portal children with a Suspense boundary because in React 18 concurrent,
	 * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
	 * our portal gets in an infinite loop of rendering.
	 */ const suspendedChildren = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: children
    });
    return atlaskitPortal ? /*#__PURE__*/ (0, $aQK2r.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("lWEHz", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $cc13ebf906e61507$export$700979bc83e7db82);

var $eJOHy = parcelRequire("eJOHy");
const $cc13ebf906e61507$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $eJOHy.useLayoutEffect) : (0, $eJOHy.useEffect);

});


parcelRegister("fQhhF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce510458bfa25665$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lWEHz = parcelRequire("lWEHz");
const $ce510458bfa25665$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $eJOHy.useState)(false);
    const [useMountEffect] = (0, $eJOHy.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $lWEHz.useIsomorphicLayoutEffect) : (0, $eJOHy.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $ce510458bfa25665$export$2e2bcd8739ae039 = $ce510458bfa25665$var$useIsSubsequentRender;

});

parcelRegister("9yvpy", function(module, exports) {
$parcel$export(module.exports, "default", () => $fdea2a169c9334ed$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


var $icm2U = parcelRequire("icm2U");
const $fdea2a169c9334ed$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $eJOHy.useEffect)(()=>{
        (0, $icm2U.default)((0, $31a7f3563d375095$export$ed5835cc67e87f72), zIndexNumber);
        return ()=>{
            (0, $icm2U.default)((0, $31a7f3563d375095$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $fdea2a169c9334ed$export$2e2bcd8739ae039 = $fdea2a169c9334ed$var$useFirePortalEvent;

});
const $31a7f3563d375095$export$ed5835cc67e87f72 = 'akPortalMount';
const $31a7f3563d375095$export$80816bd900e5bd00 = 'akPortalUnmount';

parcelRegister("icm2U", function(module, exports) {
$parcel$export(module.exports, "default", () => $b243e3003fb494e7$export$2e2bcd8739ae039);
const $b243e3003fb494e7$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $b243e3003fb494e7$var$getLayerName = (zIndex)=>{
    return $b243e3003fb494e7$var$zIndexToName.hasOwnProperty(zIndex) ? $b243e3003fb494e7$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $b243e3003fb494e7$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $b243e3003fb494e7$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $b243e3003fb494e7$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $b243e3003fb494e7$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("IW7jS", function(module, exports) {
$parcel$export(module.exports, "noFocusRing", () => $0614d17fd9e23708$export$c0dd343266bc3261);
$parcel$export(module.exports, "layers", () => $0614d17fd9e23708$export$7be255094ccdc533);
$parcel$export(module.exports, "skeletonShimmer", () => $0614d17fd9e23708$export$e497e856b4f89fcd);

var $8ZvRN = parcelRequire("8ZvRN");

const $0614d17fd9e23708$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $0614d17fd9e23708$export$c93026a968943f95 = 'light';
const $0614d17fd9e23708$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $0614d17fd9e23708$export$8e24544ddba725ee = (color = `var(--ds-border-focused, ${0, $7bb4c1736002a04a$export$215b7063051591f1})`, outlineWidth = 2)=>{
    (0, $8ZvRN.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return `
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
  }
`;
};
const $0614d17fd9e23708$export$c0dd343266bc3261 = ()=>`
  box-shadow: none;
`;
const $0614d17fd9e23708$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};
const $0614d17fd9e23708$export$a1b3edb637fb4f35 = ()=>{
    (0, $8ZvRN.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
const $0614d17fd9e23708$export$ba1d834b86d72a09 = $0614d17fd9e23708$export$a1b3edb637fb4f35;
const $0614d17fd9e23708$export$e497e856b4f89fcd = ()=>({
        css: {
            backgroundColor: `var(--ds-skeleton, ${0, $7bb4c1736002a04a$export$8d43898f60b96a82})`,
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: `var(--ds-skeleton, ${0, $7bb4c1736002a04a$export$8d43898f60b96a82})`
            },
            to: {
                backgroundColor: `var(--ds-skeleton-subtle, ${0, $7bb4c1736002a04a$export$920c0d5c49070351})`
            }
        }
    });

});
parcelRegister("8ZvRN", function(module, exports) {
$parcel$export(module.exports, "default", () => $52bdbfafb0e2d997$export$2e2bcd8739ae039);

var $4tAXJ = parcelRequire("4tAXJ");

var $igDjg = parcelRequire("igDjg");
function $52bdbfafb0e2d997$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $4tAXJ.default)(`[${packageName}]: The ${api} is deprecated.${additionalMessage && ` ${additionalMessage}`}`);
}
function $52bdbfafb0e2d997$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $igDjg;
}

});
parcelRegister("4tAXJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e6b08fdfaa8f022$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $9e6b08fdfaa8f022$var$printed = {};
function $9e6b08fdfaa8f022$export$2e2bcd8739ae039(message) {
    if ($9e6b08fdfaa8f022$var$printed[message]) return;
    $9e6b08fdfaa8f022$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});




parcelRegister("kB33F", function(module, exports) {
$parcel$export(module.exports, "default", () => $65c18a1e37a66588$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6BxzS = parcelRequire("6BxzS");

var $jAF24 = parcelRequire("jAF24");

var $6J9k6 = parcelRequire("6J9k6");

var $3Qkuo = parcelRequire("3Qkuo");
const $65c18a1e37a66588$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6)));
    let buttonLabel = 'Dismiss';
    let size = 'small';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($jAF24))) : (0, (/*@__PURE__*/$parcel$interopDefault($6BxzS)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        size = 'medium';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)(ButtonIcon, {
                ...iconProps,
                LEGACY_size: size,
                size: "small",
                label: "",
                color: (0, $3Qkuo.flagTextColorToken)[appearance]
            }),
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
const $65c18a1e37a66588$var$DismissButton = /*#__PURE__*/ (0, $eJOHy.memo)($65c18a1e37a66588$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$65c18a1e37a66588$export$2e2bcd8739ae039 = $65c18a1e37a66588$var$DismissButton;

});
parcelRegister("Ay1uj", function(module, exports) {
$parcel$export(module.exports, "default", () => $707b992054fa9d5a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gyJTO = parcelRequire("gyJTO");

var $k71qx = parcelRequire("k71qx");

var $6fs4r = parcelRequire("6fs4r");

var $linPv = parcelRequire("linPv");

var $9fToX = parcelRequire("9fToX");

var $2RUos = parcelRequire("2RUos");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $707b992054fa9d5a$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $linPv.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9fToX.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2RUos.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        shortcut: tooltip?.shortcut,
        children: (triggerProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $linPv.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    onClick?.(e, analyticsEvent);
                    triggerProps.onClick?.(e);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                ref: (0, $gyJTO.default)([
                    ref,
                    triggerProps?.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9fToX.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2RUos.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$707b992054fa9d5a$var$IconButton.displayName = 'IconButton';
var $707b992054fa9d5a$export$2e2bcd8739ae039 = $707b992054fa9d5a$var$IconButton;

});
parcelRegister("gyJTO", function(module, exports) {
$parcel$export(module.exports, "default", () => $06b1bc6e20dec309$export$2e2bcd8739ae039);
function $06b1bc6e20dec309$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("k71qx", function(module, exports) {
$parcel$export(module.exports, "default", () => $008cc98e87f23eb3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $ixFlz = parcelRequire("ixFlz");

var $3Vuhz = parcelRequire("3Vuhz");

var $eRny2 = parcelRequire("eRny2");

var $4X7Tx = parcelRequire("4X7Tx");

var $5NYi5 = parcelRequire("5NYi5");

var $Ys7jv = parcelRequire("Ys7jv");
var $2rPSy = parcelRequire("2rPSy");

var $eGOwo = parcelRequire("eGOwo");

var $8qmYl = parcelRequire("8qmYl");

var $67YQP = parcelRequire("67YQP");

var $IW7jS = parcelRequire("IW7jS");

var $aide1 = parcelRequire("aide1");

var $8hVap = parcelRequire("8hVap");

var $bfK28 = parcelRequire("bfK28");

var $39kdz = parcelRequire("39kdz");

var $02Gft = parcelRequire("02Gft");
const $008cc98e87f23eb3$var$tooltipZIndex = (0, $IW7jS.layers).tooltip();
const $008cc98e87f23eb3$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
// Inverts motion direction
const $008cc98e87f23eb3$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $008cc98e87f23eb3$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $008cc98e87f23eb3$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $39kdz.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $3Vuhz.default), onHide: onHide = (0, $3Vuhz.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false, shortcut: shortcut }) {
    const tooltipPosition = position === 'mouse' ? mousePosition : position;
    const onShowHandler = (0, $ixFlz.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$008cc98e87f23eb3$var$analyticsAttributes
    });
    const onHideHandler = (0, $ixFlz.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$008cc98e87f23eb3$var$analyticsAttributes
    });
    const apiRef = (0, $eJOHy.useRef)(null);
    const [state, setState] = (0, $eJOHy.useState)('hide');
    const targetRef = (0, $eJOHy.useRef)(null);
    const containerRef = (0, $eJOHy.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $eJOHy.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $4X7Tx.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $4X7Tx.default)(onShowHandler);
    const onHideHandlerStable = (0, $4X7Tx.default)(onHideHandler);
    const delayStable = (0, $4X7Tx.default)(delay);
    const canAppearStable = (0, $4X7Tx.default)(canAppear);
    const hasCalledShowHandler = (0, $eJOHy.useRef)(false);
    const start = (0, $eJOHy.useCallback)((api)=>{
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $eJOHy.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $eJOHy.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $eJOHy.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        return (0, $aide1.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const tryShowTooltip = (0, $eJOHy.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        const api = (0, $8hVap.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    const hideTooltipOnEsc = (0, $eJOHy.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $eRny2.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $eJOHy.useEffect)(()=>{
        if (state === 'hide') return 0, $3Vuhz.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $4eDgu.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $eJOHy.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $02Gft.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $eJOHy.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = position === 'mouse' ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePosition = (0, $02Gft.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    const onMouseOverTooltip = (0, $eJOHy.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $eJOHy.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible') && (0, $eGOwo.fg)('platform-tooltip-focus-visible-new')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $eJOHy.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $eJOHy.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    const handleOpenLayerObserverCloseSignal = (0, $eJOHy.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $5NYi5.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (position === 'mouse' && apiRef.current?.mousePosition) return apiRef.current?.mousePosition;
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $bfK28.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = `${testId}--container`;
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $eJOHy.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
            // attribute back into the tooltipTriggerProps and make it required
            // instead of optional in `types`
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    children({
                        ...tooltipTriggerProps,
                        'aria-describedby': tooltipIdForHiddenContent,
                        ref: setDirectRef
                    }),
                    hiddenContent
                ]
            }) : // @ts-ignore
            /*#__PURE__*/ (0, $gt9Am.jsxs)(CastTargetContainer, {
                ...tooltipTriggerProps,
                ref: setImplicitRefFromChildren,
                /**
     * TODO: Why is role="presentation" added?
     * - Is it only to "remove" the `Container` from screen readers?
     * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
     * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
     */ role: "presentation",
                children: [
                    children,
                    hiddenContent
                ]
            }),
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
                zIndex: $008cc98e87f23eb3$var$tooltipZIndex,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8qmYl.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        // Invert the entrance and exit directions.
                        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
                        // This gives the effect the tooltip is appearing from the target
                        const direction = position === 'mouse' ? undefined : $008cc98e87f23eb3$var$invertedDirection[$008cc98e87f23eb3$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ys7jv.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2rPSy.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $gt9Am.jsx)(Container, {
                                        ref: ref,
                                        /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        shortcut: shortcut,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
var $008cc98e87f23eb3$export$2e2bcd8739ae039 = $008cc98e87f23eb3$var$Tooltip;

});
parcelRegister("ixFlz", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $0068072ffa20b4bc$export$1a04351537078b55);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $gAkni = parcelRequire("gAkni");
function $0068072ffa20b4bc$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $gAkni.useTrackedRef)(analyticsData);
    const fnRef = (0, $gAkni.useTrackedRef)(fn);
    const handler = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("eRny2", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cd7584b898bad5e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

function $3cd7584b898bad5e$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $eJOHy.useRef)(false);
    const onKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $9f42f4c07a71299e$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $eJOHy.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $4eDgu.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $9f42f4c07a71299e$export$390330c10ff2b9a1 = 'ArrowUp';
const $9f42f4c07a71299e$export$a80636c6f41931fe = 'ArrowDown';
const $9f42f4c07a71299e$export$4af703091671bc = 'Home';
const $9f42f4c07a71299e$export$e2bc30913faa5db7 = 'End';
const $9f42f4c07a71299e$export$10f6869ed0a7d75b = 'Tab';
const $9f42f4c07a71299e$export$8152f929a25a0ff4 = 'Enter';
const $9f42f4c07a71299e$export$e51a3576c045c8d5 = 'Space';
const $9f42f4c07a71299e$export$2bb790b9008907b4 = 'Escape';


parcelRegister("4X7Tx", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca8b268473a3bea9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $ca8b268473a3bea9$export$2e2bcd8739ae039(value) {
    const ref = (0, $eJOHy.useRef)(value);
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("5NYi5", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $feed0d39fc10eb7a$export$469bb693f11edc7f);

var $eJOHy = parcelRequire("eJOHy");

var $7UPzw = parcelRequire("7UPzw");

var $5aMjU = parcelRequire("5aMjU");
function $feed0d39fc10eb7a$export$469bb693f11edc7f({ isOpen: isOpen, type: type, onClose: onClose }) {
    const context = (0, $eJOHy.useContext)((0, $7UPzw.OpenLayerObserverContext));
    const namespace = (0, $5aMjU.useOpenLayerObserverNamespace)();
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * Registers the `onClose` callback with the OpenLayerObserver.
		 */ if (context === null) return;
        if (!isOpen) /**
			 * If the layer is not open, we are not registering the `onClose` callback.
			 * This is important to prevent the `onClose` from being called for layers that
			 * are not open.
			 *
			 * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
			 * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
			 */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("7UPzw", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $e1618b13e9ddae95$export$5fbf4d7fae6cdc00);

var $eJOHy = parcelRequire("eJOHy");
const $e1618b13e9ddae95$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);

});

parcelRegister("5aMjU", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $d068eee842b20497$export$1d57e79091cc3046);

var $eJOHy = parcelRequire("eJOHy");

var $bKvRZ = parcelRequire("bKvRZ");
function $d068eee842b20497$export$1d57e79091cc3046() {
    const namespace = (0, $eJOHy.useContext)((0, $bKvRZ.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("bKvRZ", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $743143e4aa2d0e73$export$644a49f3b8c50fcd);

var $eJOHy = parcelRequire("eJOHy");
const $743143e4aa2d0e73$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $eJOHy.createContext)(null);

});



parcelRegister("2rPSy", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a267e00413d8e4d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KOMj = parcelRequire("3KOMj");
const $2a267e00413d8e4d$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $2a267e00413d8e4d$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $2a267e00413d8e4d$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KOMj.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $2a267e00413d8e4d$export$2e2bcd8739ae039 = $2a267e00413d8e4d$var$FadeIn;

});

parcelRegister("8qmYl", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $12177abb1cfc1baf$export$badac9ada3a0bdf9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Jo1J = parcelRequire("3Jo1J");

var $eSm62 = parcelRequire("eSm62");

var $fvBjg = parcelRequire("fvBjg");
const $12177abb1cfc1baf$var$viewportPadding = 5;
const $12177abb1cfc1baf$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $12177abb1cfc1baf$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $12177abb1cfc1baf$var$defaultChildrenFn() {
    return null;
}
const $12177abb1cfc1baf$var$defaultOffset = [
    0,
    8
];
function $12177abb1cfc1baf$export$badac9ada3a0bdf9({ children: children = $12177abb1cfc1baf$var$defaultChildrenFn, offset: offset = $12177abb1cfc1baf$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $eJOHy.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $12177abb1cfc1baf$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $eSm62.getMaxSizeModifiers)({
            viewportPadding: $12177abb1cfc1baf$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [
            ...$12177abb1cfc1baf$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $eJOHy.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Jo1J.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}

});
parcelRegister("3Jo1J", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $2b78364cabec4d4e$export$badac9ada3a0bdf9);

var $eJOHy = parcelRequire("eJOHy");

var $6G5P1 = parcelRequire("6G5P1");

var $hBwkR = parcelRequire("hBwkR");

var $2j4bI = parcelRequire("2j4bI");
var $2b78364cabec4d4e$var$NOOP = function NOOP() {
    return void 0;
};
var $2b78364cabec4d4e$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $2b78364cabec4d4e$var$EMPTY_MODIFIERS = [];
function $2b78364cabec4d4e$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $2b78364cabec4d4e$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eJOHy.useContext((0, $6G5P1.ManagerReferenceNodeContext));
    var _React$useState = $eJOHy.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eJOHy.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eJOHy.useEffect(function() {
        (0, $hBwkR.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eJOHy.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $2j4bI.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eJOHy.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $2b78364cabec4d4e$var$NOOP,
            update: update || $2b78364cabec4d4e$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $hBwkR.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("6G5P1", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $4dcb2e6b3dfedbc8$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $4dcb2e6b3dfedbc8$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $4dcb2e6b3dfedbc8$export$d0d38e7dec7a1a61);

var $eJOHy = parcelRequire("eJOHy");
var $4dcb2e6b3dfedbc8$export$3dbd3405086fec7b = $eJOHy.createContext();
var $4dcb2e6b3dfedbc8$export$cbabb21c2529b130 = $eJOHy.createContext();
function $4dcb2e6b3dfedbc8$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eJOHy.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eJOHy.useRef(false);
    $eJOHy.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eJOHy.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eJOHy.createElement($4dcb2e6b3dfedbc8$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eJOHy.createElement($4dcb2e6b3dfedbc8$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("hBwkR", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $cd0ef989a3bd6729$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $cd0ef989a3bd6729$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $cd0ef989a3bd6729$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $cd0ef989a3bd6729$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $cd0ef989a3bd6729$export$700979bc83e7db82);

var $eJOHy = parcelRequire("eJOHy");
var $cd0ef989a3bd6729$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $cd0ef989a3bd6729$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $cd0ef989a3bd6729$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $cd0ef989a3bd6729$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $cd0ef989a3bd6729$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $cd0ef989a3bd6729$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eJOHy.useLayoutEffect : $eJOHy.useEffect;

});

parcelRegister("2j4bI", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $1ae09ac46ed678cd$export$f4d5bf230a36dd6e);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $7czdE = parcelRequire("7czdE");

var $aVrYR = parcelRequire("aVrYR");

var $hBwkR = parcelRequire("hBwkR");
var $1ae09ac46ed678cd$var$EMPTY_MODIFIERS = [];
var $1ae09ac46ed678cd$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eJOHy.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $1ae09ac46ed678cd$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eJOHy.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eJOHy.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $aQK2r.flushSync(function() {
                    setState({
                        styles: (0, $hBwkR.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $hBwkR.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eJOHy.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($aVrYR)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eJOHy.useRef();
    (0, $hBwkR.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $hBwkR.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $7czdE.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("7czdE", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $53e4f9340c9202c5$export$8f7491d57c8f97a9);

var $ljcYU = parcelRequire("ljcYU");

var $1KSPr = parcelRequire("1KSPr");

var $cHY15 = parcelRequire("cHY15");

var $kHUUW = parcelRequire("kHUUW");

var $cjG2E = parcelRequire("cjG2E");

var $i6eeB = parcelRequire("i6eeB");

var $cYCgi = parcelRequire("cYCgi");

var $90Lgd = parcelRequire("90Lgd");

var $3oZ0c = parcelRequire("3oZ0c");

var $66tHb = parcelRequire("66tHb");


var $53e4f9340c9202c5$export$d34966752335dd47 = [
    (0, $1KSPr.default),
    (0, $cHY15.default),
    (0, $kHUUW.default),
    (0, $cjG2E.default),
    (0, $i6eeB.default),
    (0, $cYCgi.default),
    (0, $90Lgd.default),
    (0, $3oZ0c.default),
    (0, $66tHb.default)
];
var $53e4f9340c9202c5$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $ljcYU.popperGenerator)({
    defaultModifiers: $53e4f9340c9202c5$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("ljcYU", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $f835712850e424ae$export$ed5e13716264f202);

var $6oEIn = parcelRequire("6oEIn");

var $5tbj5 = parcelRequire("5tbj5");

var $jeaDx = parcelRequire("jeaDx");

var $3kRx7 = parcelRequire("3kRx7");

var $9aZXl = parcelRequire("9aZXl");

var $kHgo1 = parcelRequire("kHgo1");

var $4Vc4y = parcelRequire("4Vc4y");


var $kEd3m = parcelRequire("kEd3m");
var $f835712850e424ae$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $f835712850e424ae$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $f835712850e424ae$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $f835712850e424ae$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $f835712850e424ae$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $kEd3m.isElement)(reference) ? (0, $jeaDx.default)(reference) : reference.contextElement ? (0, $jeaDx.default)(reference.contextElement) : [],
                    popper: (0, $jeaDx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $9aZXl.default)((0, $4Vc4y.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$f835712850e424ae$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $6oEIn.default)(reference, (0, $3kRx7.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $5tbj5.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $kHgo1.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$f835712850e424ae$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $f835712850e424ae$export$8f7491d57c8f97a9 = /*#__PURE__*/ $f835712850e424ae$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("6oEIn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a849116772c2a6e$export$2e2bcd8739ae039);

var $8FF70 = parcelRequire("8FF70");

var $gKcLM = parcelRequire("gKcLM");

var $cI546 = parcelRequire("cI546");

var $kEd3m = parcelRequire("kEd3m");

var $1fs2F = parcelRequire("1fs2F");

var $9qDuy = parcelRequire("9qDuy");

var $chhik = parcelRequire("chhik");

var $3Kywr = parcelRequire("3Kywr");
function $4a849116772c2a6e$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3Kywr.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3Kywr.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $4a849116772c2a6e$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $kEd3m.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $kEd3m.isHTMLElement)(offsetParent) && $4a849116772c2a6e$var$isElementScaled(offsetParent);
    var documentElement = (0, $9qDuy.default)(offsetParent);
    var rect = (0, $8FF70.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $cI546.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $chhik.default)(documentElement)) scroll = (0, $gKcLM.default)(offsetParent);
        if ((0, $kEd3m.isHTMLElement)(offsetParent)) {
            offsets = (0, $8FF70.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $1fs2F.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("8FF70", function(module, exports) {
$parcel$export(module.exports, "default", () => $65020b12f0e2ae2b$export$2e2bcd8739ae039);

var $kEd3m = parcelRequire("kEd3m");

var $3Kywr = parcelRequire("3Kywr");

var $35Qia = parcelRequire("35Qia");

var $c9s4k = parcelRequire("c9s4k");
function $65020b12f0e2ae2b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $kEd3m.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3Kywr.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3Kywr.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $kEd3m.isElement)(element) ? (0, $35Qia.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $c9s4k.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("kEd3m", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $f081ab266589cbd6$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $f081ab266589cbd6$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $f081ab266589cbd6$export$af51f0f06c0f328a);

var $35Qia = parcelRequire("35Qia");
function $f081ab266589cbd6$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $35Qia.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f081ab266589cbd6$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $35Qia.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f081ab266589cbd6$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $35Qia.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("35Qia", function(module, exports) {
$parcel$export(module.exports, "default", () => $240a66d80d18a0be$export$2e2bcd8739ae039);
function $240a66d80d18a0be$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("3Kywr", function(module, exports) {
$parcel$export(module.exports, "max", () => $2bb07265b9444e03$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $2bb07265b9444e03$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $2bb07265b9444e03$export$2077e0241d6afd3c);
var $2bb07265b9444e03$export$8960430cfd85939f = Math.max;
var $2bb07265b9444e03$export$96ec731ed4dcb222 = Math.min;
var $2bb07265b9444e03$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("c9s4k", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d8c1930df035210$export$2e2bcd8739ae039);

var $cHgMe = parcelRequire("cHgMe");
function $8d8c1930df035210$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $cHgMe.default)());
}

});
parcelRegister("cHgMe", function(module, exports) {
$parcel$export(module.exports, "default", () => $93e683bdbce339c0$export$2e2bcd8739ae039);
function $93e683bdbce339c0$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("gKcLM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c30ad900076e5559$export$2e2bcd8739ae039);

var $eJdHM = parcelRequire("eJdHM");

var $35Qia = parcelRequire("35Qia");

var $kEd3m = parcelRequire("kEd3m");

var $f0UdY = parcelRequire("f0UdY");
function $c30ad900076e5559$export$2e2bcd8739ae039(node) {
    if (node === (0, $35Qia.default)(node) || !(0, $kEd3m.isHTMLElement)(node)) return (0, $eJdHM.default)(node);
    else return (0, $f0UdY.default)(node);
}

});
parcelRegister("eJdHM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab8fe6380361db67$export$2e2bcd8739ae039);

var $35Qia = parcelRequire("35Qia");
function $ab8fe6380361db67$export$2e2bcd8739ae039(node) {
    var win = (0, $35Qia.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("f0UdY", function(module, exports) {
$parcel$export(module.exports, "default", () => $aee2781e5f78a767$export$2e2bcd8739ae039);
function $aee2781e5f78a767$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("cI546", function(module, exports) {
$parcel$export(module.exports, "default", () => $940d85ec63720e60$export$2e2bcd8739ae039);
function $940d85ec63720e60$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("1fs2F", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e8cf1bc2fa6285c$export$2e2bcd8739ae039);

var $8FF70 = parcelRequire("8FF70");

var $9qDuy = parcelRequire("9qDuy");

var $eJdHM = parcelRequire("eJdHM");
function $0e8cf1bc2fa6285c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $8FF70.default)((0, $9qDuy.default)(element)).left + (0, $eJdHM.default)(element).scrollLeft;
}

});
parcelRegister("9qDuy", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dd52d098492b4b1$export$2e2bcd8739ae039);

var $kEd3m = parcelRequire("kEd3m");
function $6dd52d098492b4b1$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $kEd3m.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("chhik", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f047ce6a299c44f$export$2e2bcd8739ae039);

var $5M0lG = parcelRequire("5M0lG");
function $8f047ce6a299c44f$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5M0lG.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("5M0lG", function(module, exports) {
$parcel$export(module.exports, "default", () => $4341b4b1d74d00bb$export$2e2bcd8739ae039);

var $35Qia = parcelRequire("35Qia");
function $4341b4b1d74d00bb$export$2e2bcd8739ae039(element) {
    return (0, $35Qia.default)(element).getComputedStyle(element);
}

});



parcelRegister("5tbj5", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fb86e79ee62f172$export$2e2bcd8739ae039);

var $8FF70 = parcelRequire("8FF70");
function $3fb86e79ee62f172$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $8FF70.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("jeaDx", function(module, exports) {
$parcel$export(module.exports, "default", () => $dff7935d1ffca6eb$export$2e2bcd8739ae039);

var $ltLKK = parcelRequire("ltLKK");

var $ivaWs = parcelRequire("ivaWs");

var $35Qia = parcelRequire("35Qia");

var $chhik = parcelRequire("chhik");
function $dff7935d1ffca6eb$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $ltLKK.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $35Qia.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $chhik.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($dff7935d1ffca6eb$export$2e2bcd8739ae039((0, $ivaWs.default)(target)));
}

});
parcelRegister("ltLKK", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa315928c5076e68$export$2e2bcd8739ae039);

var $ivaWs = parcelRequire("ivaWs");

var $chhik = parcelRequire("chhik");

var $cI546 = parcelRequire("cI546");

var $kEd3m = parcelRequire("kEd3m");
function $fa315928c5076e68$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $cI546.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $kEd3m.isHTMLElement)(node) && (0, $chhik.default)(node)) return node;
    return $fa315928c5076e68$export$2e2bcd8739ae039((0, $ivaWs.default)(node));
}

});
parcelRegister("ivaWs", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7839c155f77ea21$export$2e2bcd8739ae039);

var $cI546 = parcelRequire("cI546");

var $9qDuy = parcelRequire("9qDuy");

var $kEd3m = parcelRequire("kEd3m");
function $d7839c155f77ea21$export$2e2bcd8739ae039(element) {
    if ((0, $cI546.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $kEd3m.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $9qDuy.default)(element) // fallback
    );
}

});



parcelRegister("3kRx7", function(module, exports) {
$parcel$export(module.exports, "default", () => $26dcc3f0b7c11b68$export$2e2bcd8739ae039);

var $35Qia = parcelRequire("35Qia");

var $cI546 = parcelRequire("cI546");

var $5M0lG = parcelRequire("5M0lG");

var $kEd3m = parcelRequire("kEd3m");

var $c1Zvu = parcelRequire("c1Zvu");

var $ivaWs = parcelRequire("ivaWs");

var $cHgMe = parcelRequire("cHgMe");
function $26dcc3f0b7c11b68$var$getTrueOffsetParent(element) {
    if (!(0, $kEd3m.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5M0lG.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $26dcc3f0b7c11b68$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $cHgMe.default)());
    var isIE = /Trident/i.test((0, $cHgMe.default)());
    if (isIE && (0, $kEd3m.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5M0lG.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $ivaWs.default)(element);
    if ((0, $kEd3m.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $kEd3m.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $cI546.default)(currentNode)) < 0){
        var css = (0, $5M0lG.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $26dcc3f0b7c11b68$export$2e2bcd8739ae039(element) {
    var window = (0, $35Qia.default)(element);
    var offsetParent = $26dcc3f0b7c11b68$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $c1Zvu.default)(offsetParent) && (0, $5M0lG.default)(offsetParent).position === 'static')offsetParent = $26dcc3f0b7c11b68$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $cI546.default)(offsetParent) === 'html' || (0, $cI546.default)(offsetParent) === 'body' && (0, $5M0lG.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $26dcc3f0b7c11b68$var$getContainingBlock(element) || window;
}

});
parcelRegister("c1Zvu", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c254a09cf845192$export$2e2bcd8739ae039);

var $cI546 = parcelRequire("cI546");
function $8c254a09cf845192$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $cI546.default)(element)) >= 0;
}

});


parcelRegister("9aZXl", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ae51b6ac1966051$export$2e2bcd8739ae039);

var $fvBjg = parcelRequire("fvBjg");
function $6ae51b6ac1966051$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $6ae51b6ac1966051$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $6ae51b6ac1966051$var$order(modifiers); // order based on phase
    return (0, $fvBjg.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("fvBjg", function(module, exports) {
$parcel$export(module.exports, "top", () => $b4a6b12fcac25d94$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $b4a6b12fcac25d94$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $b4a6b12fcac25d94$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $b4a6b12fcac25d94$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $b4a6b12fcac25d94$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $b4a6b12fcac25d94$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $b4a6b12fcac25d94$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $b4a6b12fcac25d94$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $b4a6b12fcac25d94$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $b4a6b12fcac25d94$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $b4a6b12fcac25d94$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $b4a6b12fcac25d94$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $b4a6b12fcac25d94$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $b4a6b12fcac25d94$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $b4a6b12fcac25d94$export$d087d3878fdf71d5);
var $b4a6b12fcac25d94$export$1e95b668f3b82d = 'top';
var $b4a6b12fcac25d94$export$40e543e69a8b3fbb = 'bottom';
var $b4a6b12fcac25d94$export$79ffe56a765070d2 = 'right';
var $b4a6b12fcac25d94$export$eabcd2c8791e7bf4 = 'left';
var $b4a6b12fcac25d94$export$dfb5619354ba860 = 'auto';
var $b4a6b12fcac25d94$export$aec2ce47c367b8c3 = [
    $b4a6b12fcac25d94$export$1e95b668f3b82d,
    $b4a6b12fcac25d94$export$40e543e69a8b3fbb,
    $b4a6b12fcac25d94$export$79ffe56a765070d2,
    $b4a6b12fcac25d94$export$eabcd2c8791e7bf4
];
var $b4a6b12fcac25d94$export$b3571188c770cc5a = 'start';
var $b4a6b12fcac25d94$export$bd5df0f255a350f8 = 'end';
var $b4a6b12fcac25d94$export$390fd549c5303b4d = 'clippingParents';
var $b4a6b12fcac25d94$export$d7b7311ec04a3e8f = 'viewport';
var $b4a6b12fcac25d94$export$ae5ab1c730825774 = 'popper';
var $b4a6b12fcac25d94$export$ca50aac9f3ba507f = 'reference';
var $b4a6b12fcac25d94$export$368f9a87e87fa4e1 = /*#__PURE__*/ $b4a6b12fcac25d94$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $b4a6b12fcac25d94$export$b3571188c770cc5a,
        placement + "-" + $b4a6b12fcac25d94$export$bd5df0f255a350f8
    ]);
}, []);
var $b4a6b12fcac25d94$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($b4a6b12fcac25d94$export$aec2ce47c367b8c3, [
    $b4a6b12fcac25d94$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $b4a6b12fcac25d94$export$b3571188c770cc5a,
        placement + "-" + $b4a6b12fcac25d94$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $b4a6b12fcac25d94$export$421679a7c3d56e = 'beforeRead';
var $b4a6b12fcac25d94$export$aafa59e2e03f2942 = 'read';
var $b4a6b12fcac25d94$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $b4a6b12fcac25d94$export$c65e99957a05207c = 'beforeMain';
var $b4a6b12fcac25d94$export$f22da7240b7add18 = 'main';
var $b4a6b12fcac25d94$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $b4a6b12fcac25d94$export$8d4d2d70e7d46032 = 'beforeWrite';
var $b4a6b12fcac25d94$export$68d8715fc104d294 = 'write';
var $b4a6b12fcac25d94$export$70a6e5159acce2e6 = 'afterWrite';
var $b4a6b12fcac25d94$export$d087d3878fdf71d5 = [
    $b4a6b12fcac25d94$export$421679a7c3d56e,
    $b4a6b12fcac25d94$export$aafa59e2e03f2942,
    $b4a6b12fcac25d94$export$6964f6c886723980,
    $b4a6b12fcac25d94$export$c65e99957a05207c,
    $b4a6b12fcac25d94$export$f22da7240b7add18,
    $b4a6b12fcac25d94$export$bab79516f2d662fe,
    $b4a6b12fcac25d94$export$8d4d2d70e7d46032,
    $b4a6b12fcac25d94$export$68d8715fc104d294,
    $b4a6b12fcac25d94$export$70a6e5159acce2e6
];

});


parcelRegister("kHgo1", function(module, exports) {
$parcel$export(module.exports, "default", () => $f11488cb800dfc7d$export$2e2bcd8739ae039);
function $f11488cb800dfc7d$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("4Vc4y", function(module, exports) {
$parcel$export(module.exports, "default", () => $3955d9a8bbbeebb5$export$2e2bcd8739ae039);
function $3955d9a8bbbeebb5$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("1KSPr", function(module, exports) {
$parcel$export(module.exports, "default", () => $14749e2e8a3a113c$export$2e2bcd8739ae039);

var $35Qia = parcelRequire("35Qia");
var $14749e2e8a3a113c$var$passive = {
    passive: true
};
function $14749e2e8a3a113c$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $35Qia.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $14749e2e8a3a113c$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $14749e2e8a3a113c$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $14749e2e8a3a113c$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $14749e2e8a3a113c$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $14749e2e8a3a113c$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $14749e2e8a3a113c$var$effect,
    data: {}
};

});

parcelRegister("cHY15", function(module, exports) {
$parcel$export(module.exports, "default", () => $94080e3c54fe53cb$export$2e2bcd8739ae039);

var $d44Yz = parcelRequire("d44Yz");
function $94080e3c54fe53cb$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $d44Yz.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $94080e3c54fe53cb$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $94080e3c54fe53cb$var$popperOffsets,
    data: {}
};

});
parcelRegister("d44Yz", function(module, exports) {
$parcel$export(module.exports, "default", () => $982f82363142c0b9$export$2e2bcd8739ae039);

var $cJFBG = parcelRequire("cJFBG");

var $jpbat = parcelRequire("jpbat");

var $9LI54 = parcelRequire("9LI54");

var $fvBjg = parcelRequire("fvBjg");
function $982f82363142c0b9$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $cJFBG.default)(placement) : null;
    var variation = placement ? (0, $jpbat.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $fvBjg.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $fvBjg.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $fvBjg.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $fvBjg.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $9LI54.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $fvBjg.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $fvBjg.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("cJFBG", function(module, exports) {
$parcel$export(module.exports, "default", () => $9459f6430316d16a$export$2e2bcd8739ae039);

function $9459f6430316d16a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("jpbat", function(module, exports) {
$parcel$export(module.exports, "default", () => $e20903d83544834f$export$2e2bcd8739ae039);
function $e20903d83544834f$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("9LI54", function(module, exports) {
$parcel$export(module.exports, "default", () => $71cab2594d4e2b82$export$2e2bcd8739ae039);
function $71cab2594d4e2b82$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("kHUUW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f133f96f6dfc874d$export$2e2bcd8739ae039);

var $fvBjg = parcelRequire("fvBjg");

var $3kRx7 = parcelRequire("3kRx7");

var $35Qia = parcelRequire("35Qia");

var $9qDuy = parcelRequire("9qDuy");

var $5M0lG = parcelRequire("5M0lG");

var $cJFBG = parcelRequire("cJFBG");

var $jpbat = parcelRequire("jpbat");

var $3Kywr = parcelRequire("3Kywr");
var $f133f96f6dfc874d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $f133f96f6dfc874d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3Kywr.round)(x * dpr) / dpr || 0,
        y: (0, $3Kywr.round)(y * dpr) / dpr || 0
    };
}
function $f133f96f6dfc874d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $fvBjg.left);
    var sideY = (0, $fvBjg.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3kRx7.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $35Qia.default)(popper)) {
            offsetParent = (0, $9qDuy.default)(popper);
            if ((0, $5M0lG.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $fvBjg.top) || (placement === (0, $fvBjg.left) || placement === (0, $fvBjg.right)) && variation === (0, $fvBjg.end)) {
            sideY = (0, $fvBjg.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $fvBjg.left) || (placement === (0, $fvBjg.top) || placement === (0, $fvBjg.bottom)) && variation === (0, $fvBjg.end)) {
            sideX = (0, $fvBjg.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $f133f96f6dfc874d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $f133f96f6dfc874d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $35Qia.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $f133f96f6dfc874d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $cJFBG.default)(state.placement),
        variation: (0, $jpbat.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $f133f96f6dfc874d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $f133f96f6dfc874d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f133f96f6dfc874d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $f133f96f6dfc874d$var$computeStyles,
    data: {}
};

});

parcelRegister("cjG2E", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f77df04b613a94c$export$2e2bcd8739ae039);

var $cI546 = parcelRequire("cI546");

var $kEd3m = parcelRequire("kEd3m");
// and applies them to the HTMLElements such as popper and arrow
function $8f77df04b613a94c$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $kEd3m.isHTMLElement)(element) || !(0, $cI546.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $8f77df04b613a94c$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $kEd3m.isHTMLElement)(element) || !(0, $cI546.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $8f77df04b613a94c$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $8f77df04b613a94c$var$applyStyles,
    effect: $8f77df04b613a94c$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("i6eeB", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2d3d439b814286d$export$2e2bcd8739ae039);

var $cJFBG = parcelRequire("cJFBG");

var $fvBjg = parcelRequire("fvBjg");
function $d2d3d439b814286d$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $cJFBG.default)(placement);
    var invertDistance = [
        (0, $fvBjg.left),
        (0, $fvBjg.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $fvBjg.left),
        (0, $fvBjg.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $d2d3d439b814286d$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $fvBjg.placements).reduce(function(acc, placement) {
        acc[placement] = $d2d3d439b814286d$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d2d3d439b814286d$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $d2d3d439b814286d$var$offset
};

});

parcelRegister("cYCgi", function(module, exports) {
$parcel$export(module.exports, "default", () => $9728c49fe106cda0$export$2e2bcd8739ae039);

var $7w2dY = parcelRequire("7w2dY");

var $cJFBG = parcelRequire("cJFBG");

var $ebf47 = parcelRequire("ebf47");

var $4Woeq = parcelRequire("4Woeq");

var $8BWqp = parcelRequire("8BWqp");

var $fvBjg = parcelRequire("fvBjg");

var $jpbat = parcelRequire("jpbat");
function $9728c49fe106cda0$var$getExpandedFallbackPlacements(placement) {
    if ((0, $cJFBG.default)(placement) === (0, $fvBjg.auto)) return [];
    var oppositePlacement = (0, $7w2dY.default)(placement);
    return [
        (0, $ebf47.default)(placement),
        oppositePlacement,
        (0, $ebf47.default)(oppositePlacement)
    ];
}
function $9728c49fe106cda0$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $cJFBG.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $7w2dY.default)(preferredPlacement)
    ] : $9728c49fe106cda0$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $cJFBG.default)(placement) === (0, $fvBjg.auto) ? (0, $8BWqp.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $cJFBG.default)(placement);
        var isStartVariation = (0, $jpbat.default)(placement) === (0, $fvBjg.start);
        var isVertical = [
            (0, $fvBjg.top),
            (0, $fvBjg.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $4Woeq.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $fvBjg.right) : (0, $fvBjg.left) : isStartVariation ? (0, $fvBjg.bottom) : (0, $fvBjg.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $7w2dY.default)(mainVariationSide);
        var altVariationSide = (0, $7w2dY.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $9728c49fe106cda0$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $9728c49fe106cda0$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("7w2dY", function(module, exports) {
$parcel$export(module.exports, "default", () => $578d3f4529a2b6a7$export$2e2bcd8739ae039);
var $578d3f4529a2b6a7$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $578d3f4529a2b6a7$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $578d3f4529a2b6a7$var$hash[matched];
    });
}

});

parcelRegister("ebf47", function(module, exports) {
$parcel$export(module.exports, "default", () => $a52dc77277c85459$export$2e2bcd8739ae039);
var $a52dc77277c85459$var$hash = {
    start: 'end',
    end: 'start'
};
function $a52dc77277c85459$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $a52dc77277c85459$var$hash[matched];
    });
}

});

parcelRegister("4Woeq", function(module, exports) {
$parcel$export(module.exports, "default", () => $398f6015549ae422$export$2e2bcd8739ae039);

var $jqVi0 = parcelRequire("jqVi0");

var $9qDuy = parcelRequire("9qDuy");

var $8FF70 = parcelRequire("8FF70");

var $d44Yz = parcelRequire("d44Yz");

var $3qKE6 = parcelRequire("3qKE6");

var $fvBjg = parcelRequire("fvBjg");

var $kEd3m = parcelRequire("kEd3m");

var $iDLti = parcelRequire("iDLti");

var $2qCHQ = parcelRequire("2qCHQ");
function $398f6015549ae422$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $fvBjg.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $fvBjg.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $fvBjg.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $iDLti.default)(typeof padding !== 'number' ? padding : (0, $2qCHQ.default)(padding, (0, $fvBjg.basePlacements)));
    var altContext = elementContext === (0, $fvBjg.popper) ? (0, $fvBjg.reference) : (0, $fvBjg.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $jqVi0.default)((0, $kEd3m.isElement)(element) ? element : element.contextElement || (0, $9qDuy.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $8FF70.default)(state.elements.reference);
    var popperOffsets = (0, $d44Yz.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $3qKE6.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $fvBjg.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $fvBjg.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $fvBjg.right),
                (0, $fvBjg.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $fvBjg.top),
                (0, $fvBjg.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("jqVi0", function(module, exports) {
$parcel$export(module.exports, "default", () => $e25ce285e5969678$export$2e2bcd8739ae039);

var $fvBjg = parcelRequire("fvBjg");

var $dC8pZ = parcelRequire("dC8pZ");

var $5e4YH = parcelRequire("5e4YH");

var $jeaDx = parcelRequire("jeaDx");

var $3kRx7 = parcelRequire("3kRx7");

var $9qDuy = parcelRequire("9qDuy");

var $5M0lG = parcelRequire("5M0lG");

var $kEd3m = parcelRequire("kEd3m");

var $8FF70 = parcelRequire("8FF70");

var $ivaWs = parcelRequire("ivaWs");

var $17XrQ = parcelRequire("17XrQ");

var $cI546 = parcelRequire("cI546");

var $3qKE6 = parcelRequire("3qKE6");

var $3Kywr = parcelRequire("3Kywr");
function $e25ce285e5969678$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $8FF70.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $e25ce285e5969678$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $fvBjg.viewport) ? (0, $3qKE6.default)((0, $dC8pZ.default)(element, strategy)) : (0, $kEd3m.isElement)(clippingParent) ? $e25ce285e5969678$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $3qKE6.default)((0, $5e4YH.default)((0, $9qDuy.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $e25ce285e5969678$var$getClippingParents(element) {
    var clippingParents = (0, $jeaDx.default)((0, $ivaWs.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $5M0lG.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $kEd3m.isHTMLElement)(element) ? (0, $3kRx7.default)(element) : element;
    if (!(0, $kEd3m.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $kEd3m.isElement)(clippingParent) && (0, $17XrQ.default)(clippingParent, clipperElement) && (0, $cI546.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $e25ce285e5969678$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $e25ce285e5969678$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $e25ce285e5969678$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3Kywr.max)(rect.top, accRect.top);
        accRect.right = (0, $3Kywr.min)(rect.right, accRect.right);
        accRect.bottom = (0, $3Kywr.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3Kywr.max)(rect.left, accRect.left);
        return accRect;
    }, $e25ce285e5969678$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("dC8pZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e955aa59d92c9e0$export$2e2bcd8739ae039);

var $35Qia = parcelRequire("35Qia");

var $9qDuy = parcelRequire("9qDuy");

var $1fs2F = parcelRequire("1fs2F");

var $c9s4k = parcelRequire("c9s4k");
function $9e955aa59d92c9e0$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $35Qia.default)(element);
    var html = (0, $9qDuy.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $c9s4k.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $1fs2F.default)(element),
        y: y
    };
}

});

parcelRegister("5e4YH", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ce21f191a48b171$export$2e2bcd8739ae039);

var $9qDuy = parcelRequire("9qDuy");

var $5M0lG = parcelRequire("5M0lG");

var $1fs2F = parcelRequire("1fs2F");

var $eJdHM = parcelRequire("eJdHM");

var $3Kywr = parcelRequire("3Kywr");
function $3ce21f191a48b171$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $9qDuy.default)(element);
    var winScroll = (0, $eJdHM.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3Kywr.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3Kywr.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $1fs2F.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5M0lG.default)(body || html).direction === 'rtl') x += (0, $3Kywr.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("17XrQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d248f09e65212a8$export$2e2bcd8739ae039);

var $kEd3m = parcelRequire("kEd3m");
function $0d248f09e65212a8$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $kEd3m.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("3qKE6", function(module, exports) {
$parcel$export(module.exports, "default", () => $27f7fbb06ffb6bda$export$2e2bcd8739ae039);
function $27f7fbb06ffb6bda$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("iDLti", function(module, exports) {
$parcel$export(module.exports, "default", () => $d920b163a95c4455$export$2e2bcd8739ae039);

var $iLa5b = parcelRequire("iLa5b");
function $d920b163a95c4455$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $iLa5b.default)(), paddingObject);
}

});
parcelRegister("iLa5b", function(module, exports) {
$parcel$export(module.exports, "default", () => $da846ff3dbc34266$export$2e2bcd8739ae039);
function $da846ff3dbc34266$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("2qCHQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c4c08b77efde7ae$export$2e2bcd8739ae039);
function $1c4c08b77efde7ae$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("8BWqp", function(module, exports) {
$parcel$export(module.exports, "default", () => $644f196a19006898$export$2e2bcd8739ae039);

var $jpbat = parcelRequire("jpbat");

var $fvBjg = parcelRequire("fvBjg");

var $4Woeq = parcelRequire("4Woeq");

var $cJFBG = parcelRequire("cJFBG");
function $644f196a19006898$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $fvBjg.placements) : _options$allowedAutoP;
    var variation = (0, $jpbat.default)(placement);
    var placements = variation ? flipVariations ? (0, $fvBjg.variationPlacements) : (0, $fvBjg.variationPlacements).filter(function(placement) {
        return (0, $jpbat.default)(placement) === variation;
    }) : (0, $fvBjg.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $4Woeq.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $cJFBG.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("90Lgd", function(module, exports) {
$parcel$export(module.exports, "default", () => $68f8c61e93ab17b5$export$2e2bcd8739ae039);

var $fvBjg = parcelRequire("fvBjg");

var $cJFBG = parcelRequire("cJFBG");

var $9LI54 = parcelRequire("9LI54");

var $dyAce = parcelRequire("dyAce");

var $irJck = parcelRequire("irJck");

var $5tbj5 = parcelRequire("5tbj5");

var $3kRx7 = parcelRequire("3kRx7");

var $4Woeq = parcelRequire("4Woeq");

var $jpbat = parcelRequire("jpbat");

var $iLa5b = parcelRequire("iLa5b");

var $3Kywr = parcelRequire("3Kywr");
function $68f8c61e93ab17b5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $4Woeq.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $cJFBG.default)(state.placement);
    var variation = (0, $jpbat.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $9LI54.default)(basePlacement);
    var altAxis = (0, $dyAce.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $fvBjg.top) : (0, $fvBjg.left);
        var altSide = mainAxis === 'y' ? (0, $fvBjg.bottom) : (0, $fvBjg.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $fvBjg.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $fvBjg.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $5tbj5.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $iLa5b.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $irJck.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3kRx7.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $irJck.within)(tether ? (0, $3Kywr.min)(min, tetherMin) : min, offset, tether ? (0, $3Kywr.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $fvBjg.top) : (0, $fvBjg.left);
        var _altSide = mainAxis === 'x' ? (0, $fvBjg.bottom) : (0, $fvBjg.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $fvBjg.top),
            (0, $fvBjg.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $irJck.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $irJck.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $68f8c61e93ab17b5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $68f8c61e93ab17b5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("dyAce", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dea87306f2ebaee$export$2e2bcd8739ae039);
function $9dea87306f2ebaee$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("irJck", function(module, exports) {
$parcel$export(module.exports, "within", () => $d6ddcef18af3ef0d$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $d6ddcef18af3ef0d$export$86c8af6d3ef0b4a);

var $3Kywr = parcelRequire("3Kywr");
function $d6ddcef18af3ef0d$export$f28d906d67a997f3(min, value, max) {
    return (0, $3Kywr.max)(min, (0, $3Kywr.min)(value, max));
}
function $d6ddcef18af3ef0d$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $d6ddcef18af3ef0d$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("3oZ0c", function(module, exports) {
$parcel$export(module.exports, "default", () => $27a2eec858de3b40$export$2e2bcd8739ae039);

var $cJFBG = parcelRequire("cJFBG");

var $5tbj5 = parcelRequire("5tbj5");

var $17XrQ = parcelRequire("17XrQ");

var $3kRx7 = parcelRequire("3kRx7");

var $9LI54 = parcelRequire("9LI54");

var $irJck = parcelRequire("irJck");

var $iDLti = parcelRequire("iDLti");

var $2qCHQ = parcelRequire("2qCHQ");

var $fvBjg = parcelRequire("fvBjg");
var $27a2eec858de3b40$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $iDLti.default)(typeof padding !== 'number' ? padding : (0, $2qCHQ.default)(padding, (0, $fvBjg.basePlacements)));
};
function $27a2eec858de3b40$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $cJFBG.default)(state.placement);
    var axis = (0, $9LI54.default)(basePlacement);
    var isVertical = [
        (0, $fvBjg.left),
        (0, $fvBjg.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $27a2eec858de3b40$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $5tbj5.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $fvBjg.top) : (0, $fvBjg.left);
    var maxProp = axis === 'y' ? (0, $fvBjg.bottom) : (0, $fvBjg.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3kRx7.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $irJck.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $27a2eec858de3b40$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $17XrQ.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $27a2eec858de3b40$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $27a2eec858de3b40$var$arrow,
    effect: $27a2eec858de3b40$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("66tHb", function(module, exports) {
$parcel$export(module.exports, "default", () => $471a5686f0680317$export$2e2bcd8739ae039);

var $fvBjg = parcelRequire("fvBjg");

var $4Woeq = parcelRequire("4Woeq");
function $471a5686f0680317$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $471a5686f0680317$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $fvBjg.top),
        (0, $fvBjg.right),
        (0, $fvBjg.bottom),
        (0, $fvBjg.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $471a5686f0680317$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $4Woeq.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $4Woeq.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $471a5686f0680317$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $471a5686f0680317$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $471a5686f0680317$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $471a5686f0680317$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $471a5686f0680317$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $471a5686f0680317$var$hide
};

});




parcelRegister("eSm62", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $96316625b7ffaf3a$export$6d8c2b45c99d6e3f);
function $96316625b7ffaf3a$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
			 * Performing DOM measurements in the 'read' phase,
			 * which is the convention for popper modifiers
			 */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
			 * Applying max size CSS
			 */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                const data = state.modifiersData.maxSizeData;
                if (typeof data?.viewport?.width !== 'number' || typeof data?.viewport?.height !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = state.modifiersData?.offset?.[state.placement] ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});


parcelRegister("aide1", function(module, exports) {
$parcel$export(module.exports, "register", () => $6b847cd9691e02f7$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $4eDgu = parcelRequire("4eDgu");
const $6b847cd9691e02f7$var$registrations = new Set();
let $6b847cd9691e02f7$var$cleanupEndEventListeners = null;
function $6b847cd9691e02f7$var$onDragStart() {
    if ($6b847cd9691e02f7$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $6b847cd9691e02f7$var$cleanupEndEventListeners = (0, $4eDgu.bindAll)(window, [
        {
            type: 'dragend',
            listener: $6b847cd9691e02f7$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $6b847cd9691e02f7$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $6b847cd9691e02f7$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($6b847cd9691e02f7$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $6b847cd9691e02f7$var$onDragEnd() {
    $6b847cd9691e02f7$var$cleanupEndEventListeners?.();
    $6b847cd9691e02f7$var$cleanupEndEventListeners = null;
    const clone = Array.from($6b847cd9691e02f7$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $6b847cd9691e02f7$var$bindStartEvents() {
    return (0, $4eDgu.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $6b847cd9691e02f7$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $6b847cd9691e02f7$var$onDragStart
        }
    ]);
}
let $6b847cd9691e02f7$var$cleanupStartEventListeners = null;
function $6b847cd9691e02f7$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$6b847cd9691e02f7$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $6b847cd9691e02f7$var$cleanupStartEventListeners = $6b847cd9691e02f7$var$bindStartEvents();
    $6b847cd9691e02f7$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $6b847cd9691e02f7$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $6b847cd9691e02f7$var$registrations.delete(registration);
        if ($6b847cd9691e02f7$var$registrations.size === 0) {
            $6b847cd9691e02f7$var$cleanupStartEventListeners?.();
            $6b847cd9691e02f7$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("8hVap", function(module, exports) {
$parcel$export(module.exports, "show", () => $031f9bbb215a658e$export$57bf213be019eeb0);

var $6Pu2S = parcelRequire("6Pu2S");
let $031f9bbb215a658e$var$active = null;
function $031f9bbb215a658e$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($031f9bbb215a658e$var$active && $031f9bbb215a658e$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $6Pu2S.clearScheduled)();
            $031f9bbb215a658e$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $6Pu2S.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $6Pu2S.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $6Pu2S.scheduleTimeout)(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        const showImmediately = Boolean($031f9bbb215a658e$var$active && $031f9bbb215a658e$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($031f9bbb215a658e$var$active) {
            (0, $6Pu2S.clearScheduled)();
            $031f9bbb215a658e$var$active.entry.hide({
                isImmediate: true
            });
            $031f9bbb215a658e$var$active.entry.done();
            $031f9bbb215a658e$var$active = null;
        }
        // this tooltip is now the active tooltip
        $031f9bbb215a658e$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $6Pu2S.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("6Pu2S", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", () => $a7de87841d2eb90a$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $a7de87841d2eb90a$export$5f4d6617421d489b);
let $a7de87841d2eb90a$var$delayId = null;
function $a7de87841d2eb90a$export$eaf678f6f93f5250() {
    if ($a7de87841d2eb90a$var$delayId != null) {
        window.clearTimeout($a7de87841d2eb90a$var$delayId);
        $a7de87841d2eb90a$var$delayId = null;
    }
}
function $a7de87841d2eb90a$export$5f4d6617421d489b(fn, delay) {
    $a7de87841d2eb90a$export$eaf678f6f93f5250();
    $a7de87841d2eb90a$var$delayId = window.setTimeout(()=>{
        $a7de87841d2eb90a$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("bfK28", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5095560fc82234f$export$2e2bcd8739ae039);

var $gl2vi = parcelRequire("gl2vi");
function $d5095560fc82234f$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $gl2vi.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("gl2vi", function(module, exports) {
$parcel$export(module.exports, "useId", () => $c75ba6c4b576f5f1$export$f680877a34711e37);
$parcel$export(module.exports, "IdProvider", () => $c75ba6c4b576f5f1$export$6be90bcb437e928f);
$parcel$export(module.exports, "useIdSeed", () => $c75ba6c4b576f5f1$export$6ee17796e3d70de2);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $o0Fzr = parcelRequire("o0Fzr");

var $eGOwo = parcelRequire("eGOwo");
// @ts-ignore - useId is not accessible in React 16
const $c75ba6c4b576f5f1$var$react18UseId = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useId ?? undefined;
function $c75ba6c4b576f5f1$export$f680877a34711e37() {
    if ($c75ba6c4b576f5f1$var$react18UseId && (0, $eGOwo.fg)('platform-dst-react-18-use-id')) {
        if ((0, $eGOwo.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $c75ba6c4b576f5f1$var$react18UseId().replace(/[:«»]/g, '_');
        return $c75ba6c4b576f5f1$var$react18UseId();
    }
    return `uid${(0, $o0Fzr.useUID)()}`;
}
const $c75ba6c4b576f5f1$export$6be90bcb437e928f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${$c75ba6c4b576f5f1$export$f680877a34711e37()}${postfix}`;
    (0, $eJOHy.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
function $c75ba6c4b576f5f1$export$6ee17796e3d70de2() {
    if ($c75ba6c4b576f5f1$var$react18UseId && (0, $eGOwo.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        const uid = $c75ba6c4b576f5f1$export$f680877a34711e37();
        return (id)=>`${uid}-${id.toString()}`;
    }
    return (0, $o0Fzr.useUIDSeed)();
}

});


parcelRegister("39kdz", function(module, exports) {
$parcel$export(module.exports, "default", () => $687d79b4d0ff1951$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7AseU = parcelRequire("7AseU");
const $687d79b4d0ff1951$var$styles = {
    base: "_2rkofajl _11c8dcr7 _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $687d79b4d0ff1951$var$TooltipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7AseU.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            $687d79b4d0ff1951$var$styles.base,
            truncate && $687d79b4d0ff1951$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        children: children
    });
});
$687d79b4d0ff1951$var$TooltipContainer.displayName = 'TooltipContainer';
var $687d79b4d0ff1951$export$2e2bcd8739ae039 = $687d79b4d0ff1951$var$TooltipContainer;

});
parcelRegister("7AseU", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9773d4e4ed7f8bd$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $617Zj = parcelRequire("617Zj");
const $c9773d4e4ed7f8bd$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ const $c9773d4e4ed7f8bd$var$TooltipPrimitive = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            role: "tooltip",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $hcewu.default)([
                "_80om73ad",
                className
            ]),
            // Because the tooltip should not be focusable, there is no reason to have key events.
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
            "data-placement": placement,
            "data-testid": testId,
            id: id,
            children: [
                children,
                shortcut && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $617Zj.TooltipShortcut), {
                    shortcut: shortcut
                })
            ]
        })
    });
});
$c9773d4e4ed7f8bd$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $c9773d4e4ed7f8bd$export$2e2bcd8739ae039 = $c9773d4e4ed7f8bd$var$TooltipPrimitive;

});
parcelRegister("617Zj", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $55e9236e5b1fc7e5$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $55e9236e5b1fc7e5$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c81u0j _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
const $55e9236e5b1fc7e5$export$5bcbc43c84236222 = ({ shortcut: shortcut })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $55e9236e5b1fc7e5$var$styles.shortcutSegmentsContainer
        ]),
        children: shortcut.map((segment, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)("kbd", {
                className: (0, $hcewu.default)([
                    $55e9236e5b1fc7e5$var$styles.shortcutSegment
                ]),
                children: segment
            }, `${segment}-${index}`))
    });
};

});



parcelRegister("02Gft", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", () => $a4a98caf042161c0$export$642213d516a9b928);
function $a4a98caf042161c0$export$642213d516a9b928(mouseCoordinates) {
    const safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    const getBoundingClientRect = ()=>({
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        });
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("linPv", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd271f8cc2d41144$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $gyJTO = parcelRequire("gyJTO");

var $jTslB = parcelRequire("jTslB");

var $gl2vi = parcelRequire("gl2vi");

var $46R8N = parcelRequire("46R8N");

var $6fs4r = parcelRequire("6fs4r");

var $k51XY = parcelRequire("k51XY");

var $3dfFi = parcelRequire("3dfFi");

var $3BYEp = parcelRequire("3BYEp");
const $fd271f8cc2d41144$var$LOADING_LABEL = ', Loading';
const $fd271f8cc2d41144$var$styles = {
    base: "_2rkofajl _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu18uv _1hmsglyw _ajmmnqa1 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk1caa _irr31caa _1di61caa",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhk1w7a _y4ti12x7 _bozg12x7"
};
const $fd271f8cc2d41144$var$defaultStyles = {
    root: "_bfhk1w7a _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk18uv _8l3mbk0g _irr318uv _1di618uv"
};
const $fd271f8cc2d41144$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
const $fd271f8cc2d41144$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
const $fd271f8cc2d41144$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
const $fd271f8cc2d41144$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
const $fd271f8cc2d41144$var$subtleStyles = {
    root: "_bfhk1w7a _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr34mfv _30l3azsu _1di619qy _9h8hazsu",
    disabled: "_bfhk18uv _8l3mbk0g _irr318uv _1di618uv"
};
const $fd271f8cc2d41144$var$selectedStyles = {
    root: "_bfhk15s3 _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $fd271f8cc2d41144$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    const localRef = (0, $eJOHy.useRef)(null);
    const splitButtonContext = (0, $k51XY.useSplitButtonContext)();
    const loadingLabelId = (0, $gl2vi.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $jTslB.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $gyJTO.default)([
            localRef,
            ref
        ]),
        xcss: (0, $6qaBj.cx)($fd271f8cc2d41144$var$styles.base, appearance === 'default' && $fd271f8cc2d41144$var$defaultStyles.root, appearance === 'default' && isInteractive && $fd271f8cc2d41144$var$defaultStyles.interactive, appearance === 'primary' && $fd271f8cc2d41144$var$primaryStyles.root, appearance === 'primary' && isInteractive && $fd271f8cc2d41144$var$primaryStyles.interactive, appearance === 'warning' && $fd271f8cc2d41144$var$warningStyles.root, appearance === 'warning' && isInteractive && $fd271f8cc2d41144$var$warningStyles.interactive, appearance === 'danger' && $fd271f8cc2d41144$var$dangerStyles.root, appearance === 'danger' && isInteractive && $fd271f8cc2d41144$var$dangerStyles.interactive, appearance === 'discovery' && $fd271f8cc2d41144$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $fd271f8cc2d41144$var$discoveryStyles.interactive, appearance === 'subtle' && $fd271f8cc2d41144$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $fd271f8cc2d41144$var$subtleStyles.interactive, $fd271f8cc2d41144$var$styles.linkDecorationUnset, isSelected && $fd271f8cc2d41144$var$selectedStyles.root, isSelected && isSplitButton && $fd271f8cc2d41144$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $fd271f8cc2d41144$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $fd271f8cc2d41144$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $fd271f8cc2d41144$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $fd271f8cc2d41144$var$selectedStyles.discovery, isDisabled && $fd271f8cc2d41144$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $fd271f8cc2d41144$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $fd271f8cc2d41144$var$defaultStyles.disabled, isCircle && !isSplitButton && $fd271f8cc2d41144$var$styles.circle, spacing === 'compact' && $fd271f8cc2d41144$var$styles.spacingCompact, hasIconBefore && $fd271f8cc2d41144$var$styles.buttonIconBefore, shouldFitContainer && $fd271f8cc2d41144$var$styles.fullWidth, hasIconAfter && $fd271f8cc2d41144$var$styles.buttonIconAfter, isIconButton && $fd271f8cc2d41144$var$styles.iconButton, isIconButton && spacing === 'compact' && $fd271f8cc2d41144$var$styles.iconButtonCompact, isLoading && $fd271f8cc2d41144$var$styles.loading, isSplitButton && $fd271f8cc2d41144$var$styles.splitButton, isNavigationSplitButton && $fd271f8cc2d41144$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$fd271f8cc2d41144$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $3dfFi.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $k51XY.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    className: (0, $hcewu.default)([
                        $fd271f8cc2d41144$var$styles.loadingOverlay
                    ]),
                    children: (0, $3BYEp.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                    id: loadingLabelId,
                    children: $fd271f8cc2d41144$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $fd271f8cc2d41144$export$2e2bcd8739ae039 = $fd271f8cc2d41144$var$ButtonBase;

});
parcelRegister("46R8N", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d1e4ffac038317b$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $jrFnt = parcelRequire("jrFnt");

var $8ffYo = parcelRequire("8ffYo");

var $3Vuhz = parcelRequire("3Vuhz");

var $d0Gew = parcelRequire("d0Gew");

var $g6Dmv = parcelRequire("g6Dmv");
const $4d1e4ffac038317b$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $4d1e4ffac038317b$var$Pressable = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $3Vuhz.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $eJOHy.useContext)((0, $d0Gew.default));
    const handleClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g6Dmv.default // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button" // Safari does not apply focus to buttons on click like other browsers, which means click events will not be fired.
        ,
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $8ffYo.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $k0ahr.cx)($4d1e4ffac038317b$var$styles.root, isDisabled && $4d1e4ffac038317b$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});
var $4d1e4ffac038317b$export$2e2bcd8739ae039 = $4d1e4ffac038317b$var$Pressable;

});
parcelRegister("8ffYo", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $524d0c1db2c04ba1$export$95df08bae54cb4df);
$parcel$export(module.exports, "isAppleDevice", () => $524d0c1db2c04ba1$export$e1865c3bedcd822b);
function $524d0c1db2c04ba1$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $524d0c1db2c04ba1$var$isIPhone() {
    return $524d0c1db2c04ba1$var$testPlatform(/^iPhone/i);
}
function $524d0c1db2c04ba1$var$isMac() {
    return $524d0c1db2c04ba1$var$testPlatform(/^Mac/i);
}
function $524d0c1db2c04ba1$var$isIPad() {
    return $524d0c1db2c04ba1$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $524d0c1db2c04ba1$var$isMac() && navigator.maxTouchPoints > 1;
}
function $524d0c1db2c04ba1$var$isIOS() {
    return $524d0c1db2c04ba1$var$isIPhone() || $524d0c1db2c04ba1$var$isIPad();
}
function $524d0c1db2c04ba1$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $524d0c1db2c04ba1$export$e1865c3bedcd822b() {
    return $524d0c1db2c04ba1$var$isMac() || $524d0c1db2c04ba1$var$isIOS();
}

});

parcelRegister("g6Dmv", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf4275472e5464ae$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bf4275472e5464ae$var$focusRingStyles = null;
const $bf4275472e5464ae$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ const $bf4275472e5464ae$var$Focusable = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        ...safeHtmlAttributes,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $hcewu.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "data-testid": testId,
        children: children
    });
});
var $bf4275472e5464ae$export$2e2bcd8739ae039 = $bf4275472e5464ae$var$Focusable;

});


parcelRegister("k51XY", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $615b432f3a624703$export$4b86304b2c0d7e71);
$parcel$export(module.exports, "useSplitButtonContext", () => $615b432f3a624703$export$47e2c6fdb142d947);

var $eJOHy = parcelRequire("eJOHy");
const $615b432f3a624703$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $615b432f3a624703$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $eJOHy.useContext)($615b432f3a624703$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("3dfFi", function(module, exports) {
$parcel$export(module.exports, "default", () => $676196ecd8434910$export$2e2bcd8739ae039);
function $676196ecd8434910$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $676196ecd8434910$var$tabKeyCode = 9;
function $676196ecd8434910$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $676196ecd8434910$var$tabKeyCode) return;
    $676196ecd8434910$var$abort(event);
}
function $676196ecd8434910$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $676196ecd8434910$var$abort,
        onMouseUpCapture: $676196ecd8434910$var$abort,
        onKeyDownCapture: $676196ecd8434910$var$onKey,
        onKeyUpCapture: $676196ecd8434910$var$onKey,
        onTouchStartCapture: $676196ecd8434910$var$abort,
        onTouchEndCapture: $676196ecd8434910$var$abort,
        onPointerDownCapture: $676196ecd8434910$var$abort,
        onPointerUpCapture: $676196ecd8434910$var$abort,
        onClickCapture: $676196ecd8434910$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $676196ecd8434910$var$abort
    } : events;
}

});

parcelRegister("3BYEp", function(module, exports) {
$parcel$export(module.exports, "default", () => $c084b5e0fa42f252$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");
function $c084b5e0fa42f252$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $c084b5e0fa42f252$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $c084b5e0fa42f252$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
        size: $c084b5e0fa42f252$var$getIconSpacing(spacing),
        appearance: $c084b5e0fa42f252$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("9fToX", function(module, exports) {
$parcel$export(module.exports, "default", () => $589f5a3dde03da9d$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $589f5a3dde03da9d$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $589f5a3dde03da9d$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading, position: position })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            $589f5a3dde03da9d$var$styles.common,
            type === 'text' && $589f5a3dde03da9d$var$styles.text,
            type === 'icon' && $589f5a3dde03da9d$var$styles.icon,
            isLoading && $589f5a3dde03da9d$var$styles.fade,
            position === 'before' && $589f5a3dde03da9d$var$styles.beforeIcon,
            position === 'after' && $589f5a3dde03da9d$var$styles.afterIcon
        ]),
        children: children
    });
};
var $589f5a3dde03da9d$export$2e2bcd8739ae039 = $589f5a3dde03da9d$var$Content;

});

parcelRegister("2RUos", function(module, exports) {
$parcel$export(module.exports, "default", () => $13d71358e852850f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
function $13d71358e852850f$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $13d71358e852850f$var$IconRenderer = ({ icon: Icon })=>{
    const isRenderProp = $13d71358e852850f$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $eGOwo.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            ...iconProps
        })
    });
};
var $13d71358e852850f$export$2e2bcd8739ae039 = $13d71358e852850f$var$IconRenderer;

});



parcelRegister("hq2lE", function(module, exports) {
$parcel$export(module.exports, "default", () => $22f4af540c5a502a$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $Ys7jv = parcelRequire("Ys7jv");
var $2rPSy = parcelRequire("2rPSy");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
const $22f4af540c5a502a$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
const $22f4af540c5a502a$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $22f4af540c5a502a$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ys7jv.default), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2rPSy.default), {
                children: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        xcss: $22f4af540c5a502a$var$styles.container,
                        ...props,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
                            space: "space.100",
                            children: children
                        })
                    })
            })
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$22f4af540c5a502a$export$2e2bcd8739ae039 = $22f4af540c5a502a$var$Expander;

});


parcelRegister("1jLQ3", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c3aa4d6b4377989$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $h0TP6 = parcelRequire("h0TP6");

var $gPCVG = parcelRequire("gPCVG");
const $0c3aa4d6b4377989$var$packageName = "platform-pkg";
const $0c3aa4d6b4377989$var$packageVersion = "0.0.0-use.local";
const $0c3aa4d6b4377989$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $0c3aa4d6b4377989$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $3Vuhz.default) } = props;
    const autoDismissTimer = (0, $eJOHy.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $gPCVG.useFlagGroup)();
    const onDismissed = (0, $eJOHy.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $0c3aa4d6b4377989$var$packageName,
        packageVersion: $0c3aa4d6b4377989$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $eJOHy.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $eJOHy.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $eJOHy.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $0c3aa4d6b4377989$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $eJOHy.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h0TP6.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $0c3aa4d6b4377989$export$2e2bcd8739ae039 = $0c3aa4d6b4377989$var$AutoDismissFlag;

});

parcelRegister("101p7", function(module, exports) {
$parcel$export(module.exports, "useFlags", () => $0db1fe3db3ac8335$export$2879604e6aec4ab);
$parcel$export(module.exports, "FlagsProvider", () => $0db1fe3db3ac8335$export$a4270ab432ac8a58);
$parcel$export(module.exports, "withFlagsProvider", () => $0db1fe3db3ac8335$export$7b676815c264eaf3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1jLQ3 = parcelRequire("1jLQ3");

var $h0TP6 = parcelRequire("h0TP6");

var $gPCVG = parcelRequire("gPCVG");
const $0db1fe3db3ac8335$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(null);
function $0db1fe3db3ac8335$export$2879604e6aec4ab() {
    const api = (0, $eJOHy.useContext)($0db1fe3db3ac8335$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $0db1fe3db3ac8335$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $0db1fe3db3ac8335$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $eJOHy.useState)([]);
    const removeFlag = (0, $eJOHy.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $eJOHy.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $0db1fe3db3ac8335$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($0db1fe3db3ac8335$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPCVG.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $1jLQ3.default) : (0, $h0TP6.default);
                    return /*#__PURE__*/ (0, $eJOHy.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $0db1fe3db3ac8335$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $gt9Am.jsx)($0db1fe3db3ac8335$export$a4270ab432ac8a58, {
        children: fn()
    });

});


parcelRegister("ig36w", function(module, exports) {
$parcel$export(module.exports, "Popper", () => (parcelRequire("8qmYl")).Popper);
$parcel$export(module.exports, "placements", () => (parcelRequire("fvBjg")).placements);
$parcel$export(module.exports, "Manager", () => (parcelRequire("6G5P1")).Manager);
$parcel$export(module.exports, "Reference", () => (parcelRequire("azjc1")).Reference);

var $fvBjg = parcelRequire("fvBjg");
var $8qmYl = parcelRequire("8qmYl");

var $6G5P1 = parcelRequire("6G5P1");
var $azjc1 = parcelRequire("azjc1");

});
parcelRegister("azjc1", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $7b1c0f954e621480$export$e0be378c32fb70a7);

var $eJOHy = parcelRequire("eJOHy");

var $9Hk5t = parcelRequire("9Hk5t");

var $6G5P1 = parcelRequire("6G5P1");

var $hBwkR = parcelRequire("hBwkR");
function $7b1c0f954e621480$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eJOHy.useContext((0, $6G5P1.ManagerReferenceNodeSetterContext));
    var refHandler = $eJOHy.useCallback(function(node) {
        (0, $hBwkR.setRef)(innerRef, node);
        (0, $hBwkR.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eJOHy.useEffect(function() {
        return function() {
            return (0, $hBwkR.setRef)(innerRef, null);
        };
    }, []);
    $eJOHy.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9Hk5t)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $hBwkR.unwrapArray)(children)({
        ref: refHandler
    });
}

});


parcelRegister("4J0ad", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9ebf301d90379f4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $ixE4q = parcelRequire("ixE4q");
const $e9ebf301d90379f4$var$withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            const { patchedEventProps: patchedEventProps } = (0, $ixE4q.usePatchedProps)(createEventMap, props);
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                ...props,
                ...patchedEventProps,
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            });
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
var $e9ebf301d90379f4$export$2e2bcd8739ae039 = $e9ebf301d90379f4$var$withAnalyticsEvents;

});
parcelRegister("ixE4q", function(module, exports) {
$parcel$export(module.exports, "usePatchedProps", () => $f2a9dd8b0cd9fb89$export$9ebb5a84d17e5d18);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");
function $f2a9dd8b0cd9fb89$export$9ebb5a84d17e5d18(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handlerCache = (0, $eJOHy.useRef)({});
    const patchedProps = (0, $eJOHy.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return {
                ...p,
                [k]: cache[k].wrappedCallback
            };
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return {
                ...p,
                [k]: wrappedCallback
            };
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("goZPP", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddb2c28837e86a18$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $kUDZ7 = parcelRequire("kUDZ7");

var $guzrQ = parcelRequire("guzrQ");

var $dtCDi = parcelRequire("dtCDi");

var $5xD8j = parcelRequire("5xD8j");
const $ddb2c28837e86a18$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $ddb2c28837e86a18$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $3Vuhz.default), onMouseUp: providedOnMouseUp = (0, $3Vuhz.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const { mode: mode } = (0, $kUDZ7.useGlobalTheme)();
    const isOnlySingleIcon = (0, $5xD8j.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $eJOHy.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    const onMouseDown = (0, $eJOHy.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($ddb2c28837e86a18$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $eJOHy.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($ddb2c28837e86a18$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $eJOHy.useMemo)(()=>(0, $dtCDi.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $guzrQ.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        //  manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$ddb2c28837e86a18$var$Button.displayName = 'Button';
var $ddb2c28837e86a18$export$2e2bcd8739ae039 = $ddb2c28837e86a18$var$Button;

});

parcelRegister("3cMgR", function(module, exports) {
$parcel$export(module.exports, "default", () => $24a8c060965c4e9a$export$2e2bcd8739ae039);
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GOss = parcelRequire("8GOss");

var $6ItDa = parcelRequire("6ItDa");

var $1yiB6 = parcelRequire("1yiB6");
const $24a8c060965c4e9a$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $24a8c060965c4e9a$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $1yiB6.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($24a8c060965c4e9a$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $24a8c060965c4e9a$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
const $24a8c060965c4e9a$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pmoej",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $24a8c060965c4e9a$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
const $24a8c060965c4e9a$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $24a8c060965c4e9a$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
const $24a8c060965c4e9a$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $24a8c060965c4e9a$var$Text = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $8GOss.default)($24a8c060965c4e9a$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $6ItDa.useHasTextAncestor)();
    const color = $24a8c060965c4e9a$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        className: (0, $hcewu.default)([
            $24a8c060965c4e9a$var$styles.root,
            size && $24a8c060965c4e9a$var$fontSizeMap[size],
            color && $24a8c060965c4e9a$var$textColorMap[color],
            maxLines && $24a8c060965c4e9a$var$styles.truncation,
            maxLines === 1 && $24a8c060965c4e9a$var$styles.breakAll,
            align && $24a8c060965c4e9a$var$styles[`textAlign.${align}`],
            weight && $24a8c060965c4e9a$var$fontWeightMap[weight],
            Component === 'em' && $24a8c060965c4e9a$var$styles['as.em'],
            Component === 'strong' && $24a8c060965c4e9a$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6ItDa.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});
var $24a8c060965c4e9a$export$2e2bcd8739ae039 = $24a8c060965c4e9a$var$Text;

});
parcelRegister("6ItDa", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $feda7fd5da1502cc$export$9322276ec105d055);
$parcel$export(module.exports, "HasTextAncestorProvider", () => $feda7fd5da1502cc$export$ae933c6cbe5643ad);

var $eJOHy = parcelRequire("eJOHy");
const $feda7fd5da1502cc$var$HasTextAncestorContext = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $feda7fd5da1502cc$export$9322276ec105d055 = ()=>(0, $eJOHy.useContext)($feda7fd5da1502cc$var$HasTextAncestorContext);
const $feda7fd5da1502cc$export$ae933c6cbe5643ad = $feda7fd5da1502cc$var$HasTextAncestorContext.Provider;

});


parcelRegister("48q59", function(module, exports) {
$parcel$export(module.exports, "default", () => $b82487cc219afcd3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");
function $b82487cc219afcd3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b82487cc219afcd3$var$buttonGroupStyles = {
    name: "1oy5iav",
    styles: "display:inline-flex;gap:var(--ds-space-050, 4px);> *{flex:1 0 auto;}"
};
function $b82487cc219afcd3$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $b82487cc219afcd3$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), {
            key: idx
        }, child);
    }));
}

});

parcelRegister("dUaMU", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b7a9365cf3634ac$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");
const $7b7a9365cf3634ac$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $eJOHy.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
                data: analyticsData,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                    ...rest,
                    ref: ref
                })
            });
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $7b7a9365cf3634ac$export$2e2bcd8739ae039 = $7b7a9365cf3634ac$var$withAnalyticsContext;

});

parcelRegister("6MnLl", function(module, exports) {
$parcel$export(module.exports, "default", () => $af767092691e0e0e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $48q59 = parcelRequire("48q59");

var $806LH = parcelRequire("806LH");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $7ep4S = parcelRequire("7ep4S");

var $9Ixd3 = parcelRequire("9Ixd3");
var $fdapa = parcelRequire("fdapa");
var $1H15y = parcelRequire("1H15y");
var $hQhLt = parcelRequire("hQhLt");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $af767092691e0e0e$var$EmptyState = ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, headingSize: headingSize = 'medium', imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9Ixd3.default), {
        children: [
            primaryAction && secondaryAction ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $48q59.default), {
                label: buttonGroupLabel || 'Button group',
                testId: testId && `${testId}-button-group`,
                children: [
                    secondaryAction,
                    primaryAction
                ]
            }) : primaryAction || secondaryAction,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hQhLt.default), {
                children: isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                    testId: "empty-state-spinner"
                })
            })
        ]
    }) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fdapa.default), {
        testId: testId,
        width: width || 'wide',
        children: [
            imageUrl ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1H15y.default), {
                src: imageUrl,
                maxWidth: maxImageWidth,
                maxHeight: maxImageHeight,
                width: imageWidth,
                height: imageHeight
            }) : renderImage && renderImage({
                maxImageWidth: maxImageWidth,
                maxImageHeight: maxImageHeight,
                imageWidth: imageWidth,
                imageHeight: imageHeight
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                paddingBlockEnd: "space.200",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                    size: headingSize,
                    as: tag,
                    children: header
                })
            }),
            description && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                paddingBlockEnd: "space.300",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    as: "p",
                    children: description
                })
            }),
            actionsContainer,
            tertiaryAction
        ]
    });
};
var $af767092691e0e0e$export$2e2bcd8739ae039 = $af767092691e0e0e$var$EmptyState;

});
parcelRegister("9Ixd3", function(module, exports) {
$parcel$export(module.exports, "default", () => $8491475dc5e2cf30$export$2e2bcd8739ae039);
/* actions-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $8491475dc5e2cf30$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ const $8491475dc5e2cf30$var$ActionsContainer = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ]),
        children: children
    });
var $8491475dc5e2cf30$export$2e2bcd8739ae039 = $8491475dc5e2cf30$var$ActionsContainer;

});

parcelRegister("fdapa", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4e292cd49eef878$export$2e2bcd8739ae039);
/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f4e292cd49eef878$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ const $f4e292cd49eef878$var$wideContainerStyles = null;
const $f4e292cd49eef878$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ const $f4e292cd49eef878$var$Container = ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ]),
        children: children
    });
var $f4e292cd49eef878$export$2e2bcd8739ae039 = $f4e292cd49eef878$var$Container;

});

parcelRegister("1H15y", function(module, exports) {
$parcel$export(module.exports, "default", () => $e13691990977afe9$export$2e2bcd8739ae039);
/* image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $e13691990977afe9$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $e13691990977afe9$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $e13691990977afe9$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ const $e13691990977afe9$var$Image = ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        style: {
            [$e13691990977afe9$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$e13691990977afe9$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $hcewu.default)([
            "_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ])
    });
var $e13691990977afe9$export$2e2bcd8739ae039 = $e13691990977afe9$var$Image;

});

parcelRegister("hQhLt", function(module, exports) {
$parcel$export(module.exports, "default", () => $3dae217797993aa8$export$2e2bcd8739ae039);
/* spinner-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3dae217797993aa8$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ const $3dae217797993aa8$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1bsb1ejb _ahbqpxbi"
        ]),
        children: children
    });
var $3dae217797993aa8$export$2e2bcd8739ae039 = $3dae217797993aa8$var$SpinnerContainer;

});


parcelRegister("5fWw9", function(module, exports) {
$parcel$export(module.exports, "default", () => $472bb4a1cf62ecb3$export$2e2bcd8739ae039);
var $472bb4a1cf62ecb3$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("cA0Y2", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c0c1a796b03ab01$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $2re7G = parcelRequire("2re7G");
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $8c0c1a796b03ab01$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2re7G.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$8c0c1a796b03ab01$var$LoadingButton.displayName = 'LoadingButton';
var $8c0c1a796b03ab01$export$2e2bcd8739ae039 = $8c0c1a796b03ab01$var$LoadingButton;

});

parcelRegister("cc8Bd", function(module, exports) {
$parcel$export(module.exports, "fontFallback", () => $f9f364208e47f527$export$2a99220fb32ec798);
/**
 * Font token fallbacks are verbose.
 * This object exists purely to make using fallbacks less cumbersome while we still need to use them.
 * Will be removed once fallbacks are no longer needed.
 *
 * This is referenced by the use-tokens-typography ESLint rule.
 */ const $f9f364208e47f527$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    }
};

});

parcelRegister("315a7", function(module, exports) {
$parcel$export(module.exports, "useCallbackWithAnalytics", () => $e6f0e92c09070fb5$export$53c2b9c37c40e0d8);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $gAkni = parcelRequire("gAkni");
const $e6f0e92c09070fb5$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const methodRef = (0, $gAkni.useTrackedRef)(method);
    const payloadRef = (0, $gAkni.useTrackedRef)(payload);
    return (0, $eJOHy.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("5jAEx", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a326b2cbbc9ec29$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $csmow = parcelRequire("csmow");
class $0a326b2cbbc9ec29$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { data: data, children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError) {
            if (ErrorComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $csmow.default), {
                data: data,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(ErrorComponent, {})
            });
            return null;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $csmow.default), {
            data: data,
            children: children
        });
    }
}

});

const $c9cb1b3997607889$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $c9cb1b3997607889$export$f005e2e9f707cb5f = 'commercial';
const $c9cb1b3997607889$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $c9cb1b3997607889$export$a739cd5aac835909 = 'stg';
const $c9cb1b3997607889$export$42dd0cdd351a4a9 = 'prod';
const $c9cb1b3997607889$export$404582bc18fe4d9e = 'dev';

const $54dbbe6dc88f8bd2$export$42f4885608027d0c = 'non_boolean';

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

const $652f5f63189f3e2a$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $652f5f63189f3e2a$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $652f5f63189f3e2a$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $652f5f63189f3e2a$export$b2c0462ff17aa26e = 'BUSINESS_BOARD';
const $652f5f63189f3e2a$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $652f5f63189f3e2a$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $652f5f63189f3e2a$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $652f5f63189f3e2a$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $652f5f63189f3e2a$export$4695c1a423ffe431 = 'DASHBOARD';
const $652f5f63189f3e2a$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $652f5f63189f3e2a$export$9a80695e72849f84 = 'X-Atlassian-Capability';

// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

const $3a6f6559ec260003$export$881d135f98d8d7d0 = 100;
const $3a6f6559ec260003$export$9ab5bdcb8a1d6c34 = false;
const $3a6f6559ec260003$export$f267d0e9ab3eb265 = false;
const $3a6f6559ec260003$export$12c1dc38ea1692da = 0;
const $3a6f6559ec260003$export$c6d9b82b8528dcc3 = false;

const $71feb0ebe2f021d7$export$cf090d5281b5ae06 = 10000;
const $71feb0ebe2f021d7$export$8575e30be0feb909 = 30000;

const $10b5883439ef237e$export$3288b14b6745c572 = 204;
const $10b5883439ef237e$export$c09e7ea0fc79f34f = 409;
const $10b5883439ef237e$export$974c37534b0191b1 = 503;


$parcel$global.rlb("kNFvF")
//# sourceMappingURL=shared~vendor~atlaskit~ar.8e9addd2.js.map
